import { jsx as W, jsxs as Qe, Fragment as en } from "react/jsx-runtime";
import He, { useContext as We, useMemo as tn, useState as ke, useEffect as Me, useCallback as rn, Component as ii } from "react";
import { Modal as oi, Paragraph as Tr, Link as si, H3 as ai, H2 as Mr, Button as ui, Spinner as ci, ApplicationLayout as li, Currency as pi } from "@increasecard/typed-components";
import nn from "styled-components";
import { HelpIcon as di, WarningCircleIcon as fi } from "@increasecard/icons";
const hi = {
  authUrl: "http://localhost:4444",
  blogUrl: "https://increase.app/blog",
  contactUrl: "https://soporte.increasecard.com/hc/es/requests/new?ticket_form_id=360003356153",
  platformUrl: "http://localhost:3000",
  gatewayUrl: "http://localhost:3000",
  supportUrl: "https://soporte.increasecard.com/hc/es",
  landingUrl: "https://increase.app",
  productName: "platform",
  environment: "development",
  whatsappUrl: "https://api.whatsapp.com/send/?phone=541150365046&text&app_absent=0"
}, on = {
  production: {
    authUrl: "https://auth.increase.app",
    platformUrl: "https://platform.increase.app",
    gatewayUrl: "https://gateway.increase.app",
    blogUrl: "https://increase.app/blog",
    contactUrl: "https://platform.increase.app/support",
    supportUrl: "https://increase-app.notion.site/increase-app/0672da0ca4da408884e5028a9e029cc5?v=028b29fa6cb14f2ab12146599378a2b5",
    landingUrl: "https://increase.app",
    productName: "platform",
    environment: "production",
    whatsappUrl: "https://api.whatsapp.com/send/?phone=541150365046&text&app_absent=0"
  },
  staging: {
    authUrl: "https://auth.staging.increase.app",
    platformUrl: "https://platform.staging.increase.app",
    gatewayUrl: "https://gateway.staging.increase.app",
    blogUrl: "https://increase.app/blog",
    contactUrl: "https://platform.increase.app/support",
    supportUrl: "https://increase-app.notion.site/increase-app/0672da0ca4da408884e5028a9e029cc5?v=028b29fa6cb14f2ab12146599378a2b5",
    landingUrl: "https://staging.increase.app",
    productName: "platform",
    environment: "staging",
    whatsappUrl: "https://api.whatsapp.com/send/?phone=541150365046&text&app_absent=0"
  },
  playground: {
    authUrl: "https://auth.playground.increase.app",
    platformUrl: "https://platform.playground.increase.app",
    gatewayUrl: "https://gateway.playground.increase.app",
    blogUrl: "https://increase.app/blog",
    contactUrl: "https://platform.increase.app/support",
    supportUrl: "https://increase-app.notion.site/increase-app/0672da0ca4da408884e5028a9e029cc5?v=028b29fa6cb14f2ab12146599378a2b5",
    landingUrl: "https://staging.increase.app",
    productName: "platform",
    environment: "playground",
    whatsappUrl: "https://api.whatsapp.com/send/?phone=541150365046&text&app_absent=0"
  },
  development: hi
}, sn = /* @__PURE__ */ He.createContext(on.development);
function an({
  children: e,
  environment: t,
  productName: r
}) {
  return /* @__PURE__ */ W(sn.Provider, { value: {
    ...on[t],
    productName: r
  }, children: e });
}
function Re() {
  return We(sn);
}
const mi = ["argentina", "ecuador", "dominicana", "uruguay", "chile", "colombia", "paraguay", "peru", "costa_rica", "panama"], gi = mi.reduce((e, t) => (e[t] = [], e), {});
class _i {
  constructor(t, r, n, o, p, f, s, i, d, u, a, l, g, c, h, b, m) {
    this.id = t, this.firstName = r, this.lastName = n, this.email = o, this.owner = p, this.accountId = f, this.defaultCountry = s, this.subscriptions = i, this.authorizations = d, this.isMasquerading = u, this.realUserEmail = a, this.account = l, this.createdAt = g, this.phone = c, this.deletedAt = h, this.termsAndConditionsAcceptedAt = b, this.productAuthorizations = m, this._activeProducts = void 0, this._role = void 0;
  }
  name() {
    return `${this.firstName} ${this.lastName}`;
  }
  activeProducts() {
    return this._activeProducts ? this._activeProducts : (this._activeProducts = this.subscriptions.reduce((t, r) => (t[r.country] && t[r.country].push(r.product.name), t), gi), this._activeProducts);
  }
  displayName() {
    return this.firstName ? `${this.firstName} ${this.lastName}` : this.email;
  }
  productQuantity(t, r) {
    return this.subscriptions.find((n) => n.country === r && n.product.name === t)?.terminals_count;
  }
  role() {
    if (this._role) return this._role;
    const t = this.authorizations.find((r) => r.product_name === "platform" && r.product_country === this.defaultCountry);
    return this._role = t?.role, this._role;
  }
}
const yi = (e) => new _i(e.id, e.first_name, e.last_name, e.email, e.owner, e.account_id, e.default_country, e.subscriptions, e.authorizations, e.real_user !== null, e.real_user && e.real_user.email, e.account, new Date(e.created_at), e.phone_number, new Date(e.deleted_at), e.terms_and_conditions_accepted_at, e.product_authorizations), vi = (e) => ({
  getMe: () => fetch(`${e}/v1/users/me`, {
    credentials: "include"
  }).then((t) => t.json()).then((t) => yi(t)),
  updateUser: (t, r) => fetch(`${e}/v1/users/${t}`, {
    method: "PUT",
    credentials: "include",
    body: JSON.stringify(r),
    headers: {
      "Content-Type": "application/json"
    }
  }),
  getProducts: () => fetch(`${e}/v1/products`, {
    credentials: "include"
  }).then((t) => t.json()).then((t) => t.products),
  createSubscription: (t) => fetch(`${e}/v1/subscriptions`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      product_name: t
    }),
    headers: {
      "Content-Type": "application/json"
    }
  })
});
function Wt() {
  const {
    gatewayUrl: e
  } = Re();
  return tn(() => vi(`${e}/platform`), [e]);
}
var ue = /* @__PURE__ */ ((e) => (e.Unknown = "unknown", e.Authenticated = "authenticated", e.Unauthenticated = "unauthenticated", e))(ue || {});
const un = {
  state: "unknown"
  /* Unknown */
}, cn = /* @__PURE__ */ He.createContext(un);
function bi({
  children: e
}) {
  const [t, r] = ke(un), n = Wt();
  return Me(() => {
    n.getMe().then((o) => r({
      state: "authenticated",
      user: o
    })).catch(() => r({
      state: "unauthenticated"
      /* Unauthenticated */
    }));
  }, [n]), /* @__PURE__ */ W(cn.Provider, { value: t, children: e });
}
var ln = /* @__PURE__ */ ((e) => (e.Idle = "idle", e.Fetching = "fetching", e.Success = "success", e.Error = "error", e))(ln || {});
const pn = {
  state: "idle"
  /* Idle */
}, dn = /* @__PURE__ */ He.createContext(pn);
function wi({
  children: e
}) {
  const [t, r] = ke(pn), n = Wt();
  return Me(() => {
    r({
      state: "fetching"
      /* Fetching */
    }), n.getProducts().then((o) => r({
      state: "success",
      products: o
    })).catch(() => r({
      state: "error"
      /* Error */
    }));
  }, [n]), /* @__PURE__ */ W(dn.Provider, { value: t, children: e });
}
var ee;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(ee || (ee = {}));
function Si(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function at(e) {
  const t = e?.host;
  return t?.shadowRoot === e;
}
function ut(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function ki(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e;
}
function xi(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const r = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? r.push("layer") : e.layerName && r.push(`layer(${e.layerName})`), e.supportsText && r.push(`supports(${e.supportsText})`), e.media.length && r.push(e.media.mediaText), r.join(" ") + ";";
}
function Nt(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? ki(Array.from(t, fn).join("")) : null;
  } catch {
    return null;
  }
}
function fn(e) {
  let t;
  if (Ii(e))
    try {
      t = Nt(e.styleSheet) || xi(e);
    } catch {
    }
  else if (Ci(e) && e.selectorText.includes(":"))
    return Ei(e.cssText);
  return t || e.cssText;
}
function Ei(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function Ii(e) {
  return "styleSheet" in e;
}
function Ci(e) {
  return "selectorText" in e;
}
class hn {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t) {
    var r;
    if (!t)
      return -1;
    const n = (r = this.getMeta(t)) === null || r === void 0 ? void 0 : r.id;
    return n ?? -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  removeNodeFromMap(t) {
    const r = this.getId(t);
    this.idNodeMap.delete(r), t.childNodes && t.childNodes.forEach((n) => this.removeNodeFromMap(n));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, r) {
    const n = r.id;
    this.idNodeMap.set(n, t), this.nodeMetaMap.set(t, r);
  }
  replace(t, r) {
    const n = this.getNode(t);
    if (n) {
      const o = this.nodeMetaMap.get(n);
      o && this.nodeMetaMap.set(r, o);
    }
    this.idNodeMap.set(t, r);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Oi() {
  return new hn();
}
function lr({ element: e, maskInputOptions: t, tagName: r, type: n, value: o, maskInputFn: p }) {
  let f = o || "";
  const s = n && je(n);
  return (t[r.toLowerCase()] || s && t[s]) && (p ? f = p(f, e) : f = "*".repeat(f.length)), f;
}
function je(e) {
  return e.toLowerCase();
}
const Nr = "__rrweb_original__";
function Ti(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const r = 50;
  for (let n = 0; n < e.width; n += r)
    for (let o = 0; o < e.height; o += r) {
      const p = t.getImageData, f = Nr in p ? p[Nr] : p;
      if (new Uint32Array(f.call(t, n, o, Math.min(r, e.width - n), Math.min(r, e.height - o)).data.buffer).some((i) => i !== 0))
        return !1;
    }
  return !0;
}
function pr(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? je(t) : null;
}
function mn(e, t) {
  var r;
  let n;
  try {
    n = new URL(e, t ?? window.location.href);
  } catch {
    return null;
  }
  const o = /\.([0-9a-z]+)(?:$)/i, p = n.pathname.match(o);
  return (r = p?.[1]) !== null && r !== void 0 ? r : null;
}
let Mi = 1;
const Ni = new RegExp("[^a-z0-9-_:]"), dt = -2;
function gn() {
  return Mi++;
}
function Ri(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = je(e.tagName);
  return Ni.test(t) ? "div" : t;
}
function Ai(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let Ge, Rr;
const Di = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Li = /^(?:[a-z+]+:)?\/\//i, Pi = /^www\..*/i, Ui = /^(data:)([^,]*),(.*)/i;
function Rt(e, t) {
  return (e || "").replace(Di, (r, n, o, p, f, s) => {
    const i = o || f || s, d = n || p || "";
    if (!i)
      return r;
    if (Li.test(i) || Pi.test(i))
      return `url(${d}${i}${d})`;
    if (Ui.test(i))
      return `url(${d}${i}${d})`;
    if (i[0] === "/")
      return `url(${d}${Ai(t) + i}${d})`;
    const u = t.split("/"), a = i.split("/");
    u.pop();
    for (const l of a)
      l !== "." && (l === ".." ? u.pop() : u.push(l));
    return `url(${d}${u.join("/")}${d})`;
  });
}
const qi = /^[^ \t\n\r\u000c]+/, Fi = /^[, \t\n\r\u000c]+/;
function ji(e, t) {
  if (t.trim() === "")
    return t;
  let r = 0;
  function n(p) {
    let f;
    const s = p.exec(t.substring(r));
    return s ? (f = s[0], r += f.length, f) : "";
  }
  const o = [];
  for (; n(Fi), !(r >= t.length); ) {
    let p = n(qi);
    if (p.slice(-1) === ",")
      p = Ve(e, p.substring(0, p.length - 1)), o.push(p);
    else {
      let f = "";
      p = Ve(e, p);
      let s = !1;
      for (; ; ) {
        const i = t.charAt(r);
        if (i === "") {
          o.push((p + f).trim());
          break;
        } else if (s)
          i === ")" && (s = !1);
        else if (i === ",") {
          r += 1, o.push((p + f).trim());
          break;
        } else i === "(" && (s = !0);
        f += i, r += 1;
      }
    }
  }
  return o.join(", ");
}
function Ve(e, t) {
  if (!t || t.trim() === "")
    return t;
  const r = e.createElement("a");
  return r.href = t, r.href;
}
function Bi(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function dr() {
  const e = document.createElement("a");
  return e.href = "", e.href;
}
function _n(e, t, r, n) {
  return n && (r === "src" || r === "href" && !(t === "use" && n[0] === "#") || r === "xlink:href" && n[0] !== "#" || r === "background" && (t === "table" || t === "td" || t === "th") ? Ve(e, n) : r === "srcset" ? ji(e, n) : r === "style" ? Rt(n, dr()) : t === "object" && r === "data" ? Ve(e, n) : n);
}
function yn(e, t, r) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function $i(e, t, r) {
  try {
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let n = e.classList.length; n--; ) {
        const o = e.classList[n];
        if (t.test(o))
          return !0;
      }
    if (r)
      return e.matches(r);
  } catch {
  }
  return !1;
}
function At(e, t, r) {
  if (!e)
    return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return r ? At(e.parentNode, t, r) : !1;
  for (let n = e.classList.length; n--; ) {
    const o = e.classList[n];
    if (t.test(o))
      return !0;
  }
  return r ? At(e.parentNode, t, r) : !1;
}
function vn(e, t, r, n) {
  try {
    const o = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (o === null)
      return !1;
    if (typeof t == "string") {
      if (n) {
        if (o.closest(`.${t}`))
          return !0;
      } else if (o.classList.contains(t))
        return !0;
    } else if (At(o, t, n))
      return !0;
    if (r) {
      if (n) {
        if (o.closest(r))
          return !0;
      } else if (o.matches(r))
        return !0;
    }
  } catch {
  }
  return !1;
}
function Hi(e, t, r) {
  const n = e.contentWindow;
  if (!n)
    return;
  let o = !1, p;
  try {
    p = n.document.readyState;
  } catch {
    return;
  }
  if (p !== "complete") {
    const s = setTimeout(() => {
      o || (t(), o = !0);
    }, r);
    e.addEventListener("load", () => {
      clearTimeout(s), o = !0, t();
    });
    return;
  }
  const f = "about:blank";
  if (n.location.href !== f || e.src === f || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function Wi(e, t, r) {
  let n = !1, o;
  try {
    o = e.sheet;
  } catch {
    return;
  }
  if (o)
    return;
  const p = setTimeout(() => {
    n || (t(), n = !0);
  }, r);
  e.addEventListener("load", () => {
    clearTimeout(p), n = !0, t();
  });
}
function zi(e, t) {
  const { doc: r, mirror: n, blockClass: o, blockSelector: p, needsMask: f, inlineStylesheet: s, maskInputOptions: i = {}, maskTextFn: d, maskInputFn: u, dataURLOptions: a = {}, inlineImages: l, recordCanvas: g, keepIframeSrcFn: c, newlyAddedElement: h = !1 } = t, b = Gi(r, n);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: ee.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: ee.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: ee.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: b
      };
    case e.ELEMENT_NODE:
      return Vi(e, {
        doc: r,
        blockClass: o,
        blockSelector: p,
        inlineStylesheet: s,
        maskInputOptions: i,
        maskInputFn: u,
        dataURLOptions: a,
        inlineImages: l,
        recordCanvas: g,
        keepIframeSrcFn: c,
        newlyAddedElement: h,
        rootId: b
      });
    case e.TEXT_NODE:
      return Ji(e, {
        needsMask: f,
        maskTextFn: d,
        rootId: b
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: ee.CDATA,
        textContent: "",
        rootId: b
      };
    case e.COMMENT_NODE:
      return {
        type: ee.Comment,
        textContent: e.textContent || "",
        rootId: b
      };
    default:
      return !1;
  }
}
function Gi(e, t) {
  if (!t.hasNode(e))
    return;
  const r = t.getId(e);
  return r === 1 ? void 0 : r;
}
function Ji(e, t) {
  var r;
  const { needsMask: n, maskTextFn: o, rootId: p } = t, f = e.parentNode && e.parentNode.tagName;
  let s = e.textContent;
  const i = f === "STYLE" ? !0 : void 0, d = f === "SCRIPT" ? !0 : void 0;
  if (i && s) {
    try {
      e.nextSibling || e.previousSibling || !((r = e.parentNode.sheet) === null || r === void 0) && r.cssRules && (s = Nt(e.parentNode.sheet));
    } catch (u) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${u}`, e);
    }
    s = Rt(s, dr());
  }
  return d && (s = "SCRIPT_PLACEHOLDER"), !i && !d && s && n && (s = o ? o(s, e.parentElement) : s.replace(/[\S]/g, "*")), {
    type: ee.Text,
    textContent: s || "",
    isStyle: i,
    rootId: p
  };
}
function Vi(e, t) {
  const { doc: r, blockClass: n, blockSelector: o, inlineStylesheet: p, maskInputOptions: f = {}, maskInputFn: s, dataURLOptions: i = {}, inlineImages: d, recordCanvas: u, keepIframeSrcFn: a, newlyAddedElement: l = !1, rootId: g } = t, c = $i(e, n, o), h = Ri(e);
  let b = {};
  const m = e.attributes.length;
  for (let y = 0; y < m; y++) {
    const w = e.attributes[y];
    yn(h, w.name, w.value) || (b[w.name] = _n(r, h, je(w.name), w.value));
  }
  if (h === "link" && p) {
    const y = Array.from(r.styleSheets).find((E) => E.href === e.href);
    let w = null;
    y && (w = Nt(y)), w && (delete b.rel, delete b.href, b._cssText = Rt(w, y.href));
  }
  if (h === "style" && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
    const y = Nt(e.sheet);
    y && (b._cssText = Rt(y, dr()));
  }
  if (h === "input" || h === "textarea" || h === "select") {
    const y = e.value, w = e.checked;
    b.type !== "radio" && b.type !== "checkbox" && b.type !== "submit" && b.type !== "button" && y ? b.value = lr({
      element: e,
      type: pr(e),
      tagName: h,
      value: y,
      maskInputOptions: f,
      maskInputFn: s
    }) : w && (b.checked = w);
  }
  if (h === "option" && (e.selected && !f.select ? b.selected = !0 : delete b.selected), h === "canvas" && u) {
    if (e.__context === "2d")
      Ti(e) || (b.rr_dataURL = e.toDataURL(i.type, i.quality));
    else if (!("__context" in e)) {
      const y = e.toDataURL(i.type, i.quality), w = document.createElement("canvas");
      w.width = e.width, w.height = e.height;
      const E = w.toDataURL(i.type, i.quality);
      y !== E && (b.rr_dataURL = y);
    }
  }
  if (h === "img" && d) {
    Ge || (Ge = r.createElement("canvas"), Rr = Ge.getContext("2d"));
    const y = e, w = y.crossOrigin;
    y.crossOrigin = "anonymous";
    const E = () => {
      y.removeEventListener("load", E);
      try {
        Ge.width = y.naturalWidth, Ge.height = y.naturalHeight, Rr.drawImage(y, 0, 0), b.rr_dataURL = Ge.toDataURL(i.type, i.quality);
      } catch (C) {
        console.warn(`Cannot inline img src=${y.currentSrc}! Error: ${C}`);
      }
      w ? b.crossOrigin = w : y.removeAttribute("crossorigin");
    };
    y.complete && y.naturalWidth !== 0 ? E() : y.addEventListener("load", E);
  }
  if (h === "audio" || h === "video") {
    const y = b;
    y.rr_mediaState = e.paused ? "paused" : "played", y.rr_mediaCurrentTime = e.currentTime, y.rr_mediaPlaybackRate = e.playbackRate, y.rr_mediaMuted = e.muted, y.rr_mediaLoop = e.loop, y.rr_mediaVolume = e.volume;
  }
  if (l || (e.scrollLeft && (b.rr_scrollLeft = e.scrollLeft), e.scrollTop && (b.rr_scrollTop = e.scrollTop)), c) {
    const { width: y, height: w } = e.getBoundingClientRect();
    b = {
      class: b.class,
      rr_width: `${y}px`,
      rr_height: `${w}px`
    };
  }
  h === "iframe" && !a(b.src) && (e.contentDocument || (b.rr_src = b.src), delete b.src);
  let v;
  try {
    customElements.get(h) && (v = !0);
  } catch {
  }
  return {
    type: ee.Element,
    tagName: h,
    attributes: b,
    childNodes: [],
    isSVG: Bi(e) || void 0,
    needBlock: c,
    rootId: g,
    isCustom: v
  };
}
function J(e) {
  return e == null ? "" : e.toLowerCase();
}
function Xi(e, t) {
  if (t.comment && e.type === ee.Comment)
    return !0;
  if (e.type === ee.Element) {
    if (t.script && (e.tagName === "script" || e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && mn(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (J(e.attributes.name).match(/^msapplication-tile(image|color)$/) || J(e.attributes.name) === "application-name" || J(e.attributes.rel) === "icon" || J(e.attributes.rel) === "apple-touch-icon" || J(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && J(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (J(e.attributes.property).match(/^(og|twitter|fb):/) || J(e.attributes.name).match(/^(og|twitter):/) || J(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (J(e.attributes.name) === "robots" || J(e.attributes.name) === "googlebot" || J(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (J(e.attributes.name) === "author" || J(e.attributes.name) === "generator" || J(e.attributes.name) === "framework" || J(e.attributes.name) === "publisher" || J(e.attributes.name) === "progid" || J(e.attributes.property).match(/^article:/) || J(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (J(e.attributes.name) === "google-site-verification" || J(e.attributes.name) === "yandex-verification" || J(e.attributes.name) === "csrf-token" || J(e.attributes.name) === "p:domain_verify" || J(e.attributes.name) === "verify-v1" || J(e.attributes.name) === "verification" || J(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Xe(e, t) {
  const { doc: r, mirror: n, blockClass: o, blockSelector: p, maskTextClass: f, maskTextSelector: s, skipChild: i = !1, inlineStylesheet: d = !0, maskInputOptions: u = {}, maskTextFn: a, maskInputFn: l, slimDOMOptions: g, dataURLOptions: c = {}, inlineImages: h = !1, recordCanvas: b = !1, onSerialize: m, onIframeLoad: v, iframeLoadTimeout: y = 5e3, onStylesheetLoad: w, stylesheetLoadTimeout: E = 5e3, keepIframeSrcFn: C = () => !1, newlyAddedElement: k = !1 } = t;
  let { needsMask: S } = t, { preserveWhiteSpace: O = !0 } = t;
  !S && e.childNodes && (S = vn(e, f, s, S === void 0));
  const T = zi(e, {
    doc: r,
    mirror: n,
    blockClass: o,
    blockSelector: p,
    needsMask: S,
    inlineStylesheet: d,
    maskInputOptions: u,
    maskTextFn: a,
    maskInputFn: l,
    dataURLOptions: c,
    inlineImages: h,
    recordCanvas: b,
    keepIframeSrcFn: C,
    newlyAddedElement: k
  });
  if (!T)
    return console.warn(e, "not serialized"), null;
  let x;
  n.hasNode(e) ? x = n.getId(e) : Xi(T, g) || !O && T.type === ee.Text && !T.isStyle && !T.textContent.replace(/^\s+|\s+$/gm, "").length ? x = dt : x = gn();
  const I = Object.assign(T, { id: x });
  if (n.add(e, I), x === dt)
    return null;
  m && m(e);
  let R = !i;
  if (I.type === ee.Element) {
    R = R && !I.needBlock, delete I.needBlock;
    const N = e.shadowRoot;
    N && ut(N) && (I.isShadowHost = !0);
  }
  if ((I.type === ee.Document || I.type === ee.Element) && R) {
    g.headWhitespace && I.type === ee.Element && I.tagName === "head" && (O = !1);
    const N = {
      doc: r,
      mirror: n,
      blockClass: o,
      blockSelector: p,
      needsMask: S,
      maskTextClass: f,
      maskTextSelector: s,
      skipChild: i,
      inlineStylesheet: d,
      maskInputOptions: u,
      maskTextFn: a,
      maskInputFn: l,
      slimDOMOptions: g,
      dataURLOptions: c,
      inlineImages: h,
      recordCanvas: b,
      preserveWhiteSpace: O,
      onSerialize: m,
      onIframeLoad: v,
      iframeLoadTimeout: y,
      onStylesheetLoad: w,
      stylesheetLoadTimeout: E,
      keepIframeSrcFn: C
    };
    if (!(I.type === ee.Element && I.tagName === "textarea" && I.attributes.value !== void 0)) for (const D of Array.from(e.childNodes)) {
      const A = Xe(D, N);
      A && I.childNodes.push(A);
    }
    if (Si(e) && e.shadowRoot)
      for (const D of Array.from(e.shadowRoot.childNodes)) {
        const A = Xe(D, N);
        A && (ut(e.shadowRoot) && (A.isShadow = !0), I.childNodes.push(A));
      }
  }
  return e.parentNode && at(e.parentNode) && ut(e.parentNode) && (I.isShadow = !0), I.type === ee.Element && I.tagName === "iframe" && Hi(e, () => {
    const N = e.contentDocument;
    if (N && v) {
      const D = Xe(N, {
        doc: N,
        mirror: n,
        blockClass: o,
        blockSelector: p,
        needsMask: S,
        maskTextClass: f,
        maskTextSelector: s,
        skipChild: !1,
        inlineStylesheet: d,
        maskInputOptions: u,
        maskTextFn: a,
        maskInputFn: l,
        slimDOMOptions: g,
        dataURLOptions: c,
        inlineImages: h,
        recordCanvas: b,
        preserveWhiteSpace: O,
        onSerialize: m,
        onIframeLoad: v,
        iframeLoadTimeout: y,
        onStylesheetLoad: w,
        stylesheetLoadTimeout: E,
        keepIframeSrcFn: C
      });
      D && v(e, D);
    }
  }, y), I.type === ee.Element && I.tagName === "link" && typeof I.attributes.rel == "string" && (I.attributes.rel === "stylesheet" || I.attributes.rel === "preload" && typeof I.attributes.href == "string" && mn(I.attributes.href) === "css") && Wi(e, () => {
    if (w) {
      const N = Xe(e, {
        doc: r,
        mirror: n,
        blockClass: o,
        blockSelector: p,
        needsMask: S,
        maskTextClass: f,
        maskTextSelector: s,
        skipChild: !1,
        inlineStylesheet: d,
        maskInputOptions: u,
        maskTextFn: a,
        maskInputFn: l,
        slimDOMOptions: g,
        dataURLOptions: c,
        inlineImages: h,
        recordCanvas: b,
        preserveWhiteSpace: O,
        onSerialize: m,
        onIframeLoad: v,
        iframeLoadTimeout: y,
        onStylesheetLoad: w,
        stylesheetLoadTimeout: E,
        keepIframeSrcFn: C
      });
      N && w(e, N);
    }
  }, E), I;
}
function Yi(e, t) {
  const { mirror: r = new hn(), blockClass: n = "rr-block", blockSelector: o = null, maskTextClass: p = "rr-mask", maskTextSelector: f = null, inlineStylesheet: s = !0, inlineImages: i = !1, recordCanvas: d = !1, maskAllInputs: u = !1, maskTextFn: a, maskInputFn: l, slimDOM: g = !1, dataURLOptions: c, preserveWhiteSpace: h, onSerialize: b, onIframeLoad: m, iframeLoadTimeout: v, onStylesheetLoad: y, stylesheetLoadTimeout: w, keepIframeSrcFn: E = () => !1 } = t || {};
  return Xe(e, {
    doc: e,
    mirror: r,
    blockClass: n,
    blockSelector: o,
    maskTextClass: p,
    maskTextSelector: f,
    skipChild: !1,
    inlineStylesheet: s,
    maskInputOptions: u === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : u === !1 ? {
      password: !0
    } : u,
    maskTextFn: a,
    maskInputFn: l,
    slimDOMOptions: g === !0 || g === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: g === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : g === !1 ? {} : g,
    dataURLOptions: c,
    inlineImages: i,
    recordCanvas: d,
    preserveWhiteSpace: h,
    onSerialize: b,
    onIframeLoad: m,
    iframeLoadTimeout: v,
    onStylesheetLoad: y,
    stylesheetLoadTimeout: w,
    keepIframeSrcFn: E,
    newlyAddedElement: !1
  });
}
function oe(e, t, r = document) {
  const n = { capture: !0, passive: !0 };
  return r.addEventListener(e, t, n), () => r.removeEventListener(e, t, n);
}
const Je = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Ar = {
  map: {},
  getId() {
    return console.error(Je), -1;
  },
  getNode() {
    return console.error(Je), null;
  },
  removeNodeFromMap() {
    console.error(Je);
  },
  has() {
    return console.error(Je), !1;
  },
  reset() {
    console.error(Je);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Ar = new Proxy(Ar, {
  get(e, t, r) {
    return t === "map" && console.error(Je), Reflect.get(e, t, r);
  }
}));
function ft(e, t, r = {}) {
  let n = null, o = 0;
  return function(...p) {
    const f = Date.now();
    !o && r.leading === !1 && (o = f);
    const s = t - (f - o), i = this;
    s <= 0 || s > t ? (n && (clearTimeout(n), n = null), o = f, e.apply(i, p)) : !n && r.trailing !== !1 && (n = setTimeout(() => {
      o = r.leading === !1 ? 0 : Date.now(), n = null, e.apply(i, p);
    }, s));
  };
}
function zt(e, t, r, n, o = window) {
  const p = o.Object.getOwnPropertyDescriptor(e, t);
  return o.Object.defineProperty(e, t, n ? r : {
    set(f) {
      setTimeout(() => {
        r.set.call(this, f);
      }, 0), p && p.set && p.set.call(this, f);
    }
  }), () => zt(e, t, p || {}, !0);
}
function it(e, t, r) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], o = r(n);
    return typeof o == "function" && (o.prototype = o.prototype || {}, Object.defineProperties(o, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = o, () => {
      e[t] = n;
    };
  } catch {
    return () => {
    };
  }
}
let Dt = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (Dt = () => (/* @__PURE__ */ new Date()).getTime());
function bn(e) {
  var t, r, n, o, p, f;
  const s = e.document;
  return {
    left: s.scrollingElement ? s.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : s?.documentElement.scrollLeft || ((r = (t = s?.body) === null || t === void 0 ? void 0 : t.parentElement) === null || r === void 0 ? void 0 : r.scrollLeft) || ((n = s?.body) === null || n === void 0 ? void 0 : n.scrollLeft) || 0,
    top: s.scrollingElement ? s.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : s?.documentElement.scrollTop || ((p = (o = s?.body) === null || o === void 0 ? void 0 : o.parentElement) === null || p === void 0 ? void 0 : p.scrollTop) || ((f = s?.body) === null || f === void 0 ? void 0 : f.scrollTop) || 0
  };
}
function wn() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Sn() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function kn(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : e.parentElement : null;
}
function se(e, t, r, n) {
  if (!e)
    return !1;
  const o = kn(e);
  if (!o)
    return !1;
  try {
    if (typeof t == "string") {
      if (o.classList.contains(t) || n && o.closest("." + t) !== null)
        return !0;
    } else if (At(o, t, n))
      return !0;
  } catch {
  }
  return !!(r && (o.matches(r) || n && o.closest(r) !== null));
}
function Ki(e, t) {
  return t.getId(e) !== -1;
}
function Qt(e, t) {
  return t.getId(e) === dt;
}
function xn(e, t) {
  if (at(e))
    return !1;
  const r = t.getId(e);
  return t.has(r) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? xn(e.parentNode, t) : !0 : !0;
}
function or(e) {
  return !!e.changedTouches;
}
function Qi(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let r = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === r)
        return !0;
    while (r = r && r.parentNode);
    return !1;
  });
}
function En(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function In(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function sr(e) {
  return !!e?.shadowRoot;
}
class Zi {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    var r;
    return (r = this.styleIDMap.get(t)) !== null && r !== void 0 ? r : -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  add(t, r) {
    if (this.has(t))
      return this.getId(t);
    let n;
    return r === void 0 ? n = this.id++ : n = r, this.styleIDMap.set(t, n), this.idStyleMap.set(n, t), n;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function Cn(e) {
  var t, r;
  let n = null;
  return ((r = (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e)) === null || r === void 0 ? void 0 : r.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (n = e.getRootNode().host), n;
}
function eo(e) {
  let t = e, r;
  for (; r = Cn(t); )
    t = r;
  return t;
}
function to(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const r = eo(e);
  return t.contains(r);
}
function On(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || to(e) : !1;
}
var H = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(H || {}), B = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(B || {}), ae = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(ae || {}), we = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(we || {}), tt = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(tt || {});
function Dr(e) {
  return "__ln" in e;
}
class ro {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let r = this.head;
    for (let n = 0; n < t; n++)
      r = r?.next || null;
    return r;
  }
  addNode(t) {
    const r = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = r, t.previousSibling && Dr(t.previousSibling)) {
      const n = t.previousSibling.__ln.next;
      r.next = n, r.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = r, n && (n.previous = r);
    } else if (t.nextSibling && Dr(t.nextSibling) && t.nextSibling.__ln.previous) {
      const n = t.nextSibling.__ln.previous;
      r.previous = n, r.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = r, n && (n.next = r);
    } else
      this.head && (this.head.previous = r), r.next = this.head, this.head = r;
    r.next === null && (this.tail = r), this.length++;
  }
  removeNode(t) {
    const r = t.__ln;
    this.head && (r.previous ? (r.previous.next = r.next, r.next ? r.next.previous = r.previous : this.tail = r.previous) : (this.head = r.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const Lr = (e, t) => `${e}@${t}`;
class no {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], r = /* @__PURE__ */ new Set(), n = new ro(), o = (i) => {
        let d = i, u = dt;
        for (; u === dt; )
          d = d && d.nextSibling, u = d && this.mirror.getId(d);
        return u;
      }, p = (i) => {
        if (!i.parentNode || !On(i) || i.parentNode.tagName === "TEXTAREA")
          return;
        const d = at(i.parentNode) ? this.mirror.getId(Cn(i)) : this.mirror.getId(i.parentNode), u = o(i);
        if (d === -1 || u === -1)
          return n.addNode(i);
        const a = Xe(i, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (l) => {
            En(l, this.mirror) && this.iframeManager.addIframe(l), In(l, this.mirror) && this.stylesheetManager.trackLinkElement(l), sr(i) && this.shadowDomManager.addShadowRoot(i.shadowRoot, this.doc);
          },
          onIframeLoad: (l, g) => {
            this.iframeManager.attachIframe(l, g), this.shadowDomManager.observeAttachShadow(l);
          },
          onStylesheetLoad: (l, g) => {
            this.stylesheetManager.attachLinkElement(l, g);
          }
        });
        a && (t.push({
          parentId: d,
          nextId: u,
          node: a
        }), r.add(a.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const i of this.movedSet)
        Pr(this.removes, i, this.mirror) && !this.movedSet.has(i.parentNode) || p(i);
      for (const i of this.addedSet)
        !Ur(this.droppedSet, i) && !Pr(this.removes, i, this.mirror) || Ur(this.movedSet, i) ? p(i) : this.droppedSet.add(i);
      let f = null;
      for (; n.length; ) {
        let i = null;
        if (f) {
          const d = this.mirror.getId(f.value.parentNode), u = o(f.value);
          d !== -1 && u !== -1 && (i = f);
        }
        if (!i) {
          let d = n.tail;
          for (; d; ) {
            const u = d;
            if (d = d.previous, u) {
              const a = this.mirror.getId(u.value.parentNode);
              if (o(u.value) === -1)
                continue;
              if (a !== -1) {
                i = u;
                break;
              } else {
                const g = u.value;
                if (g.parentNode && g.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const c = g.parentNode.host;
                  if (this.mirror.getId(c) !== -1) {
                    i = u;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!i) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        f = i.previous, n.removeNode(i.value), p(i.value);
      }
      const s = {
        texts: this.texts.map((i) => {
          const d = i.node;
          return d.parentNode && d.parentNode.tagName === "TEXTAREA" && this.genTextAreaValueMutation(d.parentNode), {
            id: this.mirror.getId(d),
            value: i.value
          };
        }).filter((i) => !r.has(i.id)).filter((i) => this.mirror.has(i.id)),
        attributes: this.attributes.map((i) => {
          const { attributes: d } = i;
          if (typeof d.style == "string") {
            const u = JSON.stringify(i.styleDiff), a = JSON.stringify(i._unchangedStyles);
            u.length < d.style.length && (u + a).split("var(").length === d.style.split("var(").length && (d.style = i.styleDiff);
          }
          return {
            id: this.mirror.getId(i.node),
            attributes: d
          };
        }).filter((i) => !r.has(i.id)).filter((i) => this.mirror.has(i.id)),
        removes: this.removes,
        adds: t
      };
      !s.texts.length && !s.attributes.length && !s.removes.length && !s.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(s));
    }, this.genTextAreaValueMutation = (t) => {
      let r = this.attributeMap.get(t);
      r || (r = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(r), this.attributeMap.set(t, r)), r.attributes.value = Array.from(t.childNodes, (n) => n.textContent || "").join("");
    }, this.processMutation = (t) => {
      if (!Qt(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const r = t.target.textContent;
            !se(t.target, this.blockClass, this.blockSelector, !1) && r !== t.oldValue && this.texts.push({
              value: vn(t.target, this.maskTextClass, this.maskTextSelector, !0) && r ? this.maskTextFn ? this.maskTextFn(r, kn(t.target)) : r.replace(/[\S]/g, "*") : r,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const r = t.target;
            let n = t.attributeName, o = t.target.getAttribute(n);
            if (n === "value") {
              const f = pr(r);
              o = lr({
                element: r,
                maskInputOptions: this.maskInputOptions,
                tagName: r.tagName,
                type: f,
                value: o,
                maskInputFn: this.maskInputFn
              });
            }
            if (se(t.target, this.blockClass, this.blockSelector, !1) || o === t.oldValue)
              return;
            let p = this.attributeMap.get(t.target);
            if (r.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(o))
              if (!r.contentDocument)
                n = "rr_src";
              else
                return;
            if (p || (p = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(p), this.attributeMap.set(t.target, p)), n === "type" && r.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && r.setAttribute("data-rr-is-password", "true"), !yn(r.tagName, n) && (p.attributes[n] = _n(this.doc, je(r.tagName), je(n), o), n === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const f = this.unattachedDoc.createElement("span");
              t.oldValue && f.setAttribute("style", t.oldValue);
              for (const s of Array.from(r.style)) {
                const i = r.style.getPropertyValue(s), d = r.style.getPropertyPriority(s);
                i !== f.style.getPropertyValue(s) || d !== f.style.getPropertyPriority(s) ? d === "" ? p.styleDiff[s] = i : p.styleDiff[s] = [i, d] : p._unchangedStyles[s] = [i, d];
              }
              for (const s of Array.from(f.style))
                r.style.getPropertyValue(s) === "" && (p.styleDiff[s] = !1);
            }
            break;
          }
          case "childList": {
            if (se(t.target, this.blockClass, this.blockSelector, !0))
              return;
            if (t.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach((r) => this.genAdds(r, t.target)), t.removedNodes.forEach((r) => {
              const n = this.mirror.getId(r), o = at(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              se(t.target, this.blockClass, this.blockSelector, !1) || Qt(r, this.mirror) || !Ki(r, this.mirror) || (this.addedSet.has(r) ? (ar(this.addedSet, r), this.droppedSet.add(r)) : this.addedSet.has(t.target) && n === -1 || xn(t.target, this.mirror) || (this.movedSet.has(r) && this.movedMap[Lr(n, o)] ? ar(this.movedSet, r) : this.removes.push({
                parentId: o,
                id: n,
                isShadow: at(t.target) && ut(t.target) ? !0 : void 0
              })), this.mapRemoves.push(r));
            });
            break;
          }
        }
    }, this.genAdds = (t, r) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (Qt(t, this.mirror))
            return;
          this.movedSet.add(t);
          let n = null;
          r && this.mirror.hasNode(r) && (n = this.mirror.getId(r)), n && n !== -1 && (this.movedMap[Lr(this.mirror.getId(t), n)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        se(t, this.blockClass, this.blockSelector, !1) || (t.childNodes.forEach((n) => this.genAdds(n)), sr(t) && t.shadowRoot.childNodes.forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((r) => {
      this[r] = t[r];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function ar(e, t) {
  e.delete(t), t.childNodes.forEach((r) => ar(e, r));
}
function Pr(e, t, r) {
  return e.length === 0 ? !1 : Tn(e, t, r);
}
function Tn(e, t, r) {
  const { parentNode: n } = t;
  if (!n)
    return !1;
  const o = r.getId(n);
  return e.some((p) => p.id === o) ? !0 : Tn(e, n, r);
}
function Ur(e, t) {
  return e.size === 0 ? !1 : Mn(e, t);
}
function Mn(e, t) {
  const { parentNode: r } = t;
  return r ? e.has(r) ? !0 : Mn(e, r) : !1;
}
let ct;
function io(e) {
  ct = e;
}
function oo() {
  ct = void 0;
}
const $ = (e) => ct ? (...r) => {
  try {
    return e(...r);
  } catch (n) {
    if (ct && ct(n) === !0)
      return;
    throw n;
  }
} : e, Fe = [];
function gt(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function Nn(e, t) {
  var r, n;
  const o = new no();
  Fe.push(o), o.init(e);
  let p = window.MutationObserver || window.__rrMutationObserver;
  const f = (n = (r = window?.Zone) === null || r === void 0 ? void 0 : r.__symbol__) === null || n === void 0 ? void 0 : n.call(r, "MutationObserver");
  f && window[f] && (p = window[f]);
  const s = new p($(o.processMutations.bind(o)));
  return s.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), s;
}
function so({ mousemoveCb: e, sampling: t, doc: r, mirror: n }) {
  if (t.mousemove === !1)
    return () => {
    };
  const o = typeof t.mousemove == "number" ? t.mousemove : 50, p = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let f = [], s;
  const i = ft($((a) => {
    const l = Date.now() - s;
    e(f.map((g) => (g.timeOffset -= l, g)), a), f = [], s = null;
  }), p), d = $(ft($((a) => {
    const l = gt(a), { clientX: g, clientY: c } = or(a) ? a.changedTouches[0] : a;
    s || (s = Dt()), f.push({
      x: g,
      y: c,
      id: n.getId(l),
      timeOffset: Dt() - s
    }), i(typeof DragEvent < "u" && a instanceof DragEvent ? B.Drag : a instanceof MouseEvent ? B.MouseMove : B.TouchMove);
  }), o, {
    trailing: !1
  })), u = [
    oe("mousemove", d, r),
    oe("touchmove", d, r),
    oe("drag", d, r)
  ];
  return $(() => {
    u.forEach((a) => a());
  });
}
function ao({ mouseInteractionCb: e, doc: t, mirror: r, blockClass: n, blockSelector: o, sampling: p }) {
  if (p.mouseInteraction === !1)
    return () => {
    };
  const f = p.mouseInteraction === !0 || p.mouseInteraction === void 0 ? {} : p.mouseInteraction, s = [];
  let i = null;
  const d = (u) => (a) => {
    const l = gt(a);
    if (se(l, n, o, !0))
      return;
    let g = null, c = u;
    if ("pointerType" in a) {
      switch (a.pointerType) {
        case "mouse":
          g = we.Mouse;
          break;
        case "touch":
          g = we.Touch;
          break;
        case "pen":
          g = we.Pen;
          break;
      }
      g === we.Touch ? ae[u] === ae.MouseDown ? c = "TouchStart" : ae[u] === ae.MouseUp && (c = "TouchEnd") : we.Pen;
    } else or(a) && (g = we.Touch);
    g !== null ? (i = g, (c.startsWith("Touch") && g === we.Touch || c.startsWith("Mouse") && g === we.Mouse) && (g = null)) : ae[u] === ae.Click && (g = i, i = null);
    const h = or(a) ? a.changedTouches[0] : a;
    if (!h)
      return;
    const b = r.getId(l), { clientX: m, clientY: v } = h;
    $(e)(Object.assign({ type: ae[c], id: b, x: m, y: v }, g !== null && { pointerType: g }));
  };
  return Object.keys(ae).filter((u) => Number.isNaN(Number(u)) && !u.endsWith("_Departed") && f[u] !== !1).forEach((u) => {
    let a = je(u);
    const l = d(u);
    if (window.PointerEvent)
      switch (ae[u]) {
        case ae.MouseDown:
        case ae.MouseUp:
          a = a.replace("mouse", "pointer");
          break;
        case ae.TouchStart:
        case ae.TouchEnd:
          return;
      }
    s.push(oe(a, l, t));
  }), $(() => {
    s.forEach((u) => u());
  });
}
function Rn({ scrollCb: e, doc: t, mirror: r, blockClass: n, blockSelector: o, sampling: p }) {
  const f = $(ft($((s) => {
    const i = gt(s);
    if (!i || se(i, n, o, !0))
      return;
    const d = r.getId(i);
    if (i === t && t.defaultView) {
      const u = bn(t.defaultView);
      e({
        id: d,
        x: u.left,
        y: u.top
      });
    } else
      e({
        id: d,
        x: i.scrollLeft,
        y: i.scrollTop
      });
  }), p.scroll || 100));
  return oe("scroll", f, t);
}
function uo({ viewportResizeCb: e }, { win: t }) {
  let r = -1, n = -1;
  const o = $(ft($(() => {
    const p = wn(), f = Sn();
    (r !== p || n !== f) && (e({
      width: Number(f),
      height: Number(p)
    }), r = p, n = f);
  }), 200));
  return oe("resize", o, t);
}
const co = ["INPUT", "TEXTAREA", "SELECT"], qr = /* @__PURE__ */ new WeakMap();
function lo({ inputCb: e, doc: t, mirror: r, blockClass: n, blockSelector: o, ignoreClass: p, ignoreSelector: f, maskInputOptions: s, maskInputFn: i, sampling: d, userTriggeredOnInput: u }) {
  function a(v) {
    let y = gt(v);
    const w = v.isTrusted, E = y && y.tagName;
    if (y && E === "OPTION" && (y = y.parentElement), !y || !E || co.indexOf(E) < 0 || se(y, n, o, !0) || y.classList.contains(p) || f && y.matches(f))
      return;
    let C = y.value, k = !1;
    const S = pr(y) || "";
    S === "radio" || S === "checkbox" ? k = y.checked : (s[E.toLowerCase()] || s[S]) && (C = lr({
      element: y,
      maskInputOptions: s,
      tagName: E,
      type: S,
      value: C,
      maskInputFn: i
    })), l(y, u ? { text: C, isChecked: k, userTriggered: w } : { text: C, isChecked: k });
    const O = y.name;
    S === "radio" && O && k && t.querySelectorAll(`input[type="radio"][name="${O}"]`).forEach((T) => {
      if (T !== y) {
        const x = T.value;
        l(T, u ? { text: x, isChecked: !k, userTriggered: !1 } : { text: x, isChecked: !k });
      }
    });
  }
  function l(v, y) {
    const w = qr.get(v);
    if (!w || w.text !== y.text || w.isChecked !== y.isChecked) {
      qr.set(v, y);
      const E = r.getId(v);
      $(e)(Object.assign(Object.assign({}, y), { id: E }));
    }
  }
  const c = (d.input === "last" ? ["change"] : ["input", "change"]).map((v) => oe(v, $(a), t)), h = t.defaultView;
  if (!h)
    return () => {
      c.forEach((v) => v());
    };
  const b = h.Object.getOwnPropertyDescriptor(h.HTMLInputElement.prototype, "value"), m = [
    [h.HTMLInputElement.prototype, "value"],
    [h.HTMLInputElement.prototype, "checked"],
    [h.HTMLSelectElement.prototype, "value"],
    [h.HTMLTextAreaElement.prototype, "value"],
    [h.HTMLSelectElement.prototype, "selectedIndex"],
    [h.HTMLOptionElement.prototype, "selected"]
  ];
  return b && b.set && c.push(...m.map((v) => zt(v[0], v[1], {
    set() {
      $(a)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, h))), $(() => {
    c.forEach((v) => v());
  });
}
function Lt(e) {
  const t = [];
  function r(n, o) {
    if (kt("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || kt("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || kt("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || kt("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const f = Array.from(n.parentRule.cssRules).indexOf(n);
      o.unshift(f);
    } else if (n.parentStyleSheet) {
      const f = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      o.unshift(f);
    }
    return o;
  }
  return r(e, t);
}
function Ce(e, t, r) {
  let n, o;
  return e ? (e.ownerNode ? n = t.getId(e.ownerNode) : o = r.getId(e), {
    styleId: o,
    id: n
  }) : {};
}
function po({ styleSheetRuleCb: e, mirror: t, stylesheetManager: r }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const o = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(o, {
    apply: $((u, a, l) => {
      const [g, c] = l, { id: h, styleId: b } = Ce(a, t, r.styleMirror);
      return (h && h !== -1 || b && b !== -1) && e({
        id: h,
        styleId: b,
        adds: [{ rule: g, index: c }]
      }), u.apply(a, l);
    })
  });
  const p = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(p, {
    apply: $((u, a, l) => {
      const [g] = l, { id: c, styleId: h } = Ce(a, t, r.styleMirror);
      return (c && c !== -1 || h && h !== -1) && e({
        id: c,
        styleId: h,
        removes: [{ index: g }]
      }), u.apply(a, l);
    })
  });
  let f;
  n.CSSStyleSheet.prototype.replace && (f = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(f, {
    apply: $((u, a, l) => {
      const [g] = l, { id: c, styleId: h } = Ce(a, t, r.styleMirror);
      return (c && c !== -1 || h && h !== -1) && e({
        id: c,
        styleId: h,
        replace: g
      }), u.apply(a, l);
    })
  }));
  let s;
  n.CSSStyleSheet.prototype.replaceSync && (s = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
    apply: $((u, a, l) => {
      const [g] = l, { id: c, styleId: h } = Ce(a, t, r.styleMirror);
      return (c && c !== -1 || h && h !== -1) && e({
        id: c,
        styleId: h,
        replaceSync: g
      }), u.apply(a, l);
    })
  }));
  const i = {};
  xt("CSSGroupingRule") ? i.CSSGroupingRule = n.CSSGroupingRule : (xt("CSSMediaRule") && (i.CSSMediaRule = n.CSSMediaRule), xt("CSSConditionRule") && (i.CSSConditionRule = n.CSSConditionRule), xt("CSSSupportsRule") && (i.CSSSupportsRule = n.CSSSupportsRule));
  const d = {};
  return Object.entries(i).forEach(([u, a]) => {
    d[u] = {
      insertRule: a.prototype.insertRule,
      deleteRule: a.prototype.deleteRule
    }, a.prototype.insertRule = new Proxy(d[u].insertRule, {
      apply: $((l, g, c) => {
        const [h, b] = c, { id: m, styleId: v } = Ce(g.parentStyleSheet, t, r.styleMirror);
        return (m && m !== -1 || v && v !== -1) && e({
          id: m,
          styleId: v,
          adds: [
            {
              rule: h,
              index: [
                ...Lt(g),
                b || 0
              ]
            }
          ]
        }), l.apply(g, c);
      })
    }), a.prototype.deleteRule = new Proxy(d[u].deleteRule, {
      apply: $((l, g, c) => {
        const [h] = c, { id: b, styleId: m } = Ce(g.parentStyleSheet, t, r.styleMirror);
        return (b && b !== -1 || m && m !== -1) && e({
          id: b,
          styleId: m,
          removes: [
            { index: [...Lt(g), h] }
          ]
        }), l.apply(g, c);
      })
    });
  }), $(() => {
    n.CSSStyleSheet.prototype.insertRule = o, n.CSSStyleSheet.prototype.deleteRule = p, f && (n.CSSStyleSheet.prototype.replace = f), s && (n.CSSStyleSheet.prototype.replaceSync = s), Object.entries(i).forEach(([u, a]) => {
      a.prototype.insertRule = d[u].insertRule, a.prototype.deleteRule = d[u].deleteRule;
    });
  });
}
function An({ mirror: e, stylesheetManager: t }, r) {
  var n, o, p;
  let f = null;
  r.nodeName === "#document" ? f = e.getId(r) : f = e.getId(r.host);
  const s = r.nodeName === "#document" ? (n = r.defaultView) === null || n === void 0 ? void 0 : n.Document : (p = (o = r.ownerDocument) === null || o === void 0 ? void 0 : o.defaultView) === null || p === void 0 ? void 0 : p.ShadowRoot, i = s?.prototype ? Object.getOwnPropertyDescriptor(s?.prototype, "adoptedStyleSheets") : void 0;
  return f === null || f === -1 || !s || !i ? () => {
  } : (Object.defineProperty(r, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      var d;
      return (d = i.get) === null || d === void 0 ? void 0 : d.call(this);
    },
    set(d) {
      var u;
      const a = (u = i.set) === null || u === void 0 ? void 0 : u.call(this, d);
      if (f !== null && f !== -1)
        try {
          t.adoptStyleSheets(d, f);
        } catch {
        }
      return a;
    }
  }), $(() => {
    Object.defineProperty(r, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      get: i.get,
      set: i.set
    });
  }));
}
function fo({ styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: r, stylesheetManager: n }, { win: o }) {
  const p = o.CSSStyleDeclaration.prototype.setProperty;
  o.CSSStyleDeclaration.prototype.setProperty = new Proxy(p, {
    apply: $((s, i, d) => {
      var u;
      const [a, l, g] = d;
      if (r.has(a))
        return p.apply(i, [a, l, g]);
      const { id: c, styleId: h } = Ce((u = i.parentRule) === null || u === void 0 ? void 0 : u.parentStyleSheet, t, n.styleMirror);
      return (c && c !== -1 || h && h !== -1) && e({
        id: c,
        styleId: h,
        set: {
          property: a,
          value: l,
          priority: g
        },
        index: Lt(i.parentRule)
      }), s.apply(i, d);
    })
  });
  const f = o.CSSStyleDeclaration.prototype.removeProperty;
  return o.CSSStyleDeclaration.prototype.removeProperty = new Proxy(f, {
    apply: $((s, i, d) => {
      var u;
      const [a] = d;
      if (r.has(a))
        return f.apply(i, [a]);
      const { id: l, styleId: g } = Ce((u = i.parentRule) === null || u === void 0 ? void 0 : u.parentStyleSheet, t, n.styleMirror);
      return (l && l !== -1 || g && g !== -1) && e({
        id: l,
        styleId: g,
        remove: {
          property: a
        },
        index: Lt(i.parentRule)
      }), s.apply(i, d);
    })
  }), $(() => {
    o.CSSStyleDeclaration.prototype.setProperty = p, o.CSSStyleDeclaration.prototype.removeProperty = f;
  });
}
function ho({ mediaInteractionCb: e, blockClass: t, blockSelector: r, mirror: n, sampling: o, doc: p }) {
  const f = $((i) => ft($((d) => {
    const u = gt(d);
    if (!u || se(u, t, r, !0))
      return;
    const { currentTime: a, volume: l, muted: g, playbackRate: c, loop: h } = u;
    e({
      type: i,
      id: n.getId(u),
      currentTime: a,
      volume: l,
      muted: g,
      playbackRate: c,
      loop: h
    });
  }), o.media || 500)), s = [
    oe("play", f(0), p),
    oe("pause", f(1), p),
    oe("seeked", f(2), p),
    oe("volumechange", f(3), p),
    oe("ratechange", f(4), p)
  ];
  return $(() => {
    s.forEach((i) => i());
  });
}
function mo({ fontCb: e, doc: t }) {
  const r = t.defaultView;
  if (!r)
    return () => {
    };
  const n = [], o = /* @__PURE__ */ new WeakMap(), p = r.FontFace;
  r.FontFace = function(i, d, u) {
    const a = new p(i, d, u);
    return o.set(a, {
      family: i,
      buffer: typeof d != "string",
      descriptors: u,
      fontSource: typeof d == "string" ? d : JSON.stringify(Array.from(new Uint8Array(d)))
    }), a;
  };
  const f = it(t.fonts, "add", function(s) {
    return function(i) {
      return setTimeout($(() => {
        const d = o.get(i);
        d && (e(d), o.delete(i));
      }), 0), s.apply(this, [i]);
    };
  });
  return n.push(() => {
    r.FontFace = p;
  }), n.push(f), $(() => {
    n.forEach((s) => s());
  });
}
function go(e) {
  const { doc: t, mirror: r, blockClass: n, blockSelector: o, selectionCb: p } = e;
  let f = !0;
  const s = $(() => {
    const i = t.getSelection();
    if (!i || f && i?.isCollapsed)
      return;
    f = i.isCollapsed || !1;
    const d = [], u = i.rangeCount || 0;
    for (let a = 0; a < u; a++) {
      const l = i.getRangeAt(a), { startContainer: g, startOffset: c, endContainer: h, endOffset: b } = l;
      se(g, n, o, !0) || se(h, n, o, !0) || d.push({
        start: r.getId(g),
        startOffset: c,
        end: r.getId(h),
        endOffset: b
      });
    }
    p({ ranges: d });
  });
  return s(), oe("selectionchange", s);
}
function _o({ doc: e, customElementCb: t }) {
  const r = e.defaultView;
  return !r || !r.customElements ? () => {
  } : it(r.customElements, "define", function(o) {
    return function(p, f, s) {
      try {
        t({
          define: {
            name: p
          }
        });
      } catch {
        console.warn(`Custom element callback failed for ${p}`);
      }
      return o.apply(this, [p, f, s]);
    };
  });
}
function yo(e, t) {
  const { mutationCb: r, mousemoveCb: n, mouseInteractionCb: o, scrollCb: p, viewportResizeCb: f, inputCb: s, mediaInteractionCb: i, styleSheetRuleCb: d, styleDeclarationCb: u, canvasMutationCb: a, fontCb: l, selectionCb: g, customElementCb: c } = e;
  e.mutationCb = (...h) => {
    t.mutation && t.mutation(...h), r(...h);
  }, e.mousemoveCb = (...h) => {
    t.mousemove && t.mousemove(...h), n(...h);
  }, e.mouseInteractionCb = (...h) => {
    t.mouseInteraction && t.mouseInteraction(...h), o(...h);
  }, e.scrollCb = (...h) => {
    t.scroll && t.scroll(...h), p(...h);
  }, e.viewportResizeCb = (...h) => {
    t.viewportResize && t.viewportResize(...h), f(...h);
  }, e.inputCb = (...h) => {
    t.input && t.input(...h), s(...h);
  }, e.mediaInteractionCb = (...h) => {
    t.mediaInteaction && t.mediaInteaction(...h), i(...h);
  }, e.styleSheetRuleCb = (...h) => {
    t.styleSheetRule && t.styleSheetRule(...h), d(...h);
  }, e.styleDeclarationCb = (...h) => {
    t.styleDeclaration && t.styleDeclaration(...h), u(...h);
  }, e.canvasMutationCb = (...h) => {
    t.canvasMutation && t.canvasMutation(...h), a(...h);
  }, e.fontCb = (...h) => {
    t.font && t.font(...h), l(...h);
  }, e.selectionCb = (...h) => {
    t.selection && t.selection(...h), g(...h);
  }, e.customElementCb = (...h) => {
    t.customElement && t.customElement(...h), c(...h);
  };
}
function vo(e, t = {}) {
  const r = e.doc.defaultView;
  if (!r)
    return () => {
    };
  yo(e, t);
  let n;
  e.recordDOM && (n = Nn(e, e.doc));
  const o = so(e), p = ao(e), f = Rn(e), s = uo(e, {
    win: r
  }), i = lo(e), d = ho(e);
  let u = () => {
  }, a = () => {
  }, l = () => {
  }, g = () => {
  };
  e.recordDOM && (u = po(e, { win: r }), a = An(e, e.doc), l = fo(e, {
    win: r
  }), e.collectFonts && (g = mo(e)));
  const c = go(e), h = _o(e), b = [];
  for (const m of e.plugins)
    b.push(m.observer(m.callback, r, m.options));
  return $(() => {
    Fe.forEach((m) => m.reset()), n?.disconnect(), o(), p(), f(), s(), i(), d(), u(), a(), l(), g(), c(), h(), b.forEach((m) => m());
  });
}
function kt(e) {
  return typeof window[e] < "u";
}
function xt(e) {
  return !!(typeof window[e] < "u" && window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class Fr {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, r, n, o) {
    const p = n || this.getIdToRemoteIdMap(t), f = o || this.getRemoteIdToIdMap(t);
    let s = p.get(r);
    return s || (s = this.generateIdFn(), p.set(r, s), f.set(s, r)), s;
  }
  getIds(t, r) {
    const n = this.getIdToRemoteIdMap(t), o = this.getRemoteIdToIdMap(t);
    return r.map((p) => this.getId(t, p, n, o));
  }
  getRemoteId(t, r, n) {
    const o = n || this.getRemoteIdToIdMap(t);
    if (typeof r != "number")
      return r;
    const p = o.get(r);
    return p || -1;
  }
  getRemoteIds(t, r) {
    const n = this.getRemoteIdToIdMap(t);
    return r.map((o) => this.getRemoteId(t, o, n));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let r = this.iframeIdToRemoteIdMap.get(t);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, r)), r;
  }
  getRemoteIdToIdMap(t) {
    let r = this.iframeRemoteIdToIdMap.get(t);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, r)), r;
  }
}
class bo {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Fr(gn), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Fr(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, r) {
    var n;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: r
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), (n = this.loadListener) === null || n === void 0 || n.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }
  handleMessage(t) {
    const r = t;
    if (r.data.type !== "rrweb" || r.origin !== r.data.origin || !t.source)
      return;
    const o = this.crossOriginIframeMap.get(t.source);
    if (!o)
      return;
    const p = this.transformCrossOriginEvent(o, r.data.event);
    p && this.wrappedEmit(p, r.data.isCheckout);
  }
  transformCrossOriginEvent(t, r) {
    var n;
    switch (r.type) {
      case H.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(r.data.node, t);
        const o = r.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, o), this.patchRootIdOnNode(r.data.node, o), {
          timestamp: r.timestamp,
          type: H.IncrementalSnapshot,
          data: {
            source: B.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: r.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case H.Meta:
      case H.Load:
      case H.DomContentLoaded:
        return !1;
      case H.Plugin:
        return r;
      case H.Custom:
        return this.replaceIds(r.data.payload, t, ["id", "parentId", "previousId", "nextId"]), r;
      case H.IncrementalSnapshot:
        switch (r.data.source) {
          case B.Mutation:
            return r.data.adds.forEach((o) => {
              this.replaceIds(o, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(o.node, t);
              const p = this.crossOriginIframeRootIdMap.get(t);
              p && this.patchRootIdOnNode(o.node, p);
            }), r.data.removes.forEach((o) => {
              this.replaceIds(o, t, ["parentId", "id"]);
            }), r.data.attributes.forEach((o) => {
              this.replaceIds(o, t, ["id"]);
            }), r.data.texts.forEach((o) => {
              this.replaceIds(o, t, ["id"]);
            }), r;
          case B.Drag:
          case B.TouchMove:
          case B.MouseMove:
            return r.data.positions.forEach((o) => {
              this.replaceIds(o, t, ["id"]);
            }), r;
          case B.ViewportResize:
            return !1;
          case B.MediaInteraction:
          case B.MouseInteraction:
          case B.Scroll:
          case B.CanvasMutation:
          case B.Input:
            return this.replaceIds(r.data, t, ["id"]), r;
          case B.StyleSheetRule:
          case B.StyleDeclaration:
            return this.replaceIds(r.data, t, ["id"]), this.replaceStyleIds(r.data, t, ["styleId"]), r;
          case B.Font:
            return r;
          case B.Selection:
            return r.data.ranges.forEach((o) => {
              this.replaceIds(o, t, ["start", "end"]);
            }), r;
          case B.AdoptedStyleSheet:
            return this.replaceIds(r.data, t, ["id"]), this.replaceStyleIds(r.data, t, ["styleIds"]), (n = r.data.styles) === null || n === void 0 || n.forEach((o) => {
              this.replaceStyleIds(o, t, ["styleId"]);
            }), r;
        }
    }
    return !1;
  }
  replace(t, r, n, o) {
    for (const p of o)
      !Array.isArray(r[p]) && typeof r[p] != "number" || (Array.isArray(r[p]) ? r[p] = t.getIds(n, r[p]) : r[p] = t.getId(n, r[p]));
    return r;
  }
  replaceIds(t, r, n) {
    return this.replace(this.crossOriginIframeMirror, t, r, n);
  }
  replaceStyleIds(t, r, n) {
    return this.replace(this.crossOriginIframeStyleMirror, t, r, n);
  }
  replaceIdOnNode(t, r) {
    this.replaceIds(t, r, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, r);
    });
  }
  patchRootIdOnNode(t, r) {
    t.type !== ee.Document && !t.rootId && (t.rootId = r), "childNodes" in t && t.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, r);
    });
  }
}
class wo {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, r) {
    if (!ut(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const n = Nn(Object.assign(Object.assign({}, this.bypassOptions), { doc: r, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), t);
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(Rn(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: t, mirror: this.mirror }))), setTimeout(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, this.mirror.getId(t.host)), this.restoreHandlers.push(An({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, t));
    }, 0);
  }
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }
  patchAttachShadow(t, r) {
    const n = this;
    this.restoreHandlers.push(it(t.prototype, "attachShadow", function(o) {
      return function(p) {
        const f = o.call(this, p);
        return this.shadowRoot && On(this) && n.addShadowRoot(this.shadowRoot, r), f;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function So(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function ko(e, t, r, n) {
  function o(p) {
    return p instanceof r ? p : new r(function(f) {
      f(p);
    });
  }
  return new (r || (r = Promise))(function(p, f) {
    function s(u) {
      try {
        d(n.next(u));
      } catch (a) {
        f(a);
      }
    }
    function i(u) {
      try {
        d(n.throw(u));
      } catch (a) {
        f(a);
      }
    }
    function d(u) {
      u.done ? p(u.value) : o(u.value).then(s, i);
    }
    d((n = n.apply(e, [])).next());
  });
}
var Ye = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", xo = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Et = 0; Et < Ye.length; Et++)
  xo[Ye.charCodeAt(Et)] = Et;
var Eo = function(e) {
  var t = new Uint8Array(e), r, n = t.length, o = "";
  for (r = 0; r < n; r += 3)
    o += Ye[t[r] >> 2], o += Ye[(t[r] & 3) << 4 | t[r + 1] >> 4], o += Ye[(t[r + 1] & 15) << 2 | t[r + 2] >> 6], o += Ye[t[r + 2] & 63];
  return n % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : n % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
};
const jr = /* @__PURE__ */ new Map();
function Io(e, t) {
  let r = jr.get(e);
  return r || (r = /* @__PURE__ */ new Map(), jr.set(e, r)), r.has(t) || r.set(t, []), r.get(t);
}
const Dn = (e, t, r) => {
  if (!e || !(Pn(e, t) || typeof e == "object"))
    return;
  const n = e.constructor.name, o = Io(r, n);
  let p = o.indexOf(e);
  return p === -1 && (p = o.length, o.push(e)), p;
};
function Tt(e, t, r) {
  if (e instanceof Array)
    return e.map((n) => Tt(n, t, r));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (e instanceof ArrayBuffer) {
    const n = e.constructor.name, o = Eo(e);
    return {
      rr_type: n,
      base64: o
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          Tt(e.buffer, t, r),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const n = e.constructor.name, { src: o } = e;
      return {
        rr_type: n,
        src: o
      };
    } else if (e instanceof HTMLCanvasElement) {
      const n = "HTMLImageElement", o = e.toDataURL();
      return {
        rr_type: n,
        src: o
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [Tt(e.data, t, r), e.width, e.height]
        };
      if (Pn(e, t) || typeof e == "object") {
        const n = e.constructor.name, o = Dn(e, t, r);
        return {
          rr_type: n,
          index: o
        };
      }
    }
  }
  return e;
}
const Ln = (e, t, r) => e.map((n) => Tt(n, t, r)), Pn = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  "WebGLVertexArrayObjectOES"
].filter((o) => typeof t[o] == "function").find((o) => e instanceof t[o]);
function Co(e, t, r, n) {
  const o = [], p = Object.getOwnPropertyNames(t.CanvasRenderingContext2D.prototype);
  for (const f of p)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[f] != "function")
        continue;
      const s = it(t.CanvasRenderingContext2D.prototype, f, function(i) {
        return function(...d) {
          return se(this.canvas, r, n, !0) || setTimeout(() => {
            const u = Ln(d, t, this);
            e(this.canvas, {
              type: tt["2D"],
              property: f,
              args: u
            });
          }, 0), i.apply(this, d);
        };
      });
      o.push(s);
    } catch {
      const i = zt(t.CanvasRenderingContext2D.prototype, f, {
        set(d) {
          e(this.canvas, {
            type: tt["2D"],
            property: f,
            args: [d],
            setter: !0
          });
        }
      });
      o.push(i);
    }
  return () => {
    o.forEach((f) => f());
  };
}
function Oo(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function Br(e, t, r, n) {
  const o = [];
  try {
    const p = it(e.HTMLCanvasElement.prototype, "getContext", function(f) {
      return function(s, ...i) {
        if (!se(this, t, r, !0)) {
          const d = Oo(s);
          if ("__context" in this || (this.__context = d), n && ["webgl", "webgl2"].includes(d))
            if (i[0] && typeof i[0] == "object") {
              const u = i[0];
              u.preserveDrawingBuffer || (u.preserveDrawingBuffer = !0);
            } else
              i.splice(0, 1, {
                preserveDrawingBuffer: !0
              });
        }
        return f.apply(this, [s, ...i]);
      };
    });
    o.push(p);
  } catch {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    o.forEach((p) => p());
  };
}
function $r(e, t, r, n, o, p, f) {
  const s = [], i = Object.getOwnPropertyNames(e);
  for (const d of i)
    if (![
      "isContextLost",
      "canvas",
      "drawingBufferWidth",
      "drawingBufferHeight"
    ].includes(d))
      try {
        if (typeof e[d] != "function")
          continue;
        const u = it(e, d, function(a) {
          return function(...l) {
            const g = a.apply(this, l);
            if (Dn(g, f, this), "tagName" in this.canvas && !se(this.canvas, n, o, !0)) {
              const c = Ln(l, f, this), h = {
                type: t,
                property: d,
                args: c
              };
              r(this.canvas, h);
            }
            return g;
          };
        });
        s.push(u);
      } catch {
        const a = zt(e, d, {
          set(l) {
            r(this.canvas, {
              type: t,
              property: d,
              args: [l],
              setter: !0
            });
          }
        });
        s.push(a);
      }
  return s;
}
function To(e, t, r, n, o) {
  const p = [];
  return p.push(...$r(t.WebGLRenderingContext.prototype, tt.WebGL, e, r, n, o, t)), typeof t.WebGL2RenderingContext < "u" && p.push(...$r(t.WebGL2RenderingContext.prototype, tt.WebGL2, e, r, n, o, t)), () => {
    p.forEach((f) => f());
  };
}
function Mo(e, t) {
  var r = e.toString(), n = r.split(`
`);
  n.pop(), n.shift();
  for (var o = n[0].search(/\S/), p = /(['"])__worker_loader_strict__(['"])/g, f = 0, s = n.length; f < s; ++f)
    n[f] = n[f].substring(o).replace(p, "$1use strict$2") + `
`;
  return n;
}
function No(e, t) {
  var r = Mo(e), n = new Blob(r, { type: "application/javascript" });
  return URL.createObjectURL(n);
}
function Ro(e, t) {
  var r;
  return function(o) {
    return r = r || No(e), new Worker(r, o);
  };
}
var Ao = Ro(
  /* rollup-plugin-web-worker-loader */
  function() {
    (function() {
      "__worker_loader_strict__";
      /*! *****************************************************************************
          Copyright (c) Microsoft Corporation.
      
          Permission to use, copy, modify, and/or distribute this software for any
          purpose with or without fee is hereby granted.
      
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
          REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
          AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
          INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
          LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
          OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
          PERFORMANCE OF THIS SOFTWARE.
          ***************************************************************************** */
      function e(d, u, a, l) {
        function g(c) {
          return c instanceof a ? c : new a(function(h) {
            h(c);
          });
        }
        return new (a || (a = Promise))(function(c, h) {
          function b(y) {
            try {
              v(l.next(y));
            } catch (w) {
              h(w);
            }
          }
          function m(y) {
            try {
              v(l.throw(y));
            } catch (w) {
              h(w);
            }
          }
          function v(y) {
            y.done ? c(y.value) : g(y.value).then(b, m);
          }
          v((l = l.apply(d, [])).next());
        });
      }
      for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = typeof Uint8Array > "u" ? [] : new Uint8Array(256), n = 0; n < t.length; n++)
        r[t.charCodeAt(n)] = n;
      var o = function(d) {
        var u = new Uint8Array(d), a, l = u.length, g = "";
        for (a = 0; a < l; a += 3)
          g += t[u[a] >> 2], g += t[(u[a] & 3) << 4 | u[a + 1] >> 4], g += t[(u[a + 1] & 15) << 2 | u[a + 2] >> 6], g += t[u[a + 2] & 63];
        return l % 3 === 2 ? g = g.substring(0, g.length - 1) + "=" : l % 3 === 1 && (g = g.substring(0, g.length - 2) + "=="), g;
      };
      const p = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
      function s(d, u, a) {
        return e(this, void 0, void 0, function* () {
          const l = `${d}-${u}`;
          if ("OffscreenCanvas" in globalThis) {
            if (f.has(l))
              return f.get(l);
            const g = new OffscreenCanvas(d, u);
            g.getContext("2d");
            const h = yield (yield g.convertToBlob(a)).arrayBuffer(), b = o(h);
            return f.set(l, b), b;
          } else
            return "";
        });
      }
      const i = self;
      i.onmessage = function(d) {
        return e(this, void 0, void 0, function* () {
          if ("OffscreenCanvas" in globalThis) {
            const { id: u, bitmap: a, width: l, height: g, dataURLOptions: c } = d.data, h = s(l, g, c), b = new OffscreenCanvas(l, g);
            b.getContext("2d").drawImage(a, 0, 0), a.close();
            const v = yield b.convertToBlob(c), y = v.type, w = yield v.arrayBuffer(), E = o(w);
            if (!p.has(u) && (yield h) === E)
              return p.set(u, E), i.postMessage({ id: u });
            if (p.get(u) === E)
              return i.postMessage({ id: u });
            i.postMessage({
              id: u,
              type: y,
              base64: E,
              width: l,
              height: g
            }), p.set(u, E);
          } else
            return i.postMessage({ id: d.data.id });
        });
      };
    })();
  }
);
class Do {
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  constructor(t) {
    this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.frozen = !1, this.locked = !1, this.processMutation = (i, d) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(i) || this.pendingCanvasMutations.set(i, []), this.pendingCanvasMutations.get(i).push(d);
    };
    const { sampling: r = "all", win: n, blockClass: o, blockSelector: p, recordCanvas: f, dataURLOptions: s } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, f && r === "all" && this.initCanvasMutationObserver(n, o, p), f && typeof r == "number" && this.initCanvasFPSObserver(r, n, o, p, {
      dataURLOptions: s
    });
  }
  initCanvasFPSObserver(t, r, n, o, p) {
    const f = Br(r, n, o, !0), s = /* @__PURE__ */ new Map(), i = new Ao();
    i.onmessage = (c) => {
      const { id: h } = c.data;
      if (s.set(h, !1), !("base64" in c.data))
        return;
      const { base64: b, type: m, width: v, height: y } = c.data;
      this.mutationCb({
        id: h,
        type: tt["2D"],
        commands: [
          {
            property: "clearRect",
            args: [0, 0, v, y]
          },
          {
            property: "drawImage",
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: b }],
                    type: m
                  }
                ]
              },
              0,
              0
            ]
          }
        ]
      });
    };
    const d = 1e3 / t;
    let u = 0, a;
    const l = () => {
      const c = [];
      return r.document.querySelectorAll("canvas").forEach((h) => {
        se(h, n, o, !0) || c.push(h);
      }), c;
    }, g = (c) => {
      if (u && c - u < d) {
        a = requestAnimationFrame(g);
        return;
      }
      u = c, l().forEach((h) => ko(this, void 0, void 0, function* () {
        var b;
        const m = this.mirror.getId(h);
        if (s.get(m) || h.width === 0 || h.height === 0)
          return;
        if (s.set(m, !0), ["webgl", "webgl2"].includes(h.__context)) {
          const y = h.getContext(h.__context);
          ((b = y?.getContextAttributes()) === null || b === void 0 ? void 0 : b.preserveDrawingBuffer) === !1 && y.clear(y.COLOR_BUFFER_BIT);
        }
        const v = yield createImageBitmap(h);
        i.postMessage({
          id: m,
          bitmap: v,
          width: h.width,
          height: h.height,
          dataURLOptions: p.dataURLOptions
        }, [v]);
      })), a = requestAnimationFrame(g);
    };
    a = requestAnimationFrame(g), this.resetObservers = () => {
      f(), cancelAnimationFrame(a);
    };
  }
  initCanvasMutationObserver(t, r, n) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const o = Br(t, r, n, !1), p = Co(this.processMutation.bind(this), t, r, n), f = To(this.processMutation.bind(this), t, r, n, this.mirror);
    this.resetObservers = () => {
      o(), p(), f();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (r) => {
      this.rafStamps.latestId = r, requestAnimationFrame(t);
    };
    requestAnimationFrame(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((t, r) => {
      const n = this.mirror.getId(r);
      this.flushPendingCanvasMutationFor(r, n);
    }), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, r) {
    if (this.frozen || this.locked)
      return;
    const n = this.pendingCanvasMutations.get(t);
    if (!n || r === -1)
      return;
    const o = n.map((f) => So(f, ["type"])), { type: p } = n[0];
    this.mutationCb({ id: r, type: p, commands: o }), this.pendingCanvasMutations.delete(t);
  }
}
class Lo {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new Zi(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, r) {
    "_cssText" in r.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: r.id,
          attributes: r.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, r) {
    if (t.length === 0)
      return;
    const n = {
      id: r,
      styleIds: []
    }, o = [];
    for (const p of t) {
      let f;
      this.styleMirror.has(p) ? f = this.styleMirror.getId(p) : (f = this.styleMirror.add(p), o.push({
        styleId: f,
        rules: Array.from(p.rules || CSSRule, (s, i) => ({
          rule: fn(s),
          index: i
        }))
      })), n.styleIds.push(f);
    }
    o.length > 0 && (n.styles = o), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(t) {
  }
}
class Po {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    requestAnimationFrame(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(t, r) {
    const n = this.nodeMap.get(t);
    return n && Array.from(n).some((o) => o !== r);
  }
  add(t, r) {
    this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(r));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
}
function Z(e) {
  return Object.assign(Object.assign({}, e), { timestamp: Dt() });
}
let K, Mt, Zt, Pt = !1;
const de = Oi();
function _t(e = {}) {
  const { emit: t, checkoutEveryNms: r, checkoutEveryNth: n, blockClass: o = "rr-block", blockSelector: p = null, ignoreClass: f = "rr-ignore", ignoreSelector: s = null, maskTextClass: i = "rr-mask", maskTextSelector: d = null, inlineStylesheet: u = !0, maskAllInputs: a, maskInputOptions: l, slimDOMOptions: g, maskInputFn: c, maskTextFn: h, hooks: b, packFn: m, sampling: v = {}, dataURLOptions: y = {}, mousemoveWait: w, recordDOM: E = !0, recordCanvas: C = !1, recordCrossOriginIframes: k = !1, recordAfter: S = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load", userTriggeredOnInput: O = !1, collectFonts: T = !1, inlineImages: x = !1, plugins: I, keepIframeSrcFn: R = () => !1, ignoreCSSAttributes: N = /* @__PURE__ */ new Set([]), errorHandler: D } = e;
  io(D);
  const A = k ? window.parent === window : !0;
  let L = !1;
  if (!A)
    try {
      window.parent.document && (L = !1);
    } catch {
      L = !0;
    }
  if (A && !t)
    throw new Error("emit function is required");
  w !== void 0 && v.mousemove === void 0 && (v.mousemove = w), de.reset();
  const q = a === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : l !== void 0 ? l : { password: !0 }, te = g === !0 || g === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: g === "all",
    headMetaDescKeywords: g === "all"
  } : g || {};
  Qi();
  let Ee, Pe = 0;
  const Ie = (F) => {
    for (const pe of I || [])
      pe.eventProcessor && (F = pe.eventProcessor(F));
    return m && !L && (F = m(F)), F;
  };
  K = (F, pe) => {
    var Y;
    if (!((Y = Fe[0]) === null || Y === void 0) && Y.isFrozen() && F.type !== H.FullSnapshot && !(F.type === H.IncrementalSnapshot && F.data.source === B.Mutation) && Fe.forEach((ie) => ie.unfreeze()), A)
      t?.(Ie(F), pe);
    else if (L) {
      const ie = {
        type: "rrweb",
        event: Ie(F),
        origin: window.location.origin,
        isCheckout: pe
      };
      window.parent.postMessage(ie, "*");
    }
    if (F.type === H.FullSnapshot)
      Ee = F, Pe = 0;
    else if (F.type === H.IncrementalSnapshot) {
      if (F.data.source === B.Mutation && F.data.isAttachIframe)
        return;
      Pe++;
      const ie = n && Pe >= n, qe = r && F.timestamp - Ee.timestamp > r;
      (ie || qe) && Mt(!0);
    }
  };
  const ce = (F) => {
    K(Z({
      type: H.IncrementalSnapshot,
      data: Object.assign({ source: B.Mutation }, F)
    }));
  }, bt = (F) => K(Z({
    type: H.IncrementalSnapshot,
    data: Object.assign({ source: B.Scroll }, F)
  })), be = (F) => K(Z({
    type: H.IncrementalSnapshot,
    data: Object.assign({ source: B.CanvasMutation }, F)
  })), wt = (F) => K(Z({
    type: H.IncrementalSnapshot,
    data: Object.assign({ source: B.AdoptedStyleSheet }, F)
  })), re = new Lo({
    mutationCb: ce,
    adoptedStyleSheetCb: wt
  }), Ue = new bo({
    mirror: de,
    mutationCb: ce,
    stylesheetManager: re,
    recordCrossOriginIframes: k,
    wrappedEmit: K
  });
  for (const F of I || [])
    F.getMirror && F.getMirror({
      nodeMirror: de,
      crossOriginIframeMirror: Ue.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Ue.crossOriginIframeStyleMirror
    });
  const Yt = new Po();
  Zt = new Do({
    recordCanvas: C,
    mutationCb: be,
    win: window,
    blockClass: o,
    blockSelector: p,
    mirror: de,
    sampling: v.canvas,
    dataURLOptions: y
  });
  const St = new wo({
    mutationCb: ce,
    scrollCb: bt,
    bypassOptions: {
      blockClass: o,
      blockSelector: p,
      maskTextClass: i,
      maskTextSelector: d,
      inlineStylesheet: u,
      maskInputOptions: q,
      dataURLOptions: y,
      maskTextFn: h,
      maskInputFn: c,
      recordCanvas: C,
      inlineImages: x,
      sampling: v,
      slimDOMOptions: te,
      iframeManager: Ue,
      stylesheetManager: re,
      canvasManager: Zt,
      keepIframeSrcFn: R,
      processedNodeManager: Yt
    },
    mirror: de
  });
  Mt = (F = !1) => {
    if (!E)
      return;
    K(Z({
      type: H.Meta,
      data: {
        href: window.location.href,
        width: Sn(),
        height: wn()
      }
    }), F), re.reset(), St.init(), Fe.forEach((Y) => Y.lock());
    const pe = Yi(document, {
      mirror: de,
      blockClass: o,
      blockSelector: p,
      maskTextClass: i,
      maskTextSelector: d,
      inlineStylesheet: u,
      maskAllInputs: q,
      maskTextFn: h,
      slimDOM: te,
      dataURLOptions: y,
      recordCanvas: C,
      inlineImages: x,
      onSerialize: (Y) => {
        En(Y, de) && Ue.addIframe(Y), In(Y, de) && re.trackLinkElement(Y), sr(Y) && St.addShadowRoot(Y.shadowRoot, document);
      },
      onIframeLoad: (Y, ie) => {
        Ue.attachIframe(Y, ie), St.observeAttachShadow(Y);
      },
      onStylesheetLoad: (Y, ie) => {
        re.attachLinkElement(Y, ie);
      },
      keepIframeSrcFn: R
    });
    if (!pe)
      return console.warn("Failed to snapshot the document");
    K(Z({
      type: H.FullSnapshot,
      data: {
        node: pe,
        initialOffset: bn(window)
      }
    }), F), Fe.forEach((Y) => Y.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && re.adoptStyleSheets(document.adoptedStyleSheets, de.getId(document));
  };
  try {
    const F = [], pe = (ie) => {
      var qe;
      return $(vo)({
        mutationCb: ce,
        mousemoveCb: (V, Kt) => K(Z({
          type: H.IncrementalSnapshot,
          data: {
            source: Kt,
            positions: V
          }
        })),
        mouseInteractionCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.MouseInteraction }, V)
        })),
        scrollCb: bt,
        viewportResizeCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.ViewportResize }, V)
        })),
        inputCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.Input }, V)
        })),
        mediaInteractionCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.MediaInteraction }, V)
        })),
        styleSheetRuleCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.StyleSheetRule }, V)
        })),
        styleDeclarationCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.StyleDeclaration }, V)
        })),
        canvasMutationCb: be,
        fontCb: (V) => K(Z({
          type: H.IncrementalSnapshot,
          data: Object.assign({ source: B.Font }, V)
        })),
        selectionCb: (V) => {
          K(Z({
            type: H.IncrementalSnapshot,
            data: Object.assign({ source: B.Selection }, V)
          }));
        },
        customElementCb: (V) => {
          K(Z({
            type: H.IncrementalSnapshot,
            data: Object.assign({ source: B.CustomElement }, V)
          }));
        },
        blockClass: o,
        ignoreClass: f,
        ignoreSelector: s,
        maskTextClass: i,
        maskTextSelector: d,
        maskInputOptions: q,
        inlineStylesheet: u,
        sampling: v,
        recordDOM: E,
        recordCanvas: C,
        inlineImages: x,
        userTriggeredOnInput: O,
        collectFonts: T,
        doc: ie,
        maskInputFn: c,
        maskTextFn: h,
        keepIframeSrcFn: R,
        blockSelector: p,
        slimDOMOptions: te,
        dataURLOptions: y,
        mirror: de,
        iframeManager: Ue,
        stylesheetManager: re,
        shadowDomManager: St,
        processedNodeManager: Yt,
        canvasManager: Zt,
        ignoreCSSAttributes: N,
        plugins: ((qe = I?.filter((V) => V.observer)) === null || qe === void 0 ? void 0 : qe.map((V) => ({
          observer: V.observer,
          options: V.options,
          callback: (Kt) => K(Z({
            type: H.Plugin,
            data: {
              plugin: V.name,
              payload: Kt
            }
          }))
        }))) || []
      }, b);
    };
    Ue.addLoadListener((ie) => {
      try {
        F.push(pe(ie.contentDocument));
      } catch (qe) {
        console.warn(qe);
      }
    });
    const Y = () => {
      Mt(), F.push(pe(document)), Pt = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? Y() : (F.push(oe("DOMContentLoaded", () => {
      K(Z({
        type: H.DomContentLoaded,
        data: {}
      })), S === "DOMContentLoaded" && Y();
    })), F.push(oe("load", () => {
      K(Z({
        type: H.Load,
        data: {}
      })), S === "load" && Y();
    }, window))), () => {
      F.forEach((ie) => ie()), Yt.destroy(), Pt = !1, oo();
    };
  } catch (F) {
    console.warn(F);
  }
}
_t.addCustomEvent = (e, t) => {
  if (!Pt)
    throw new Error("please add custom event after start recording");
  K(Z({
    type: H.Custom,
    data: {
      tag: e,
      payload: t
    }
  }));
};
_t.freezePage = () => {
  Fe.forEach((e) => e.freeze());
};
_t.takeFullSnapshot = (e) => {
  if (!Pt)
    throw new Error("please take full snapshot after start recording");
  Mt(e);
};
_t.mirror = de;
var Un = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(Un || {}), ge = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(ge || {}), ye = {
  DEBUG: !1,
  LIB_VERSION: "2.56.0"
}, P;
if (typeof window > "u") {
  var Hr = {
    hostname: ""
  };
  P = {
    navigator: { userAgent: "", onLine: !0 },
    document: {
      location: Hr,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: Hr
  };
} else
  P = window;
var lt = 24 * 60 * 60 * 1e3, er = 8 * 1e3, Gt = Array.prototype, Uo = Function.prototype, qn = Object.prototype, Oe = Gt.slice, yt = qn.toString, Jt = qn.hasOwnProperty, Q = P.console, Te = P.navigator, G = P.document, It = P.opera, Ut = P.screen, _e = Te.userAgent, tr = Uo.bind, Wr = Gt.forEach, zr = Gt.indexOf, Gr = Gt.map, qo = Array.isArray, ur = {}, _ = {
  trim: function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, z = {
  /** @type {function(...*)} */
  log: function() {
    if (ye.DEBUG && !_.isUndefined(Q) && Q)
      try {
        Q.log.apply(Q, arguments);
      } catch {
        _.each(arguments, function(t) {
          Q.log(t);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (ye.DEBUG && !_.isUndefined(Q) && Q) {
      var e = ["Mixpanel warning:"].concat(_.toArray(arguments));
      try {
        Q.warn.apply(Q, e);
      } catch {
        _.each(e, function(r) {
          Q.warn(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (ye.DEBUG && !_.isUndefined(Q) && Q) {
      var e = ["Mixpanel error:"].concat(_.toArray(arguments));
      try {
        Q.error.apply(Q, e);
      } catch {
        _.each(e, function(r) {
          Q.error(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!_.isUndefined(Q) && Q) {
      var e = ["Mixpanel error:"].concat(_.toArray(arguments));
      try {
        Q.error.apply(Q, e);
      } catch {
        _.each(e, function(r) {
          Q.error(r);
        });
      }
    }
  }
}, rr = function(e, t) {
  return function() {
    return arguments[0] = "[" + t + "] " + arguments[0], e.apply(z, arguments);
  };
}, vt = function(e) {
  return {
    log: rr(z.log, e),
    error: rr(z.error, e),
    critical: rr(z.critical, e)
  };
};
_.bind = function(e, t) {
  var r, n;
  if (tr && e.bind === tr)
    return tr.apply(e, Oe.call(arguments, 1));
  if (!_.isFunction(e))
    throw new TypeError();
  return r = Oe.call(arguments, 2), n = function() {
    if (!(this instanceof n))
      return e.apply(t, r.concat(Oe.call(arguments)));
    var o = {};
    o.prototype = e.prototype;
    var p = new o();
    o.prototype = null;
    var f = e.apply(p, r.concat(Oe.call(arguments)));
    return Object(f) === f ? f : p;
  }, n;
};
_.each = function(e, t, r) {
  if (e != null) {
    if (Wr && e.forEach === Wr)
      e.forEach(t, r);
    else if (e.length === +e.length) {
      for (var n = 0, o = e.length; n < o; n++)
        if (n in e && t.call(r, e[n], n, e) === ur)
          return;
    } else
      for (var p in e)
        if (Jt.call(e, p) && t.call(r, e[p], p, e) === ur)
          return;
  }
};
_.extend = function(e) {
  return _.each(Oe.call(arguments, 1), function(t) {
    for (var r in t)
      t[r] !== void 0 && (e[r] = t[r]);
  }), e;
};
_.isArray = qo || function(e) {
  return yt.call(e) === "[object Array]";
};
_.isFunction = function(e) {
  try {
    return /^\s*\bfunction\b/.test(e);
  } catch {
    return !1;
  }
};
_.isArguments = function(e) {
  return !!(e && Jt.call(e, "callee"));
};
_.toArray = function(e) {
  return e ? e.toArray ? e.toArray() : _.isArray(e) || _.isArguments(e) ? Oe.call(e) : _.values(e) : [];
};
_.map = function(e, t, r) {
  if (Gr && e.map === Gr)
    return e.map(t, r);
  var n = [];
  return _.each(e, function(o) {
    n.push(t.call(r, o));
  }), n;
};
_.keys = function(e) {
  var t = [];
  return e === null || _.each(e, function(r, n) {
    t[t.length] = n;
  }), t;
};
_.values = function(e) {
  var t = [];
  return e === null || _.each(e, function(r) {
    t[t.length] = r;
  }), t;
};
_.include = function(e, t) {
  var r = !1;
  return e === null ? r : zr && e.indexOf === zr ? e.indexOf(t) != -1 : (_.each(e, function(n) {
    if (r || (r = n === t))
      return ur;
  }), r);
};
_.includes = function(e, t) {
  return e.indexOf(t) !== -1;
};
_.inherit = function(e, t) {
  return e.prototype = new t(), e.prototype.constructor = e, e.superclass = t.prototype, e;
};
_.isObject = function(e) {
  return e === Object(e) && !_.isArray(e);
};
_.isEmptyObject = function(e) {
  if (_.isObject(e)) {
    for (var t in e)
      if (Jt.call(e, t))
        return !1;
    return !0;
  }
  return !1;
};
_.isUndefined = function(e) {
  return e === void 0;
};
_.isString = function(e) {
  return yt.call(e) == "[object String]";
};
_.isDate = function(e) {
  return yt.call(e) == "[object Date]";
};
_.isNumber = function(e) {
  return yt.call(e) == "[object Number]";
};
_.isElement = function(e) {
  return !!(e && e.nodeType === 1);
};
_.encodeDates = function(e) {
  return _.each(e, function(t, r) {
    _.isDate(t) ? e[r] = _.formatDate(t) : _.isObject(t) && (e[r] = _.encodeDates(t));
  }), e;
};
_.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
_.formatDate = function(e) {
  function t(r) {
    return r < 10 ? "0" + r : r;
  }
  return e.getUTCFullYear() + "-" + t(e.getUTCMonth() + 1) + "-" + t(e.getUTCDate()) + "T" + t(e.getUTCHours()) + ":" + t(e.getUTCMinutes()) + ":" + t(e.getUTCSeconds());
};
_.strip_empty_properties = function(e) {
  var t = {};
  return _.each(e, function(r, n) {
    _.isString(r) && r.length > 0 && (t[n] = r);
  }), t;
};
_.truncate = function(e, t) {
  var r;
  return typeof e == "string" ? r = e.slice(0, t) : _.isArray(e) ? (r = [], _.each(e, function(n) {
    r.push(_.truncate(n, t));
  })) : _.isObject(e) ? (r = {}, _.each(e, function(n, o) {
    r[o] = _.truncate(n, t);
  })) : r = e, r;
};
_.JSONEncode = /* @__PURE__ */ function() {
  return function(e) {
    var t = e, r = function(o) {
      var p = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, f = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return p.lastIndex = 0, p.test(o) ? '"' + o.replace(p, function(s) {
        var i = f[s];
        return typeof i == "string" ? i : "\\u" + ("0000" + s.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + o + '"';
    }, n = function(o, p) {
      var f = "", s = "    ", i = 0, d = "", u = "", a = 0, l = f, g = [], c = p[o];
      switch (c && typeof c == "object" && typeof c.toJSON == "function" && (c = c.toJSON(o)), typeof c) {
        case "string":
          return r(c);
        case "number":
          return isFinite(c) ? String(c) : "null";
        case "boolean":
        case "null":
          return String(c);
        case "object":
          if (!c)
            return "null";
          if (f += s, g = [], yt.apply(c) === "[object Array]") {
            for (a = c.length, i = 0; i < a; i += 1)
              g[i] = n(i, c) || "null";
            return u = g.length === 0 ? "[]" : f ? `[
` + f + g.join(`,
` + f) + `
` + l + "]" : "[" + g.join(",") + "]", f = l, u;
          }
          for (d in c)
            Jt.call(c, d) && (u = n(d, c), u && g.push(r(d) + (f ? ": " : ":") + u));
          return u = g.length === 0 ? "{}" : f ? "{" + g.join(",") + l + "}" : "{" + g.join(",") + "}", f = l, u;
      }
    };
    return n("", {
      "": t
    });
  };
}();
_.JSONDecode = function() {
  var e, t, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n, o = function(g) {
    var c = new SyntaxError(g);
    throw c.at = e, c.text = n, c;
  }, p = function(g) {
    return g && g !== t && o("Expected '" + g + "' instead of '" + t + "'"), t = n.charAt(e), e += 1, t;
  }, f = function() {
    var g, c = "";
    for (t === "-" && (c = "-", p("-")); t >= "0" && t <= "9"; )
      c += t, p();
    if (t === ".")
      for (c += "."; p() && t >= "0" && t <= "9"; )
        c += t;
    if (t === "e" || t === "E")
      for (c += t, p(), (t === "-" || t === "+") && (c += t, p()); t >= "0" && t <= "9"; )
        c += t, p();
    if (g = +c, !isFinite(g))
      o("Bad number");
    else
      return g;
  }, s = function() {
    var g, c, h = "", b;
    if (t === '"')
      for (; p(); ) {
        if (t === '"')
          return p(), h;
        if (t === "\\")
          if (p(), t === "u") {
            for (b = 0, c = 0; c < 4 && (g = parseInt(p(), 16), !!isFinite(g)); c += 1)
              b = b * 16 + g;
            h += String.fromCharCode(b);
          } else if (typeof r[t] == "string")
            h += r[t];
          else
            break;
        else
          h += t;
      }
    o("Bad string");
  }, i = function() {
    for (; t && t <= " "; )
      p();
  }, d = function() {
    switch (t) {
      case "t":
        return p("t"), p("r"), p("u"), p("e"), !0;
      case "f":
        return p("f"), p("a"), p("l"), p("s"), p("e"), !1;
      case "n":
        return p("n"), p("u"), p("l"), p("l"), null;
    }
    o('Unexpected "' + t + '"');
  }, u, a = function() {
    var g = [];
    if (t === "[") {
      if (p("["), i(), t === "]")
        return p("]"), g;
      for (; t; ) {
        if (g.push(u()), i(), t === "]")
          return p("]"), g;
        p(","), i();
      }
    }
    o("Bad array");
  }, l = function() {
    var g, c = {};
    if (t === "{") {
      if (p("{"), i(), t === "}")
        return p("}"), c;
      for (; t; ) {
        if (g = s(), i(), p(":"), Object.hasOwnProperty.call(c, g) && o('Duplicate key "' + g + '"'), c[g] = u(), i(), t === "}")
          return p("}"), c;
        p(","), i();
      }
    }
    o("Bad object");
  };
  return u = function() {
    switch (i(), t) {
      case "{":
        return l();
      case "[":
        return a();
      case '"':
        return s();
      case "-":
        return f();
      default:
        return t >= "0" && t <= "9" ? f() : d();
    }
  }, function(g) {
    var c;
    return n = g, e = 0, t = " ", c = u(), i(), t && o("Syntax error"), c;
  };
}();
_.base64Encode = function(e) {
  var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r, n, o, p, f, s, i, d, u = 0, a = 0, l = "", g = [];
  if (!e)
    return e;
  e = _.utf8Encode(e);
  do
    r = e.charCodeAt(u++), n = e.charCodeAt(u++), o = e.charCodeAt(u++), d = r << 16 | n << 8 | o, p = d >> 18 & 63, f = d >> 12 & 63, s = d >> 6 & 63, i = d & 63, g[a++] = t.charAt(p) + t.charAt(f) + t.charAt(s) + t.charAt(i);
  while (u < e.length);
  switch (l = g.join(""), e.length % 3) {
    case 1:
      l = l.slice(0, -2) + "==";
      break;
    case 2:
      l = l.slice(0, -1) + "=";
      break;
  }
  return l;
};
_.utf8Encode = function(e) {
  e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var t = "", r, n, o = 0, p;
  for (r = n = 0, o = e.length, p = 0; p < o; p++) {
    var f = e.charCodeAt(p), s = null;
    f < 128 ? n++ : f > 127 && f < 2048 ? s = String.fromCharCode(f >> 6 | 192, f & 63 | 128) : s = String.fromCharCode(f >> 12 | 224, f >> 6 & 63 | 128, f & 63 | 128), s !== null && (n > r && (t += e.substring(r, n)), t += s, r = n = p + 1);
  }
  return n > r && (t += e.substring(r, e.length)), t;
};
_.UUID = /* @__PURE__ */ function() {
  var e = function() {
    var n = 1 * /* @__PURE__ */ new Date(), o;
    if (P.performance && P.performance.now)
      o = P.performance.now();
    else
      for (o = 0; n == 1 * /* @__PURE__ */ new Date(); )
        o++;
    return n.toString(16) + Math.floor(o).toString(16);
  }, t = function() {
    return Math.random().toString(16).replace(".", "");
  }, r = function() {
    var n = _e, o, p, f = [], s = 0;
    function i(d, u) {
      var a, l = 0;
      for (a = 0; a < u.length; a++)
        l |= f[a] << a * 8;
      return d ^ l;
    }
    for (o = 0; o < n.length; o++)
      p = n.charCodeAt(o), f.unshift(p & 255), f.length >= 4 && (s = i(s, f), f = []);
    return f.length > 0 && (s = i(s, f)), s.toString(16);
  };
  return function() {
    var n = (Ut.height * Ut.width).toString(16);
    return e() + "-" + t() + "-" + r() + "-" + n + "-" + e();
  };
}();
var Jr = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandexbot",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
_.isBlockedUA = function(e) {
  var t;
  for (e = e.toLowerCase(), t = 0; t < Jr.length; t++)
    if (e.indexOf(Jr[t]) !== -1)
      return !0;
  return !1;
};
_.HTTPBuildQuery = function(e, t) {
  var r, n, o = [];
  return _.isUndefined(t) && (t = "&"), _.each(e, function(p, f) {
    r = encodeURIComponent(p.toString()), n = encodeURIComponent(f), o[o.length] = n + "=" + r;
  }), o.join(t);
};
_.getQueryParam = function(e, t) {
  t = t.replace(/[[]/g, "\\[").replace(/[\]]/g, "\\]");
  var r = "[\\?&]" + t + "=([^&#]*)", n = new RegExp(r), o = n.exec(e);
  if (o === null || o && typeof o[1] != "string" && o[1].length)
    return "";
  var p = o[1];
  try {
    p = decodeURIComponent(p);
  } catch {
    z.error("Skipping decoding for malformed query param: " + p);
  }
  return p.replace(/\+/g, " ");
};
_.cookie = {
  get: function(e) {
    for (var t = e + "=", r = G.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var o = r[n]; o.charAt(0) == " "; )
        o = o.substring(1, o.length);
      if (o.indexOf(t) === 0)
        return decodeURIComponent(o.substring(t.length, o.length));
    }
    return null;
  },
  parse: function(e) {
    var t;
    try {
      t = _.JSONDecode(_.cookie.get(e)) || {};
    } catch {
    }
    return t;
  },
  set_seconds: function(e, t, r, n, o, p, f) {
    var s = "", i = "", d = "";
    if (f)
      s = "; domain=" + f;
    else if (n) {
      var u = Vr(G.location.hostname);
      s = u ? "; domain=." + u : "";
    }
    if (r) {
      var a = /* @__PURE__ */ new Date();
      a.setTime(a.getTime() + r * 1e3), i = "; expires=" + a.toGMTString();
    }
    p && (o = !0, d = "; SameSite=None"), o && (d += "; secure"), G.cookie = e + "=" + encodeURIComponent(t) + i + "; path=/" + s + d;
  },
  set: function(e, t, r, n, o, p, f) {
    var s = "", i = "", d = "";
    if (f)
      s = "; domain=" + f;
    else if (n) {
      var u = Vr(G.location.hostname);
      s = u ? "; domain=." + u : "";
    }
    if (r) {
      var a = /* @__PURE__ */ new Date();
      a.setTime(a.getTime() + r * 24 * 60 * 60 * 1e3), i = "; expires=" + a.toGMTString();
    }
    p && (o = !0, d = "; SameSite=None"), o && (d += "; secure");
    var l = e + "=" + encodeURIComponent(t) + i + "; path=/" + s + d;
    return G.cookie = l, l;
  },
  remove: function(e, t, r) {
    _.cookie.set(e, "", -1, t, !1, !1, r);
  }
};
var nr = null, qt = function(e, t) {
  if (nr !== null && !t)
    return nr;
  var r = !0;
  try {
    e = e || window.localStorage;
    var n = "__mplss_" + fr(8), o = "xyz";
    e.setItem(n, o), e.getItem(n) !== o && (r = !1), e.removeItem(n);
  } catch {
    r = !1;
  }
  return nr = r, r;
};
_.localStorage = {
  is_supported: function(e) {
    var t = qt(null, e);
    return t || z.error("localStorage unsupported; falling back to cookie store"), t;
  },
  error: function(e) {
    z.error("localStorage error: " + e);
  },
  get: function(e) {
    try {
      return window.localStorage.getItem(e);
    } catch (t) {
      _.localStorage.error(t);
    }
    return null;
  },
  parse: function(e) {
    try {
      return _.JSONDecode(_.localStorage.get(e)) || {};
    } catch {
    }
    return null;
  },
  set: function(e, t) {
    try {
      window.localStorage.setItem(e, t);
    } catch (r) {
      _.localStorage.error(r);
    }
  },
  remove: function(e) {
    try {
      window.localStorage.removeItem(e);
    } catch (t) {
      _.localStorage.error(t);
    }
  }
};
_.register_event = function() {
  var e = function(n, o, p, f, s) {
    if (!n) {
      z.error("No valid element provided to register_event");
      return;
    }
    if (n.addEventListener && !f)
      n.addEventListener(o, p, !!s);
    else {
      var i = "on" + o, d = n[i];
      n[i] = t(n, p, d);
    }
  };
  function t(n, o, p) {
    var f = function(s) {
      if (s = s || r(window.event), !!s) {
        var i = !0, d, u;
        return _.isFunction(p) && (d = p(s)), u = o.call(n, s), (d === !1 || u === !1) && (i = !1), i;
      }
    };
    return f;
  }
  function r(n) {
    return n && (n.preventDefault = r.preventDefault, n.stopPropagation = r.stopPropagation), n;
  }
  return r.preventDefault = function() {
    this.returnValue = !1;
  }, r.stopPropagation = function() {
    this.cancelBubble = !0;
  }, e;
}();
var Fo = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
_.dom_query = /* @__PURE__ */ function() {
  function e(o) {
    return o.all ? o.all : o.getElementsByTagName("*");
  }
  var t = /[\t\r\n]/g;
  function r(o, p) {
    var f = " " + p + " ";
    return (" " + o.className + " ").replace(t, " ").indexOf(f) >= 0;
  }
  function n(o) {
    if (!G.getElementsByTagName)
      return [];
    var p = o.split(" "), f, s, i, d, u, a, l, g, c, h, b = [G];
    for (a = 0; a < p.length; a++) {
      if (f = p[a].replace(/^\s+/, "").replace(/\s+$/, ""), f.indexOf("#") > -1) {
        s = f.split("#"), i = s[0];
        var m = s[1], v = G.getElementById(m);
        if (!v || i && v.nodeName.toLowerCase() != i)
          return [];
        b = [v];
        continue;
      }
      if (f.indexOf(".") > -1) {
        s = f.split("."), i = s[0];
        var y = s[1];
        for (i || (i = "*"), d = [], u = 0, l = 0; l < b.length; l++)
          for (i == "*" ? c = e(b[l]) : c = b[l].getElementsByTagName(i), g = 0; g < c.length; g++)
            d[u++] = c[g];
        for (b = [], h = 0, l = 0; l < d.length; l++)
          d[l].className && _.isString(d[l].className) && // some SVG elements have classNames which are not strings
          r(d[l], y) && (b[h++] = d[l]);
        continue;
      }
      var w = f.match(Fo);
      if (w) {
        i = w[1];
        var E = w[2], C = w[3], k = w[4];
        for (i || (i = "*"), d = [], u = 0, l = 0; l < b.length; l++)
          for (i == "*" ? c = e(b[l]) : c = b[l].getElementsByTagName(i), g = 0; g < c.length; g++)
            d[u++] = c[g];
        b = [], h = 0;
        var S;
        switch (C) {
          case "=":
            S = function(O) {
              return O.getAttribute(E) == k;
            };
            break;
          case "~":
            S = function(O) {
              return O.getAttribute(E).match(new RegExp("\\b" + k + "\\b"));
            };
            break;
          case "|":
            S = function(O) {
              return O.getAttribute(E).match(new RegExp("^" + k + "-?"));
            };
            break;
          case "^":
            S = function(O) {
              return O.getAttribute(E).indexOf(k) === 0;
            };
            break;
          case "$":
            S = function(O) {
              return O.getAttribute(E).lastIndexOf(k) == O.getAttribute(E).length - k.length;
            };
            break;
          case "*":
            S = function(O) {
              return O.getAttribute(E).indexOf(k) > -1;
            };
            break;
          default:
            S = function(O) {
              return O.getAttribute(E);
            };
        }
        for (b = [], h = 0, l = 0; l < d.length; l++)
          S(d[l]) && (b[h++] = d[l]);
        continue;
      }
      for (i = f, d = [], u = 0, l = 0; l < b.length; l++)
        for (c = b[l].getElementsByTagName(i), g = 0; g < c.length; g++)
          d[u++] = c[g];
      b = d;
    }
    return b;
  }
  return function(o) {
    return _.isElement(o) ? [o] : _.isObject(o) && !_.isUndefined(o.length) ? o : n.call(this, o);
  };
}();
var jo = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "utm_source_platform", "utm_campaign_id", "utm_creative_format", "utm_marketing_tactic"], Bo = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "sccid", "ttclid", "twclid", "wbraid"];
_.info = {
  campaignParams: function(e) {
    var t = "", r = {};
    return _.each(jo, function(n) {
      t = _.getQueryParam(G.URL, n), t.length ? r[n] = t : e !== void 0 && (r[n] = e);
    }), r;
  },
  clickParams: function() {
    var e = "", t = {};
    return _.each(Bo, function(r) {
      e = _.getQueryParam(G.URL, r), e.length && (t[r] = e);
    }), t;
  },
  marketingParams: function() {
    return _.extend(_.info.campaignParams(), _.info.clickParams());
  },
  searchEngine: function(e) {
    return e.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : e.search("https?://(.*)bing.com") === 0 ? "bing" : e.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : e.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(e) {
    var t = _.info.searchEngine(e), r = t != "yahoo" ? "q" : "p", n = {};
    if (t !== null) {
      n.$search_engine = t;
      var o = _.getQueryParam(e, r);
      o.length && (n.mp_keyword = o);
    }
    return n;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(e, t, r) {
    return t = t || "", r || _.includes(e, " OPR/") ? _.includes(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : _.includes(e, "IEMobile") || _.includes(e, "WPDesktop") ? "Internet Explorer Mobile" : _.includes(e, "SamsungBrowser/") ? "Samsung Internet" : _.includes(e, "Edge") || _.includes(e, "Edg/") ? "Microsoft Edge" : _.includes(e, "FBIOS") ? "Facebook Mobile" : _.includes(e, "Chrome") ? "Chrome" : _.includes(e, "CriOS") ? "Chrome iOS" : _.includes(e, "UCWEB") || _.includes(e, "UCBrowser") ? "UC Browser" : _.includes(e, "FxiOS") ? "Firefox iOS" : _.includes(t, "Apple") ? _.includes(e, "Mobile") ? "Mobile Safari" : "Safari" : _.includes(e, "Android") ? "Android Mobile" : _.includes(e, "Konqueror") ? "Konqueror" : _.includes(e, "Firefox") ? "Firefox" : _.includes(e, "MSIE") || _.includes(e, "Trident/") ? "Internet Explorer" : _.includes(e, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(e, t, r) {
    var n = _.info.browser(e, t, r), o = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, p = o[n];
    if (p === void 0)
      return null;
    var f = e.match(p);
    return f ? parseFloat(f[f.length - 2]) : null;
  },
  os: function() {
    var e = _e;
    return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
  },
  device: function(e) {
    return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
  },
  referringDomain: function(e) {
    var t = e.split("/");
    return t.length >= 3 ? t[2] : "";
  },
  currentUrl: function() {
    return P.location.href;
  },
  properties: function(e) {
    return typeof e != "object" && (e = {}), _.extend(_.strip_empty_properties({
      $os: _.info.os(),
      $browser: _.info.browser(_e, Te.vendor, It),
      $referrer: G.referrer,
      $referring_domain: _.info.referringDomain(G.referrer),
      $device: _.info.device(_e)
    }), {
      $current_url: _.info.currentUrl(),
      $browser_version: _.info.browserVersion(_e, Te.vendor, It),
      $screen_height: Ut.height,
      $screen_width: Ut.width,
      mp_lib: "web",
      $lib_version: ye.LIB_VERSION,
      $insert_id: fr(),
      time: _.timestamp() / 1e3
      // epoch time in seconds
    }, _.strip_empty_properties(e));
  },
  people_properties: function() {
    return _.extend(_.strip_empty_properties({
      $os: _.info.os(),
      $browser: _.info.browser(_e, Te.vendor, It)
    }), {
      $browser_version: _.info.browserVersion(_e, Te.vendor, It)
    });
  },
  mpPageViewProperties: function() {
    return _.strip_empty_properties({
      current_page_title: G.title,
      current_domain: P.location.hostname,
      current_url_path: P.location.pathname,
      current_url_protocol: P.location.protocol,
      current_url_search: P.location.search
    });
  }
};
var fr = function(e) {
  var t = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return e ? t.substring(0, e) : t;
}, $o = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, Ho = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, Vr = function(e) {
  var t = Ho, r = e.split("."), n = r[r.length - 1];
  (n.length > 4 || n === "com" || n === "org") && (t = $o);
  var o = e.match(t);
  return o ? o[0] : "";
}, Wo = function() {
  var e = P.navigator.onLine;
  return _.isUndefined(e) || e;
}, Ft = null, jt = null;
typeof JSON < "u" && (Ft = JSON.stringify, jt = JSON.parse);
Ft = Ft || _.JSONEncode;
jt = jt || _.JSONDecode;
_.toArray = _.toArray;
_.isObject = _.isObject;
_.JSONEncode = _.JSONEncode;
_.JSONDecode = _.JSONDecode;
_.isBlockedUA = _.isBlockedUA;
_.isEmptyObject = _.isEmptyObject;
_.info = _.info;
_.info.device = _.info.device;
_.info.browser = _.info.browser;
_.info.browserVersion = _.info.browserVersion;
_.info.properties = _.info.properties;
var zo = "__mp_opt_in_out_";
function Go(e, t) {
  Bn(!0, e, t);
}
function Jo(e, t) {
  Bn(!1, e, t);
}
function Vo(e, t) {
  return jn(e, t) === "1";
}
function Fn(e, t) {
  if (Yo(t))
    return z.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var r = jn(e, t) === "0";
  return r && z.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), r;
}
function Ae(e) {
  return gr(e, function(t) {
    return this.get_config(t);
  });
}
function De(e) {
  return gr(e, function(t) {
    return this._get_config(t);
  });
}
function ot(e) {
  return gr(e, function(t) {
    return this._get_config(t);
  });
}
function Xo(e, t) {
  t = t || {}, hr(t).remove(
    mr(e, t),
    !!t.crossSubdomainCookie,
    t.cookieDomain
  );
}
function hr(e) {
  return e = e || {}, e.persistenceType === "localStorage" ? _.localStorage : _.cookie;
}
function mr(e, t) {
  return t = t || {}, (t.persistencePrefix || zo) + e;
}
function jn(e, t) {
  return hr(t).get(mr(e, t));
}
function Yo(e) {
  if (e && e.ignoreDnt)
    return !1;
  var t = e && e.window || P, r = t.navigator || {}, n = !1;
  return _.each([
    r.doNotTrack,
    // standard
    r.msDoNotTrack,
    t.doNotTrack
  ], function(o) {
    _.includes([!0, 1, "1", "yes"], o) && (n = !0);
  }), n;
}
function Bn(e, t, r) {
  if (!_.isString(t) || !t.length) {
    z.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  r = r || {}, hr(r).set(
    mr(t, r),
    e ? 1 : 0,
    _.isNumber(r.cookieExpiration) ? r.cookieExpiration : null,
    !!r.crossSubdomainCookie,
    !!r.secureCookie,
    !!r.crossSiteCookie,
    r.cookieDomain
  ), r.track && e && r.track(r.trackEventName || "$opt_in", r.trackProperties, {
    send_immediately: !0
  });
}
function gr(e, t) {
  return function() {
    var r = !1;
    try {
      var n = t.call(this, "token"), o = t.call(this, "ignore_dnt"), p = t.call(this, "opt_out_tracking_persistence_type"), f = t.call(this, "opt_out_tracking_cookie_prefix"), s = t.call(this, "window");
      n && (r = Fn(n, {
        ignoreDnt: o,
        persistenceType: p,
        persistencePrefix: f,
        window: s
      }));
    } catch (d) {
      z.error("Unexpected error when checking tracking opt-out status: " + d);
    }
    if (!r)
      return e.apply(this, arguments);
    var i = arguments[arguments.length - 1];
    typeof i == "function" && i(0);
  };
}
var Ko = vt("lock"), $n = function(e, t) {
  t = t || {}, this.storageKey = e, this.storage = t.storage || window.localStorage, this.pollIntervalMS = t.pollIntervalMS || 100, this.timeoutMS = t.timeoutMS || 2e3;
};
$n.prototype.withLock = function(e, t, r) {
  !r && typeof t != "function" && (r = t, t = null);
  var n = r || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), o = (/* @__PURE__ */ new Date()).getTime(), p = this.storageKey, f = this.pollIntervalMS, s = this.timeoutMS, i = this.storage, d = p + ":X", u = p + ":Y", a = p + ":Z", l = function(v) {
    t && t(v);
  }, g = function(v) {
    if ((/* @__PURE__ */ new Date()).getTime() - o > s) {
      Ko.error("Timeout waiting for mutex on " + p + "; clearing lock. [" + n + "]"), i.removeItem(a), i.removeItem(u), b();
      return;
    }
    setTimeout(function() {
      try {
        v();
      } catch (y) {
        l(y);
      }
    }, f * (Math.random() + 0.1));
  }, c = function(v, y) {
    v() ? y() : g(function() {
      c(v, y);
    });
  }, h = function() {
    var v = i.getItem(u);
    if (v && v !== n)
      return !1;
    if (i.setItem(u, n), i.getItem(u) === n)
      return !0;
    if (!qt(i, !0))
      throw new Error("localStorage support dropped while acquiring lock");
    return !1;
  }, b = function() {
    i.setItem(d, n), c(h, function() {
      if (i.getItem(d) === n) {
        m();
        return;
      }
      g(function() {
        if (i.getItem(u) !== n) {
          b();
          return;
        }
        c(function() {
          return !i.getItem(a);
        }, m);
      });
    });
  }, m = function() {
    i.setItem(a, "1");
    try {
      e();
    } finally {
      i.removeItem(a), i.getItem(u) === n && i.removeItem(u), i.getItem(d) === n && i.removeItem(d);
    }
  };
  try {
    if (qt(i, !0))
      b();
    else
      throw new Error("localStorage support check failed");
  } catch (v) {
    l(v);
  }
};
var Xr = vt("batch"), Le = function(e, t) {
  t = t || {}, this.storageKey = e, this.usePersistence = t.usePersistence, this.usePersistence && (this.storage = t.storage || window.localStorage, this.lock = new $n(e, { storage: this.storage })), this.reportError = t.errorReporter || _.bind(Xr.error, Xr), this.pid = t.pid || null, this.memQueue = [];
};
Le.prototype.enqueue = function(e, t, r) {
  var n = {
    id: fr(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + t * 2,
    payload: e
  };
  this.usePersistence ? this.lock.withLock(_.bind(function() {
    var p;
    try {
      var f = this.readFromStorage();
      f.push(n), p = this.saveToStorage(f), p && this.memQueue.push(n);
    } catch {
      this.reportError("Error enqueueing item", e), p = !1;
    }
    r && r(p);
  }, this), _.bind(function(p) {
    this.reportError("Error acquiring storage lock", p), r && r(!1);
  }, this), this.pid) : (this.memQueue.push(n), r && r(!0));
};
Le.prototype.fillBatch = function(e) {
  var t = this.memQueue.slice(0, e);
  if (this.usePersistence && t.length < e) {
    var r = this.readFromStorage();
    if (r.length) {
      var n = {};
      _.each(t, function(f) {
        n[f.id] = !0;
      });
      for (var o = 0; o < r.length; o++) {
        var p = r[o];
        if ((/* @__PURE__ */ new Date()).getTime() > p.flushAfter && !n[p.id] && (p.orphaned = !0, t.push(p), t.length >= e))
          break;
      }
    }
  }
  return t;
};
var Yr = function(e, t) {
  var r = [];
  return _.each(e, function(n) {
    n.id && !t[n.id] && r.push(n);
  }), r;
};
Le.prototype.removeItemsByID = function(e, t) {
  var r = {};
  if (_.each(e, function(o) {
    r[o] = !0;
  }), this.memQueue = Yr(this.memQueue, r), !this.usePersistence)
    t && t(!0);
  else {
    var n = _.bind(function() {
      var o;
      try {
        var p = this.readFromStorage();
        if (p = Yr(p, r), o = this.saveToStorage(p), o) {
          p = this.readFromStorage();
          for (var f = 0; f < p.length; f++) {
            var s = p[f];
            if (s.id && r[s.id])
              return this.reportError("Item not removed from storage"), !1;
          }
        }
      } catch {
        this.reportError("Error removing items", e), o = !1;
      }
      return o;
    }, this);
    this.lock.withLock(function() {
      var p = n();
      t && t(p);
    }, _.bind(function(p) {
      var f = !1;
      if (this.reportError("Error acquiring storage lock", p), !qt(this.storage, !0) && (f = n(), !f))
        try {
          this.storage.removeItem(this.storageKey);
        } catch (s) {
          this.reportError("Error clearing queue", s);
        }
      t && t(f);
    }, this), this.pid);
  }
};
var Kr = function(e, t) {
  var r = [];
  return _.each(e, function(n) {
    var o = n.id;
    if (o in t) {
      var p = t[o];
      p !== null && (n.payload = p, r.push(n));
    } else
      r.push(n);
  }), r;
};
Le.prototype.updatePayloads = function(e, t) {
  this.memQueue = Kr(this.memQueue, e), this.usePersistence ? this.lock.withLock(_.bind(function() {
    var n;
    try {
      var o = this.readFromStorage();
      o = Kr(o, e), n = this.saveToStorage(o);
    } catch {
      this.reportError("Error updating items", e), n = !1;
    }
    t && t(n);
  }, this), _.bind(function(n) {
    this.reportError("Error acquiring storage lock", n), t && t(!1);
  }, this), this.pid) : t && t(!0);
};
Le.prototype.readFromStorage = function() {
  var e;
  try {
    e = this.storage.getItem(this.storageKey), e && (e = jt(e), _.isArray(e) || (this.reportError("Invalid storage entry:", e), e = null));
  } catch (t) {
    this.reportError("Error retrieving queue", t), e = null;
  }
  return e || [];
};
Le.prototype.saveToStorage = function(e) {
  try {
    return this.storage.setItem(this.storageKey, Ft(e)), !0;
  } catch (t) {
    return this.reportError("Error saving queue", t), !1;
  }
};
Le.prototype.clear = function() {
  this.memQueue = [], this.usePersistence && this.storage.removeItem(this.storageKey);
};
var Qo = 10 * 60 * 1e3, pt = vt("batch"), he = function(e, t) {
  this.errorReporter = t.errorReporter, this.queue = new Le(e, {
    errorReporter: _.bind(this.reportError, this),
    storage: t.storage,
    usePersistence: t.usePersistence
  }), this.libConfig = t.libConfig, this.sendRequest = t.sendRequestFunc, this.beforeSendHook = t.beforeSendHook, this.stopAllBatching = t.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {}, this.flushOnlyOnInterval = t.flushOnlyOnInterval || !1;
};
he.prototype.enqueue = function(e, t) {
  this.queue.enqueue(e, this.flushInterval, t);
};
he.prototype.start = function() {
  this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
he.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
he.prototype.clear = function() {
  this.queue.clear();
};
he.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
he.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
he.prototype.scheduleFlush = function(e) {
  this.flushInterval = e, this.stopped || (this.timeoutID = setTimeout(_.bind(function() {
    this.stopped || this.flush();
  }, this), this.flushInterval));
};
he.prototype.flush = function(e) {
  try {
    if (this.requestInProgress) {
      pt.log("Flush: Request already in progress");
      return;
    }
    e = e || {};
    var t = this.libConfig.batch_request_timeout_ms, r = (/* @__PURE__ */ new Date()).getTime(), n = this.batchSize, o = this.queue.fillBatch(n), p = o.length === n, f = [], s = {};
    if (_.each(o, function(u) {
      var a = u.payload;
      if (this.beforeSendHook && !u.orphaned && (a = this.beforeSendHook(a)), a) {
        a.event && a.properties && (a.properties = _.extend(
          {},
          a.properties,
          { mp_sent_by_lib_version: ye.LIB_VERSION }
        ));
        var l = !0, g = u.id;
        g ? (this.itemIdsSentSuccessfully[g] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: u,
          batchSize: o.length,
          timesSent: this.itemIdsSentSuccessfully[g]
        }), l = !1) : this.reportError("[dupe] found item with no ID", { item: u }), l && f.push(a);
      }
      s[u.id] = a;
    }, this), f.length < 1) {
      this.resetFlush();
      return;
    }
    this.requestInProgress = !0;
    var i = _.bind(function(u) {
      this.requestInProgress = !1;
      try {
        var a = !1;
        if (e.unloading)
          this.queue.updatePayloads(s);
        else if (_.isObject(u) && u.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - r >= t)
          this.reportError("Network timeout; retrying"), this.flush();
        else if (_.isObject(u) && (u.httpStatusCode >= 500 || u.httpStatusCode === 429 || u.httpStatusCode <= 0 && !Wo() || u.error === "timeout")) {
          var l = this.flushInterval * 2;
          u.retryAfter && (l = parseInt(u.retryAfter, 10) * 1e3 || l), l = Math.min(Qo, l), this.reportError("Error; retry in " + l + " ms"), this.scheduleFlush(l);
        } else if (_.isObject(u) && u.httpStatusCode === 413)
          if (o.length > 1) {
            var g = Math.max(1, Math.floor(n / 2));
            this.batchSize = Math.min(this.batchSize, g, o.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush();
          } else
            this.reportError("Single-event request too large; dropping", o), this.resetBatchSize(), a = !0;
        else
          a = !0;
        a && (this.queue.removeItemsByID(
          _.map(o, function(c) {
            return c.id;
          }),
          _.bind(function(c) {
            c ? (this.consecutiveRemovalFailures = 0, this.flushOnlyOnInterval && !p ? this.resetFlush() : this.flush()) : (this.reportError("Failed to remove items from queue"), ++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush());
          }, this)
        ), _.each(o, _.bind(function(c) {
          var h = c.id;
          h ? (this.itemIdsSentSuccessfully[h] = this.itemIdsSentSuccessfully[h] || 0, this.itemIdsSentSuccessfully[h]++, this.itemIdsSentSuccessfully[h] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: c,
            batchSize: o.length,
            timesSent: this.itemIdsSentSuccessfully[h]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: c });
        }, this)));
      } catch (c) {
        this.reportError("Error handling API response", c), this.resetFlush();
      }
    }, this), d = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: t
      // eslint-disable-line camelcase
    };
    e.unloading && (d.transport = "sendBeacon"), pt.log("MIXPANEL REQUEST:", f), this.sendRequest(f, d, i);
  } catch (u) {
    this.reportError("Error flushing request queue", u), this.resetFlush();
  }
};
he.prototype.reportError = function(e, t) {
  if (pt.error.apply(pt.error, arguments), this.errorReporter)
    try {
      t instanceof Error || (t = new Error(e)), this.errorReporter(e, t);
    } catch (r) {
      pt.error(r);
    }
};
var Ze = vt("recorder"), Qr = P.CompressionStream, Zo = {
  batch_size: 1e3,
  batch_flush_interval_ms: 10 * 1e3,
  batch_request_timeout_ms: 90 * 1e3,
  batch_autostart: !0
}, es = /* @__PURE__ */ new Set([
  ge.MouseMove,
  ge.MouseInteraction,
  ge.Scroll,
  ge.ViewportResize,
  ge.Input,
  ge.TouchMove,
  ge.MediaInteraction,
  ge.Drag,
  ge.Selection
]);
function ts(e) {
  return e.type === Un.IncrementalSnapshot && es.has(e.data.source);
}
var me = function(e) {
  this._mixpanel = e.mixpanelInstance, this._onIdleTimeout = e.onIdleTimeout, this._onMaxLengthReached = e.onMaxLengthReached, this._rrwebRecord = e.rrwebRecord, this.replayId = e.replayId, this._stopRecording = null, this.seqNo = 0, this.replayStartTime = null, this.batchStartUrl = null, this.idleTimeoutId = null, this.maxTimeoutId = null, this.recordMaxMs = lt, this.recordMinMs = 0;
  var t = "__mprec_" + this.getConfig("token") + "_" + this.replayId;
  this.batcher = new he(t, {
    errorReporter: _.bind(this.reportError, this),
    flushOnlyOnInterval: !0,
    libConfig: Zo,
    sendRequestFunc: _.bind(this.flushEventsWithOptOut, this),
    usePersistence: !1
  });
};
me.prototype.getConfig = function(e) {
  return this._mixpanel.get_config(e);
};
me.prototype.get_config = function(e) {
  return this.getConfig(e);
};
me.prototype.startRecording = function(e) {
  if (this._stopRecording !== null) {
    Ze.log("Recording already in progress, skipping startRecording.");
    return;
  }
  this.recordMaxMs = this.getConfig("record_max_ms"), this.recordMaxMs > lt && (this.recordMaxMs = lt, Ze.critical("record_max_ms cannot be greater than " + lt + "ms. Capping value.")), this.recordMinMs = this.getConfig("record_min_ms"), this.recordMinMs > er && (this.recordMinMs = er, Ze.critical("record_min_ms cannot be greater than " + er + "ms. Capping value.")), this.replayStartTime = (/* @__PURE__ */ new Date()).getTime(), this.batchStartUrl = _.info.currentUrl(), e || this.recordMinMs > 0 ? this.batcher.stop() : this.batcher.start();
  var t = _.bind(function() {
    clearTimeout(this.idleTimeoutId), this.idleTimeoutId = setTimeout(this._onIdleTimeout, this.getConfig("record_idle_timeout_ms"));
  }, this), r = this.getConfig("record_block_selector");
  if ((r === "" || r === null) && (r = void 0), this._stopRecording = this._rrwebRecord({
    emit: _.bind(function(n) {
      this.batcher.enqueue(n), ts(n) && (this.batcher.stopped && (/* @__PURE__ */ new Date()).getTime() - this.replayStartTime >= this.recordMinMs && this.batcher.start(), t());
    }, this),
    blockClass: this.getConfig("record_block_class"),
    blockSelector: r,
    collectFonts: this.getConfig("record_collect_fonts"),
    maskAllInputs: !0,
    maskTextClass: this.getConfig("record_mask_text_class"),
    maskTextSelector: this.getConfig("record_mask_text_selector")
  }), typeof this._stopRecording != "function") {
    this.reportError("rrweb failed to start, skipping this recording."), this._stopRecording = null, this.stopRecording();
    return;
  }
  t(), this.maxTimeoutId = setTimeout(_.bind(this._onMaxLengthReached, this), this.recordMaxMs);
};
me.prototype.stopRecording = function() {
  if (!this.isRrwebStopped()) {
    try {
      this._stopRecording();
    } catch (e) {
      this.reportError("Error with rrweb stopRecording", e);
    }
    this._stopRecording = null;
  }
  this.batcher.stopped ? this.batcher.clear() : (this.batcher.flush(), this.batcher.stop()), clearTimeout(this.idleTimeoutId), clearTimeout(this.maxTimeoutId);
};
me.prototype.isRrwebStopped = function() {
  return this._stopRecording === null;
};
me.prototype.flushEventsWithOptOut = function(e, t, r) {
  this._flushEvents(e, t, r, _.bind(this._onOptOut, this));
};
me.prototype._onOptOut = function(e) {
  e === 0 && this.stopRecording();
};
me.prototype._sendRequest = function(e, t, r, n) {
  var o = _.bind(function(p, f) {
    p.status === 200 && this.replayId === e && (this.seqNo++, this.batchStartUrl = _.info.currentUrl()), n({
      status: 0,
      httpStatusCode: p.status,
      responseBody: f,
      retryAfter: p.headers.get("Retry-After")
    });
  }, this);
  P.fetch(this.getConfig("api_host") + "/" + this.getConfig("api_routes").record + "?" + new URLSearchParams(t), {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa(this.getConfig("token") + ":"),
      "Content-Type": "application/octet-stream"
    },
    body: r
  }).then(function(p) {
    p.json().then(function(f) {
      o(p, f);
    }).catch(function(f) {
      n({ error: f });
    });
  }).catch(function(p) {
    n({ error: p, httpStatusCode: 0 });
  });
};
me.prototype._flushEvents = Ae(function(e, t, r) {
  const n = e.length;
  if (n > 0) {
    var o = this.replayId, p = e[0].timestamp;
    (this.seqNo === 0 || !this.replayStartTime) && (this.seqNo !== 0 && this.reportError("Replay start time not set but seqNo is not 0. Using current batch start time as a fallback."), this.replayStartTime = p);
    var f = e[n - 1].timestamp - this.replayStartTime, s = {
      $current_url: this.batchStartUrl,
      $lib_version: ye.LIB_VERSION,
      batch_start_time: p / 1e3,
      distinct_id: String(this._mixpanel.get_distinct_id()),
      mp_lib: "web",
      replay_id: o,
      replay_length_ms: f,
      replay_start_time: this.replayStartTime / 1e3,
      seq: this.seqNo
    }, i = _.JSONEncode(e), d = this._mixpanel.get_property("$device_id");
    d && (s.$device_id = d);
    var u = this._mixpanel.get_property("$user_id");
    if (u && (s.$user_id = u), Qr) {
      var a = new Blob([i], { type: "application/json" }).stream(), l = a.pipeThrough(new Qr("gzip"));
      new Response(l).blob().then(_.bind(function(g) {
        s.format = "gzip", this._sendRequest(o, s, g, r);
      }, this));
    } else
      s.format = "body", this._sendRequest(o, s, i, r);
  }
});
me.prototype.reportError = function(e, t) {
  Ze.error.apply(Ze.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.getConfig("error_reporter")(e, t);
  } catch (r) {
    Ze.error(r);
  }
};
var ir = vt("recorder"), st = function(e) {
  this._mixpanel = e, this.activeRecording = null;
};
st.prototype.startRecording = function(e) {
  if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
    ir.log("Recording already in progress, skipping startRecording.");
    return;
  }
  var t = _.bind(function() {
    ir.log("Idle timeout reached, restarting recording."), this.resetRecording();
  }, this), r = _.bind(function() {
    ir.log("Max recording length reached, stopping recording."), this.resetRecording();
  }, this);
  this.activeRecording = new me({
    mixpanelInstance: this._mixpanel,
    onIdleTimeout: t,
    onMaxLengthReached: r,
    replayId: _.UUID(),
    rrwebRecord: _t
  }), this.activeRecording.startRecording(e);
};
st.prototype.stopRecording = function() {
  this.activeRecording && (this.activeRecording.stopRecording(), this.activeRecording = null);
};
st.prototype.resetRecording = function() {
  this.stopRecording(), this.startRecording(!0);
};
st.prototype.getActiveReplayId = function() {
  return this.activeRecording && !this.activeRecording.isRrwebStopped() ? this.activeRecording.replayId : null;
};
Object.defineProperty(st.prototype, "replayId", {
  get: function() {
    return this.getActiveReplayId();
  }
});
P.__mp_recorder = st;
var xe = function() {
};
xe.prototype.create_properties = function() {
};
xe.prototype.event_handler = function() {
};
xe.prototype.after_track_handler = function() {
};
xe.prototype.init = function(e) {
  return this.mp = e, this;
};
xe.prototype.track = function(e, t, r, n) {
  var o = this, p = _.dom_query(e);
  if (p.length === 0) {
    z.error("The DOM query (" + e + ") returned 0 elements");
    return;
  }
  return _.each(p, function(f) {
    _.register_event(f, this.override_event, function(s) {
      var i = {}, d = o.create_properties(r, this), u = o.mp.get_config("track_links_timeout");
      o.event_handler(s, this, i), window.setTimeout(o.track_callback(n, d, i, !0), u), o.mp.track(t, d, o.track_callback(n, d, i));
    });
  }, this), !0;
};
xe.prototype.track_callback = function(e, t, r, n) {
  n = n || !1;
  var o = this;
  return function() {
    r.callback_fired || (r.callback_fired = !0, !(e && e(n, t) === !1) && o.after_track_handler(t, r, n));
  };
};
xe.prototype.create_properties = function(e, t) {
  var r;
  return typeof e == "function" ? r = e(t) : r = _.extend({}, e), r;
};
var rt = function() {
  this.override_event = "click";
};
_.inherit(rt, xe);
rt.prototype.create_properties = function(e, t) {
  var r = rt.superclass.create_properties.apply(this, arguments);
  return t.href && (r.url = t.href), r;
};
rt.prototype.event_handler = function(e, t, r) {
  r.new_tab = e.which === 2 || e.metaKey || e.ctrlKey || t.target === "_blank", r.href = t.href, r.new_tab || e.preventDefault();
};
rt.prototype.after_track_handler = function(e, t) {
  t.new_tab || setTimeout(function() {
    window.location = t.href;
  }, 0);
};
var Vt = function() {
  this.override_event = "submit";
};
_.inherit(Vt, xe);
Vt.prototype.event_handler = function(e, t, r) {
  r.element = t, e.preventDefault();
};
Vt.prototype.after_track_handler = function(e, t) {
  setTimeout(function() {
    t.element.submit();
  }, 0);
};
var Ne = "$set", nt = "$set_once", fe = "$unset", Be = "$add", ve = "$append", $e = "$union", Se = "$remove", rs = "$delete", Hn = {
  set_action: function(e, t) {
    var r = {}, n = {};
    return _.isObject(e) ? _.each(e, function(o, p) {
      this._is_reserved_property(p) || (n[p] = o);
    }, this) : n[e] = t, r[Ne] = n, r;
  },
  unset_action: function(e) {
    var t = {}, r = [];
    return _.isArray(e) || (e = [e]), _.each(e, function(n) {
      this._is_reserved_property(n) || r.push(n);
    }, this), t[fe] = r, t;
  },
  set_once_action: function(e, t) {
    var r = {}, n = {};
    return _.isObject(e) ? _.each(e, function(o, p) {
      this._is_reserved_property(p) || (n[p] = o);
    }, this) : n[e] = t, r[nt] = n, r;
  },
  union_action: function(e, t) {
    var r = {}, n = {};
    return _.isObject(e) ? _.each(e, function(o, p) {
      this._is_reserved_property(p) || (n[p] = _.isArray(o) ? o : [o]);
    }, this) : n[e] = _.isArray(t) ? t : [t], r[$e] = n, r;
  },
  append_action: function(e, t) {
    var r = {}, n = {};
    return _.isObject(e) ? _.each(e, function(o, p) {
      this._is_reserved_property(p) || (n[p] = o);
    }, this) : n[e] = t, r[ve] = n, r;
  },
  remove_action: function(e, t) {
    var r = {}, n = {};
    return _.isObject(e) ? _.each(e, function(o, p) {
      this._is_reserved_property(p) || (n[p] = o);
    }, this) : n[e] = t, r[Se] = n, r;
  },
  delete_action: function() {
    var e = {};
    return e[rs] = "", e;
  }
}, X = function() {
};
_.extend(X.prototype, Hn);
X.prototype._init = function(e, t, r) {
  this._mixpanel = e, this._group_key = t, this._group_id = r;
};
X.prototype.set = ot(function(e, t, r) {
  var n = this.set_action(e, t);
  return _.isObject(e) && (r = t), this._send_request(n, r);
});
X.prototype.set_once = ot(function(e, t, r) {
  var n = this.set_once_action(e, t);
  return _.isObject(e) && (r = t), this._send_request(n, r);
});
X.prototype.unset = ot(function(e, t) {
  var r = this.unset_action(e);
  return this._send_request(r, t);
});
X.prototype.union = ot(function(e, t, r) {
  _.isObject(e) && (r = t);
  var n = this.union_action(e, t);
  return this._send_request(n, r);
});
X.prototype.delete = ot(function(e) {
  var t = this.delete_action();
  return this._send_request(t, e);
});
X.prototype.remove = ot(function(e, t, r) {
  var n = this.remove_action(e, t);
  return this._send_request(n, r);
});
X.prototype._send_request = function(e, t) {
  e.$group_key = this._group_key, e.$group_id = this._group_id, e.$token = this._get_config("token");
  var r = _.encodeDates(e);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: r,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, t);
};
X.prototype._is_reserved_property = function(e) {
  return e === "$group_key" || e === "$group_id";
};
X.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
X.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
X.prototype.remove = X.prototype.remove;
X.prototype.set = X.prototype.set;
X.prototype.set_once = X.prototype.set_once;
X.prototype.union = X.prototype.union;
X.prototype.unset = X.prototype.unset;
X.prototype.toString = X.prototype.toString;
var U = function() {
};
_.extend(U.prototype, Hn);
U.prototype._init = function(e) {
  this._mixpanel = e;
};
U.prototype.set = De(function(e, t, r) {
  var n = this.set_action(e, t);
  return _.isObject(e) && (r = t), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), n[Ne] = _.extend(
    {},
    _.info.people_properties(),
    n[Ne]
  ), this._send_request(n, r);
});
U.prototype.set_once = De(function(e, t, r) {
  var n = this.set_once_action(e, t);
  return _.isObject(e) && (r = t), this._send_request(n, r);
});
U.prototype.unset = De(function(e, t) {
  var r = this.unset_action(e);
  return this._send_request(r, t);
});
U.prototype.increment = De(function(e, t, r) {
  var n = {}, o = {};
  return _.isObject(e) ? (_.each(e, function(p, f) {
    if (!this._is_reserved_property(f))
      if (isNaN(parseFloat(p))) {
        z.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        o[f] = p;
  }, this), r = t) : (_.isUndefined(t) && (t = 1), o[e] = t), n[Be] = o, this._send_request(n, r);
});
U.prototype.append = De(function(e, t, r) {
  _.isObject(e) && (r = t);
  var n = this.append_action(e, t);
  return this._send_request(n, r);
});
U.prototype.remove = De(function(e, t, r) {
  _.isObject(e) && (r = t);
  var n = this.remove_action(e, t);
  return this._send_request(n, r);
});
U.prototype.union = De(function(e, t, r) {
  _.isObject(e) && (r = t);
  var n = this.union_action(e, t);
  return this._send_request(n, r);
});
U.prototype.track_charge = De(function(e, t, r) {
  if (!_.isNumber(e) && (e = parseFloat(e), isNaN(e))) {
    z.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", _.extend({
    $amount: e
  }, t), r);
});
U.prototype.clear_charges = function(e) {
  return this.set("$transactions", [], e);
};
U.prototype.delete_user = function() {
  if (!this._identify_called()) {
    z.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var e = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(e);
};
U.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
U.prototype._send_request = function(e, t) {
  e.$token = this._get_config("token"), e.$distinct_id = this._mixpanel.get_distinct_id();
  var r = this._mixpanel.get_property("$device_id"), n = this._mixpanel.get_property("$user_id"), o = this._mixpanel.get_property("$had_persisted_distinct_id");
  r && (e.$device_id = r), n && (e.$user_id = n), o && (e.$had_persisted_distinct_id = o);
  var p = _.encodeDates(e);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: p,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, t) : (this._enqueue(e), _.isUndefined(t) || (this._get_config("verbose") ? t({ status: -1, error: null }) : t(-1)), _.truncate(p, 255));
};
U.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
U.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
U.prototype._enqueue = function(e) {
  Ne in e ? this._mixpanel.persistence._add_to_people_queue(Ne, e) : nt in e ? this._mixpanel.persistence._add_to_people_queue(nt, e) : fe in e ? this._mixpanel.persistence._add_to_people_queue(fe, e) : Be in e ? this._mixpanel.persistence._add_to_people_queue(Be, e) : ve in e ? this._mixpanel.persistence._add_to_people_queue(ve, e) : Se in e ? this._mixpanel.persistence._add_to_people_queue(Se, e) : $e in e ? this._mixpanel.persistence._add_to_people_queue($e, e) : z.error("Invalid call to _enqueue():", e);
};
U.prototype._flush_one_queue = function(e, t, r, n) {
  var o = this, p = _.extend({}, this._mixpanel.persistence.load_queue(e)), f = p;
  !_.isUndefined(p) && _.isObject(p) && !_.isEmptyObject(p) && (o._mixpanel.persistence._pop_from_people_queue(e, p), o._mixpanel.persistence.save(), n && (f = n(p)), t.call(o, f, function(s, i) {
    s === 0 && o._mixpanel.persistence._add_to_people_queue(e, p), _.isUndefined(r) || r(s, i);
  }));
};
U.prototype._flush = function(e, t, r, n, o, p, f) {
  var s = this;
  this._flush_one_queue(Ne, this.set, e), this._flush_one_queue(nt, this.set_once, n), this._flush_one_queue(fe, this.unset, p, function(b) {
    return _.keys(b);
  }), this._flush_one_queue(Be, this.increment, t), this._flush_one_queue($e, this.union, o);
  var i = this._mixpanel.persistence.load_queue(ve);
  if (!_.isUndefined(i) && _.isArray(i) && i.length)
    for (var d, u = function(b, m) {
      b === 0 && s._mixpanel.persistence._add_to_people_queue(ve, d), _.isUndefined(r) || r(b, m);
    }, a = i.length - 1; a >= 0; a--)
      i = this._mixpanel.persistence.load_queue(ve), d = i.pop(), s._mixpanel.persistence.save(), _.isEmptyObject(d) || s.append(d, u);
  var l = this._mixpanel.persistence.load_queue(Se);
  if (!_.isUndefined(l) && _.isArray(l) && l.length)
    for (var g, c = function(b, m) {
      b === 0 && s._mixpanel.persistence._add_to_people_queue(Se, g), _.isUndefined(f) || f(b, m);
    }, h = l.length - 1; h >= 0; h--)
      l = this._mixpanel.persistence.load_queue(Se), g = l.pop(), s._mixpanel.persistence.save(), _.isEmptyObject(g) || s.remove(g, c);
};
U.prototype._is_reserved_property = function(e) {
  return e === "$distinct_id" || e === "$token" || e === "$device_id" || e === "$user_id" || e === "$had_persisted_distinct_id";
};
U.prototype.set = U.prototype.set;
U.prototype.set_once = U.prototype.set_once;
U.prototype.unset = U.prototype.unset;
U.prototype.increment = U.prototype.increment;
U.prototype.append = U.prototype.append;
U.prototype.remove = U.prototype.remove;
U.prototype.union = U.prototype.union;
U.prototype.track_charge = U.prototype.track_charge;
U.prototype.clear_charges = U.prototype.clear_charges;
U.prototype.delete_user = U.prototype.delete_user;
U.prototype.toString = U.prototype.toString;
var _r = "__mps", yr = "__mpso", vr = "__mpus", br = "__mpa", wr = "__mpap", Sr = "__mpr", kr = "__mpu", Wn = "$people_distinct_id", Bt = "__alias", ht = "__timers", ns = [
  _r,
  yr,
  vr,
  br,
  wr,
  Sr,
  kr,
  Wn,
  Bt,
  ht
], j = function(e) {
  this.props = {}, this.campaign_params_saved = !1, e.persistence_name ? this.name = "mp_" + e.persistence_name : this.name = "mp_" + e.token + "_mixpanel";
  var t = e.persistence;
  t !== "cookie" && t !== "localStorage" && (z.critical("Unknown persistence type " + t + "; falling back to cookie"), t = e.persistence = "cookie"), t === "localStorage" && _.localStorage.is_supported() ? this.storage = _.localStorage : this.storage = _.cookie, this.load(), this.update_config(e), this.upgrade(), this.save();
};
j.prototype.properties = function() {
  var e = {};
  return this.load(), _.each(this.props, function(t, r) {
    _.include(ns, r) || (e[r] = t);
  }), e;
};
j.prototype.load = function() {
  if (!this.disabled) {
    var e = this.storage.parse(this.name);
    e && (this.props = _.extend({}, e));
  }
};
j.prototype.upgrade = function() {
  var e, t;
  this.storage === _.localStorage ? (e = _.cookie.parse(this.name), _.cookie.remove(this.name), _.cookie.remove(this.name, !0), e && this.register_once(e)) : this.storage === _.cookie && (t = _.localStorage.parse(this.name), _.localStorage.remove(this.name), t && this.register_once(t));
};
j.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    _.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
j.prototype.load_prop = function(e) {
  return this.load(), this.props[e];
};
j.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
j.prototype.clear = function() {
  this.remove(), this.props = {};
};
j.prototype.register_once = function(e, t, r) {
  return _.isObject(e) ? (typeof t > "u" && (t = "None"), this.expire_days = typeof r > "u" ? this.default_expiry : r, this.load(), _.each(e, function(n, o) {
    (!this.props.hasOwnProperty(o) || this.props[o] === t) && (this.props[o] = n);
  }, this), this.save(), !0) : !1;
};
j.prototype.register = function(e, t) {
  return _.isObject(e) ? (this.expire_days = typeof t > "u" ? this.default_expiry : t, this.load(), _.extend(this.props, e), this.save(), !0) : !1;
};
j.prototype.unregister = function(e) {
  this.load(), e in this.props && (delete this.props[e], this.save());
};
j.prototype.update_search_keyword = function(e) {
  this.register(_.info.searchInfo(e));
};
j.prototype.update_referrer_info = function(e) {
  this.register_once({
    $initial_referrer: e || "$direct",
    $initial_referring_domain: _.info.referringDomain(e) || "$direct"
  }, "");
};
j.prototype.get_referrer_info = function() {
  return _.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
j.prototype.update_config = function(e) {
  this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cookie_domain(e.cookie_domain), this.set_cross_site(e.cross_site_cookie), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
};
j.prototype.set_disabled = function(e) {
  this.disabled = e, this.disabled ? this.remove() : this.save();
};
j.prototype.set_cookie_domain = function(e) {
  e !== this.cookie_domain && (this.remove(), this.cookie_domain = e, this.save());
};
j.prototype.set_cross_site = function(e) {
  e !== this.cross_site && (this.cross_site = e, this.remove(), this.save());
};
j.prototype.set_cross_subdomain = function(e) {
  e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
};
j.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
j.prototype.set_secure = function(e) {
  e !== this.secure && (this.secure = !!e, this.remove(), this.save());
};
j.prototype._add_to_people_queue = function(e, t) {
  var r = this._get_queue_key(e), n = t[e], o = this._get_or_create_queue(Ne), p = this._get_or_create_queue(nt), f = this._get_or_create_queue(fe), s = this._get_or_create_queue(Be), i = this._get_or_create_queue($e), d = this._get_or_create_queue(Se, []), u = this._get_or_create_queue(ve, []);
  r === _r ? (_.extend(o, n), this._pop_from_people_queue(Be, n), this._pop_from_people_queue($e, n), this._pop_from_people_queue(fe, n)) : r === yr ? (_.each(n, function(a, l) {
    l in p || (p[l] = a);
  }), this._pop_from_people_queue(fe, n)) : r === vr ? _.each(n, function(a) {
    _.each([o, p, s, i], function(l) {
      a in l && delete l[a];
    }), _.each(u, function(l) {
      a in l && delete l[a];
    }), f[a] = !0;
  }) : r === br ? (_.each(n, function(a, l) {
    l in o ? o[l] += a : (l in s || (s[l] = 0), s[l] += a);
  }, this), this._pop_from_people_queue(fe, n)) : r === kr ? (_.each(n, function(a, l) {
    _.isArray(a) && (l in i || (i[l] = []), i[l] = i[l].concat(a));
  }), this._pop_from_people_queue(fe, n)) : r === Sr ? (d.push(n), this._pop_from_people_queue(ve, n)) : r === wr && (u.push(n), this._pop_from_people_queue(fe, n)), z.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), z.log(t), this.save();
};
j.prototype._pop_from_people_queue = function(e, t) {
  var r = this.props[this._get_queue_key(e)];
  _.isUndefined(r) || _.each(t, function(n, o) {
    e === ve || e === Se ? _.each(r, function(p) {
      p[o] === n && delete p[o];
    }) : delete r[o];
  }, this);
};
j.prototype.load_queue = function(e) {
  return this.load_prop(this._get_queue_key(e));
};
j.prototype._get_queue_key = function(e) {
  if (e === Ne)
    return _r;
  if (e === nt)
    return yr;
  if (e === fe)
    return vr;
  if (e === Be)
    return br;
  if (e === ve)
    return wr;
  if (e === Se)
    return Sr;
  if (e === $e)
    return kr;
  z.error("Invalid queue:", e);
};
j.prototype._get_or_create_queue = function(e, t) {
  var r = this._get_queue_key(e);
  return t = _.isUndefined(t) ? {} : t, this.props[r] || (this.props[r] = t);
};
j.prototype.set_event_timer = function(e, t) {
  var r = this.load_prop(ht) || {};
  r[e] = t, this.props[ht] = r, this.save();
};
j.prototype.remove_event_timer = function(e) {
  var t = this.load_prop(ht) || {}, r = t[e];
  return _.isUndefined(r) || (delete this.props[ht][e], this.save()), r;
};
var xr, zn = function(e, t) {
  throw new Error(e + " not available in this build.");
}, ne, Gn = 0, is = 1, os = function(e) {
  return e;
}, mt = function() {
}, le = "mixpanel", Jn = "base64", ss = "json", Er = "$device:", et = P.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), Vn = !et && _e.indexOf("MSIE") === -1 && _e.indexOf("Mozilla") === -1, $t = null;
Te.sendBeacon && ($t = function() {
  return Te.sendBeacon.apply(Te, arguments);
});
var Xn = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/"
}, Zr = {
  api_host: "https://api-js.mixpanel.com",
  api_routes: Xn,
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: Jn,
  app_host: "https://mixpanel.com",
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: mt,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: mt,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_collect_fonts: !1,
  record_idle_timeout_ms: 30 * 60 * 1e3,
  // 30 minutes
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: lt,
  record_min_ms: 0,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, Yn = !1, M = function() {
}, cr = function(e, t, r) {
  var n, o = r === le ? ne : ne[r];
  if (o && xr === Gn)
    n = o;
  else {
    if (o && !_.isArray(o)) {
      z.error("You have already initialized " + r);
      return;
    }
    n = new M();
  }
  if (n._cached_groups = {}, n._init(e, t, r), n.people = new U(), n.people._init(n), !n.get_config("skip_first_touch_marketing")) {
    var p = _.info.campaignParams(null), f = {}, s = !1;
    _.each(p, function(i, d) {
      f["initial_" + d] = i, i && (s = !0);
    }), s && n.people.set_once(f);
  }
  return ye.DEBUG = ye.DEBUG || n.get_config("debug"), !_.isUndefined(o) && _.isArray(o) && (n._execute_array.call(n.people, o.people), n._execute_array(o)), n;
};
M.prototype.init = function(e, t, r) {
  if (_.isUndefined(r)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (r === le) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var n = cr(e, t, r);
  return ne[r] = n, n._loaded(), n;
};
M.prototype._init = function(e, t, r) {
  t = t || {}, this.__loaded = !0, this.config = {};
  var n = {};
  if (!("api_payload_format" in t)) {
    var o = t.api_host || Zr.api_host;
    o.match(/\.mixpanel\.com/) && (n.api_payload_format = ss);
  }
  if (this.set_config(_.extend({}, Zr, n, t, {
    name: r,
    token: e,
    callback_fn: (r === le ? r : le + "." + r) + "._jsc"
  })), this._jsc = mt, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!_.localStorage.is_supported(!0) || !et)
      this._batch_requests = !1, z.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), _.each(this.get_batcher_configs(), function(i) {
        z.log("Clearing batch queue " + i.queue_key), _.localStorage.remove(i.queue_key);
      });
    else if (this.init_batchers(), $t && P.addEventListener) {
      var p = _.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      P.addEventListener("pagehide", function(i) {
        i.persisted && p();
      }), P.addEventListener("visibilitychange", function() {
        G.visibilityState === "hidden" && p();
      });
    }
  }
  this.persistence = this.cookie = new j(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var f = _.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: Er + f,
    $device_id: f
  }, "");
  var s = this.get_config("track_pageview");
  s && this._init_url_change_tracking(s), this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent") && this.start_session_recording();
};
M.prototype.start_session_recording = Ae(function() {
  if (!P.MutationObserver) {
    z.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var e = _.bind(function() {
    this._recorder = this._recorder || new P.__mp_recorder(this), this._recorder.startRecording();
  }, this);
  _.isUndefined(P.__mp_recorder) ? zn(this.get_config("recorder_src"), e) : e();
});
M.prototype.stop_session_recording = function() {
  this._recorder ? this._recorder.stopRecording() : z.critical("Session recorder module not loaded");
};
M.prototype.get_session_recording_properties = function() {
  var e = {}, t = this._get_session_replay_id();
  return t && (e.$mp_replay_id = t), e;
};
M.prototype.get_session_replay_url = function() {
  var e = null, t = this._get_session_replay_id();
  if (t) {
    var r = _.HTTPBuildQuery({
      replay_id: t,
      distinct_id: this.get_distinct_id(),
      token: this.get_config("token")
    });
    e = "https://mixpanel.com/projects/replay-redirect?" + r;
  }
  return e;
};
M.prototype._get_session_replay_id = function() {
  var e = null;
  return this._recorder && (e = this._recorder.replayId), e || null;
};
M.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var e = _.info.campaignParams(null);
    _.each(e, function(t, r) {
      this.unregister(r);
    }.bind(this));
  }
};
M.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(G.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(_.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(G.referrer);
};
M.prototype._dom_loaded = function() {
  _.each(this.__dom_loaded_queue, function(e) {
    this._track_dom.apply(this, e);
  }, this), this.has_opted_out_tracking() || _.each(this.__request_queue, function(e) {
    this._send_request.apply(this, e);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
M.prototype._track_dom = function(e, t) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!Yn)
    return this.__dom_loaded_queue.push([e, t]), !1;
  var r = new e().init(this);
  return r.track.apply(r, t);
};
M.prototype._init_url_change_tracking = function(e) {
  var t = "", r = this.track_pageview();
  if (r && (t = _.info.currentUrl()), _.include(["full-url", "url-with-path-and-query-string", "url-with-path"], e)) {
    P.addEventListener("popstate", function() {
      P.dispatchEvent(new Event("mp_locationchange"));
    }), P.addEventListener("hashchange", function() {
      P.dispatchEvent(new Event("mp_locationchange"));
    });
    var n = P.history.pushState;
    typeof n == "function" && (P.history.pushState = function(p, f, s) {
      n.call(P.history, p, f, s), P.dispatchEvent(new Event("mp_locationchange"));
    });
    var o = P.history.replaceState;
    typeof o == "function" && (P.history.replaceState = function(p, f, s) {
      o.call(P.history, p, f, s), P.dispatchEvent(new Event("mp_locationchange"));
    }), P.addEventListener("mp_locationchange", function() {
      var p = _.info.currentUrl(), f = !1;
      if (e === "full-url" ? f = p !== t : e === "url-with-path-and-query-string" ? f = p.split("#")[0] !== t.split("#")[0] : e === "url-with-path" && (f = p.split("#")[0].split("?")[0] !== t.split("#")[0].split("?")[0]), f) {
        var s = this.track_pageview();
        s && (t = p);
      }
    }.bind(this));
  }
};
M.prototype._prepare_callback = function(e, t) {
  if (_.isUndefined(e))
    return null;
  if (et) {
    var r = function(f) {
      e(f, t);
    };
    return r;
  } else {
    var n = this._jsc, o = "" + Math.floor(Math.random() * 1e8), p = this.get_config("callback_fn") + "[" + o + "]";
    return n[o] = function(f) {
      delete n[o], e(f, t);
    }, p;
  }
};
M.prototype._send_request = function(e, t, r, n) {
  var o = !0;
  if (Vn)
    return this.__request_queue.push(arguments), o;
  var p = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, f = null;
  !n && (_.isFunction(r) || typeof r == "string") && (n = r, r = null), r = _.extend(p, r || {}), et || (r.method = "GET");
  var s = r.method === "POST", i = $t && s && r.transport.toLowerCase() === "sendbeacon", d = r.verbose;
  t.verbose && (d = !0), this.get_config("test") && (t.test = 1), d && (t.verbose = 1), this.get_config("img") && (t.img = 1), et || (n ? t.callback = n : (d || this.get_config("test")) && (t.callback = "(function(){})")), t.ip = this.get_config("ip") ? 1 : 0, t._ = (/* @__PURE__ */ new Date()).getTime().toString(), s && (f = "data=" + encodeURIComponent(t.data), delete t.data), e += "?" + _.HTTPBuildQuery(t);
  var u = this;
  if ("img" in t) {
    var a = G.createElement("img");
    a.src = e, G.body.appendChild(a);
  } else if (i) {
    try {
      o = $t(e, f);
    } catch (m) {
      u.report_error(m), o = !1;
    }
    try {
      n && n(o ? 1 : 0);
    } catch (m) {
      u.report_error(m);
    }
  } else if (et)
    try {
      var l = new XMLHttpRequest();
      l.open(r.method, e, !0);
      var g = this.get_config("xhr_headers");
      if (s && (g["Content-Type"] = "application/x-www-form-urlencoded"), _.each(g, function(m, v) {
        l.setRequestHeader(v, m);
      }), r.timeout_ms && typeof l.timeout < "u") {
        l.timeout = r.timeout_ms;
        var c = (/* @__PURE__ */ new Date()).getTime();
      }
      l.withCredentials = !0, l.onreadystatechange = function() {
        if (l.readyState === 4)
          if (l.status === 200) {
            if (n)
              if (d) {
                var m;
                try {
                  m = _.JSONDecode(l.responseText);
                } catch (w) {
                  if (u.report_error(w), r.ignore_json_errors)
                    m = l.responseText;
                  else
                    return;
                }
                n(m);
              } else
                n(Number(l.responseText));
          } else {
            var v;
            if (l.timeout && !l.status && (/* @__PURE__ */ new Date()).getTime() - c >= l.timeout ? v = "timeout" : v = "Bad HTTP status: " + l.status + " " + l.statusText, u.report_error(v), n)
              if (d) {
                var y = l.responseHeaders || {};
                n({ status: 0, httpStatusCode: l.status, error: v, retryAfter: y["Retry-After"] });
              } else
                n(0);
          }
      }, l.send(f);
    } catch (m) {
      u.report_error(m), o = !1;
    }
  else {
    var h = G.createElement("script");
    h.type = "text/javascript", h.async = !0, h.defer = !0, h.src = e;
    var b = G.getElementsByTagName("script")[0];
    b.parentNode.insertBefore(h, b);
  }
  return o;
};
M.prototype._execute_array = function(e) {
  var t, r = [], n = [], o = [];
  _.each(e, function(f) {
    f && (t = f[0], _.isArray(t) ? o.push(f) : typeof f == "function" ? f.call(this) : _.isArray(f) && t === "alias" ? r.push(f) : _.isArray(f) && t.indexOf("track") !== -1 && typeof this[t] == "function" ? o.push(f) : n.push(f));
  }, this);
  var p = function(f, s) {
    _.each(f, function(i) {
      if (_.isArray(i[0])) {
        var d = s;
        _.each(i, function(u) {
          d = d[u[0]].apply(d, u.slice(1));
        });
      } else
        this[i[0]].apply(this, i.slice(1));
    }, s);
  };
  p(r, this), p(n, this), p(o, this);
};
M.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
M.prototype.get_batcher_configs = function() {
  var e = "__mpq_" + this.get_config("token"), t = this.get_config("api_routes");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", endpoint: "/" + t.track, queue_key: e + "_ev" },
    people: { type: "people", endpoint: "/" + t.engage, queue_key: e + "_pp" },
    groups: { type: "groups", endpoint: "/" + t.groups, queue_key: e + "_gr" }
  }, this._batcher_configs;
};
M.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var e = _.bind(function(r) {
      return new he(
        r.queue_key,
        {
          libConfig: this.config,
          errorReporter: this.get_config("error_reporter"),
          sendRequestFunc: _.bind(function(n, o, p) {
            this._send_request(
              this.get_config("api_host") + r.endpoint,
              this._encode_data_for_request(n),
              o,
              this._prepare_callback(p, n)
            );
          }, this),
          beforeSendHook: _.bind(function(n) {
            return this._run_hook("before_send_" + r.type, n);
          }, this),
          stopAllBatchingFunc: _.bind(this.stop_batch_senders, this),
          usePersistence: !0
        }
      );
    }, this), t = this.get_batcher_configs();
    this.request_batchers = {
      events: e(t.events),
      people: e(t.people),
      groups: e(t.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
M.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, _.each(this.request_batchers, function(e) {
    e.start();
  }));
};
M.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, _.each(this.request_batchers, function(e) {
    e.stop(), e.clear();
  });
};
M.prototype.push = function(e) {
  this._execute_array([e]);
};
M.prototype.disable = function(e) {
  typeof e > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(e);
};
M.prototype._encode_data_for_request = function(e) {
  var t = _.JSONEncode(e);
  return this.get_config("api_payload_format") === Jn && (t = _.base64Encode(t)), { data: t };
};
M.prototype._track_or_batch = function(e, t) {
  var r = _.truncate(e.data, 255), n = e.endpoint, o = e.batcher, p = e.should_send_immediately, f = e.send_request_options || {};
  t = t || mt;
  var s = !0, i = _.bind(function() {
    return f.skip_hooks || (r = this._run_hook("before_send_" + e.type, r)), r ? (z.log("MIXPANEL REQUEST:"), z.log(r), this._send_request(
      n,
      this._encode_data_for_request(r),
      f,
      this._prepare_callback(t, r)
    )) : null;
  }, this);
  return this._batch_requests && !p ? o.enqueue(r, function(d) {
    d ? t(1, r) : i();
  }) : s = i(), s && r;
};
M.prototype.track = Ae(function(e, t, r, n) {
  !n && typeof r == "function" && (n = r, r = null), r = r || {};
  var o = r.transport;
  o && (r.transport = o);
  var p = r.send_immediately;
  if (typeof n != "function" && (n = mt), _.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(e)) {
    n(0);
    return;
  }
  t = _.extend({}, t), t.token = this.get_config("token");
  var f = this.persistence.remove_event_timer(e);
  if (!_.isUndefined(f)) {
    var s = (/* @__PURE__ */ new Date()).getTime() - f;
    t.$duration = parseFloat((s / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var i = this.get_config("track_marketing") ? _.info.marketingParams() : {};
  t = _.extend(
    {},
    _.info.properties({ mp_loader: this.get_config("mp_loader") }),
    i,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    t
  );
  var d = this.get_config("property_blacklist");
  _.isArray(d) ? _.each(d, function(l) {
    delete t[l];
  }) : this.report_error("Invalid value for property_blacklist config: " + d);
  var u = {
    event: e,
    properties: t
  }, a = this._track_or_batch({
    type: "events",
    data: u,
    endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: p,
    send_request_options: r
  }, n);
  return a;
});
M.prototype.set_group = Ae(function(e, t, r) {
  _.isArray(t) || (t = [t]);
  var n = {};
  return n[e] = t, this.register(n), this.people.set(e, t, r);
});
M.prototype.add_group = Ae(function(e, t, r) {
  var n = this.get_property(e), o = {};
  return n === void 0 ? (o[e] = [t], this.register(o)) : n.indexOf(t) === -1 && (n.push(t), o[e] = n, this.register(o)), this.people.union(e, t, r);
});
M.prototype.remove_group = Ae(function(e, t, r) {
  var n = this.get_property(e);
  if (n !== void 0) {
    var o = n.indexOf(t);
    o > -1 && (n.splice(o, 1), this.register({ group_key: n })), n.length === 0 && this.unregister(e);
  }
  return this.people.remove(e, t, r);
});
M.prototype.track_with_groups = Ae(function(e, t, r, n) {
  var o = _.extend({}, t || {});
  return _.each(r, function(p, f) {
    p != null && (o[f] = p);
  }), this.track(e, o, n);
});
M.prototype._create_map_key = function(e, t) {
  return e + "_" + JSON.stringify(t);
};
M.prototype._remove_group_from_cache = function(e, t) {
  delete this._cached_groups[this._create_map_key(e, t)];
};
M.prototype.get_group = function(e, t) {
  var r = this._create_map_key(e, t), n = this._cached_groups[r];
  return (n === void 0 || n._group_key !== e || n._group_id !== t) && (n = new X(), n._init(this, e, t), this._cached_groups[r] = n), n;
};
M.prototype.track_pageview = Ae(function(e, t) {
  typeof e != "object" && (e = {}), t = t || {};
  var r = t.event_name || "$mp_web_page_view", n = _.extend(
    _.info.mpPageViewProperties(),
    _.info.campaignParams(),
    _.info.clickParams()
  ), o = _.extend(
    {},
    n,
    e
  );
  return this.track(r, o);
});
M.prototype.track_links = function() {
  return this._track_dom.call(this, rt, arguments);
};
M.prototype.track_forms = function() {
  return this._track_dom.call(this, Vt, arguments);
};
M.prototype.time_event = function(e) {
  if (_.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(e) || this.persistence.set_event_timer(e, (/* @__PURE__ */ new Date()).getTime());
};
var as = {
  persistent: !0
}, Ir = function(e) {
  var t;
  return _.isObject(e) ? t = e : _.isUndefined(e) ? t = {} : t = { days: e }, _.extend({}, as, t);
};
M.prototype.register = function(e, t) {
  var r = Ir(t);
  r.persistent ? this.persistence.register(e, r.days) : _.extend(this.unpersisted_superprops, e);
};
M.prototype.register_once = function(e, t, r) {
  var n = Ir(r);
  n.persistent ? this.persistence.register_once(e, t, n.days) : (typeof t > "u" && (t = "None"), _.each(e, function(o, p) {
    (!this.unpersisted_superprops.hasOwnProperty(p) || this.unpersisted_superprops[p] === t) && (this.unpersisted_superprops[p] = o);
  }, this));
};
M.prototype.unregister = function(e, t) {
  t = Ir(t), t.persistent ? this.persistence.unregister(e) : delete this.unpersisted_superprops[e];
};
M.prototype._register_single = function(e, t) {
  var r = {};
  r[e] = t, this.register(r);
};
M.prototype.identify = function(e, t, r, n, o, p, f, s) {
  var i = this.get_distinct_id();
  if (e && i !== e) {
    if (typeof e == "string" && e.indexOf(Er) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: e });
  }
  if (!this.get_property("$device_id")) {
    var d = i;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: d
    }, "");
  }
  e !== i && e !== this.get_property(Bt) && (this.unregister(Bt), this.register({ distinct_id: e })), this._flags.identify_called = !0, this.people._flush(t, r, n, o, p, f, s), e !== i && this.track("$identify", {
    distinct_id: e,
    $anon_distinct_id: i
  }, { skip_hooks: !0 });
};
M.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var e = _.UUID();
  this.register_once({
    distinct_id: Er + e,
    $device_id: e
  }, "");
};
M.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
M.prototype.alias = function(e, t) {
  if (e === this.get_property(Wn))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var r = this;
  return _.isUndefined(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single(Bt, e), this.track("$create_alias", {
    alias: e,
    distinct_id: t
  }, {
    skip_hooks: !0
  }, function() {
    r.identify(e);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(e), -1);
};
M.prototype.name_tag = function(e) {
  this._register_single("mp_name_tag", e);
};
M.prototype.set_config = function(e) {
  if (_.isObject(e)) {
    _.extend(this.config, e);
    var t = e.batch_size;
    t && _.each(this.request_batchers, function(r) {
      r.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), ye.DEBUG = ye.DEBUG || this.get_config("debug");
  }
};
M.prototype.get_config = function(e) {
  return this.config[e];
};
M.prototype._run_hook = function(e) {
  var t = (this.config.hooks[e] || os).apply(this, Oe.call(arguments, 1));
  return typeof t > "u" && (this.report_error(e + " hook did not return a value"), t = null), t;
};
M.prototype.get_property = function(e) {
  return this.persistence.load_prop([e]);
};
M.prototype.toString = function() {
  var e = this.get_config("name");
  return e !== le && (e = le + "." + e), e;
};
M.prototype._event_is_disabled = function(e) {
  return _.isBlockedUA(_e) || this._flags.disable_all_events || _.include(this.__disabled_events, e);
};
M.prototype._gdpr_init = function() {
  var e = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  e && _.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || _.cookie.get("mp_optout")) && (_.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
M.prototype._gdpr_update_persistence = function(e) {
  var t;
  if (e && e.clear_persistence)
    t = !0;
  else if (e && e.enable_persistence)
    t = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== t && this.persistence.set_disabled(t), t ? this.stop_batch_senders() : this._batchers_were_started && this.start_batch_senders();
};
M.prototype._gdpr_call_func = function(e, t) {
  return t = _.extend({
    track: _.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, t), _.localStorage.is_supported() || (t.persistence_type = "cookie"), e(this.get_config("token"), {
    track: t.track,
    trackEventName: t.track_event_name,
    trackProperties: t.track_properties,
    persistenceType: t.persistence_type,
    persistencePrefix: t.cookie_prefix,
    cookieDomain: t.cookie_domain,
    cookieExpiration: t.cookie_expiration,
    crossSiteCookie: t.cross_site_cookie,
    crossSubdomainCookie: t.cross_subdomain_cookie,
    secureCookie: t.secure_cookie,
    ignoreDnt: t.ignore_dnt
  });
};
M.prototype.opt_in_tracking = function(e) {
  e = _.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(Go, e), this._gdpr_update_persistence(e);
};
M.prototype.opt_out_tracking = function(e) {
  e = _.extend({
    clear_persistence: !0,
    delete_user: !0
  }, e), e.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(Jo, e), this._gdpr_update_persistence(e);
};
M.prototype.has_opted_in_tracking = function(e) {
  return this._gdpr_call_func(Vo, e);
};
M.prototype.has_opted_out_tracking = function(e) {
  return this._gdpr_call_func(Fn, e);
};
M.prototype.clear_opt_in_out_tracking = function(e) {
  e = _.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(Xo, e), this._gdpr_update_persistence(e);
};
M.prototype.report_error = function(e, t) {
  z.error.apply(z.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, t);
  } catch (r) {
    z.error(r);
  }
};
M.prototype.init = M.prototype.init;
M.prototype.reset = M.prototype.reset;
M.prototype.disable = M.prototype.disable;
M.prototype.time_event = M.prototype.time_event;
M.prototype.track = M.prototype.track;
M.prototype.track_links = M.prototype.track_links;
M.prototype.track_forms = M.prototype.track_forms;
M.prototype.track_pageview = M.prototype.track_pageview;
M.prototype.register = M.prototype.register;
M.prototype.register_once = M.prototype.register_once;
M.prototype.unregister = M.prototype.unregister;
M.prototype.identify = M.prototype.identify;
M.prototype.alias = M.prototype.alias;
M.prototype.name_tag = M.prototype.name_tag;
M.prototype.set_config = M.prototype.set_config;
M.prototype.get_config = M.prototype.get_config;
M.prototype.get_property = M.prototype.get_property;
M.prototype.get_distinct_id = M.prototype.get_distinct_id;
M.prototype.toString = M.prototype.toString;
M.prototype.opt_out_tracking = M.prototype.opt_out_tracking;
M.prototype.opt_in_tracking = M.prototype.opt_in_tracking;
M.prototype.has_opted_out_tracking = M.prototype.has_opted_out_tracking;
M.prototype.has_opted_in_tracking = M.prototype.has_opted_in_tracking;
M.prototype.clear_opt_in_out_tracking = M.prototype.clear_opt_in_out_tracking;
M.prototype.get_group = M.prototype.get_group;
M.prototype.set_group = M.prototype.set_group;
M.prototype.add_group = M.prototype.add_group;
M.prototype.remove_group = M.prototype.remove_group;
M.prototype.track_with_groups = M.prototype.track_with_groups;
M.prototype.start_batch_senders = M.prototype.start_batch_senders;
M.prototype.stop_batch_senders = M.prototype.stop_batch_senders;
M.prototype.start_session_recording = M.prototype.start_session_recording;
M.prototype.stop_session_recording = M.prototype.stop_session_recording;
M.prototype.get_session_recording_properties = M.prototype.get_session_recording_properties;
M.prototype.get_session_replay_url = M.prototype.get_session_replay_url;
M.prototype.DEFAULT_API_ROUTES = Xn;
j.prototype.properties = j.prototype.properties;
j.prototype.update_search_keyword = j.prototype.update_search_keyword;
j.prototype.update_referrer_info = j.prototype.update_referrer_info;
j.prototype.get_cross_subdomain = j.prototype.get_cross_subdomain;
j.prototype.clear = j.prototype.clear;
var Ke = {}, us = function() {
  _.each(Ke, function(e, t) {
    t !== le && (ne[t] = e);
  }), ne._ = _;
}, cs = function() {
  ne.init = function(e, t, r) {
    if (r)
      return ne[r] || (ne[r] = Ke[r] = cr(e, t, r), ne[r]._loaded()), ne[r];
    var n = ne;
    Ke[le] ? n = Ke[le] : e && (n = cr(e, t, le), n._loaded(), Ke[le] = n), ne = n, xr === is && (P[le] = ne), us();
  };
}, ls = function() {
  function e() {
    e.done || (e.done = !0, Yn = !0, Vn = !1, _.each(Ke, function(n) {
      n._dom_loaded();
    }));
  }
  function t() {
    try {
      G.documentElement.doScroll("left");
    } catch {
      setTimeout(t, 1);
      return;
    }
    e();
  }
  if (G.addEventListener)
    G.readyState === "complete" ? e() : G.addEventListener("DOMContentLoaded", e, !1);
  else if (G.attachEvent) {
    G.attachEvent("onreadystatechange", e);
    var r = !1;
    try {
      r = P.frameElement === null;
    } catch {
    }
    G.documentElement.doScroll && r && t();
  }
  _.register_event(P, "load", e, !0);
};
function ps(e) {
  return zn = e, xr = Gn, ne = new M(), cs(), ne.init(), ls(), ne;
}
function ds(e, t) {
  t();
}
var Kn = ps(ds);
function ze({
  requireAuth: e = !1
} = {}) {
  const t = Re(), r = We(cn);
  return e && r.state === ue.Unauthenticated && (window.location.href = `${t.authUrl}/login?redirect=${window.location.href}`), r;
}
class fs {
  init(t, r, n) {
  }
  identify(t) {
    this.id = t;
  }
  register(t) {
    this.baseMetadata = t;
  }
  track(t, r) {
    this.debug === !0 && console.debug("Would track: ", t, {
      ...r,
      ...this.baseMetadata,
      id: this.id
    });
  }
}
const Qn = /* @__PURE__ */ He.createContext(Kn);
function hs({
  children: e,
  ...t
}) {
  const r = t.enabled ? Kn : new fs(), [n, o] = ke(!1), p = ze(), f = Re();
  return Me(() => {
    r.init(t.enabled === !0 ? t.mixpanelToken : void 0, {
      debug: t.debug
    });
  }, [r, t]), Me(() => {
    if (p.state === ue.Unknown)
      return;
    if (p.state === ue.Unauthenticated) {
      o(!0);
      return;
    }
    const s = p.user;
    r.identify(s.email), r.register({
      account_id: s.accountId,
      product: f.productName,
      masquerading: s.isMasquerading,
      $email: s.email,
      "Impersonator Email": s.isMasquerading ? s.realUserEmail : void 0,
      subscription_id: s.subscriptions.find((i) => i.product.name === f.productName)?.id
    }), o(!0);
  }, [p, f.productName, r]), p.state === ue.Unknown || !n ? null : /* @__PURE__ */ W(Qn.Provider, { value: r, children: e });
}
var ms = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zn = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(ms, () => {
    return r = { 276: function() {
      (function(o) {
        o.console || (o.console = {});
        for (var p, f, s = o.console, i = function() {
        }, d = ["memory"], u = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); p = d.pop(); ) s[p] || (s[p] = {});
        for (; f = u.pop(); ) s[f] || (s[f] = i);
      })(typeof window > "u" ? this : window);
    }, 180: function(o, p, f) {
      var s, i, d;
      (function(u, a) {
        i = [f(124)], (d = typeof (s = function(l) {
          var g = /(^|@)\S+:\d+/, c = /^\s*at .*(\S+:\d+|\(native\))/m, h = /^(eval@)?(\[native code])?$/;
          return { parse: function(b) {
            if (b.stacktrace !== void 0 || b["opera#sourceloc"] !== void 0) return this.parseOpera(b);
            if (b.stack && b.stack.match(c)) return this.parseV8OrIE(b);
            if (b.stack) return this.parseFFOrSafari(b);
            throw new Error("Cannot parse given Error object");
          }, extractLocation: function(b) {
            if (b.indexOf(":") === -1) return [b];
            var m = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(b.replace(/[()]/g, ""));
            return [m[1], m[2] || void 0, m[3] || void 0];
          }, parseV8OrIE: function(b) {
            return b.stack.split(`
`).filter(function(m) {
              return !!m.match(c);
            }, this).map(function(m) {
              m.indexOf("(eval ") > -1 && (m = m.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
              var v = m.replace(/^\s+/, "").replace(/\(eval code/g, "("), y = v.match(/ (\((.+):(\d+):(\d+)\)$)/), w = (v = y ? v.replace(y[0], "") : v).split(/\s+/).slice(1), E = this.extractLocation(y ? y[1] : w.pop()), C = w.join(" ") || void 0, k = ["eval", "<anonymous>"].indexOf(E[0]) > -1 ? void 0 : E[0];
              return new l({ functionName: C, fileName: k, lineNumber: E[1], columnNumber: E[2], source: m });
            }, this);
          }, parseFFOrSafari: function(b) {
            return b.stack.split(`
`).filter(function(m) {
              return !m.match(h);
            }, this).map(function(m) {
              if (m.indexOf(" > eval") > -1 && (m = m.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), m.indexOf("@") === -1 && m.indexOf(":") === -1) return new l({ functionName: m });
              var v = /((.*".+"[^@]*)?[^@]*)(?:@)/, y = m.match(v), w = y && y[1] ? y[1] : void 0, E = this.extractLocation(m.replace(v, ""));
              return new l({ functionName: w, fileName: E[0], lineNumber: E[1], columnNumber: E[2], source: m });
            }, this);
          }, parseOpera: function(b) {
            return !b.stacktrace || b.message.indexOf(`
`) > -1 && b.message.split(`
`).length > b.stacktrace.split(`
`).length ? this.parseOpera9(b) : b.stack ? this.parseOpera11(b) : this.parseOpera10(b);
          }, parseOpera9: function(b) {
            for (var m = /Line (\d+).*script (?:in )?(\S+)/i, v = b.message.split(`
`), y = [], w = 2, E = v.length; w < E; w += 2) {
              var C = m.exec(v[w]);
              C && y.push(new l({ fileName: C[2], lineNumber: C[1], source: v[w] }));
            }
            return y;
          }, parseOpera10: function(b) {
            for (var m = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, v = b.stacktrace.split(`
`), y = [], w = 0, E = v.length; w < E; w += 2) {
              var C = m.exec(v[w]);
              C && y.push(new l({ functionName: C[3] || void 0, fileName: C[2], lineNumber: C[1], source: v[w] }));
            }
            return y;
          }, parseOpera11: function(b) {
            return b.stack.split(`
`).filter(function(m) {
              return !!m.match(g) && !m.match(/^Error created at/);
            }, this).map(function(m) {
              var v, y = m.split("@"), w = this.extractLocation(y.pop()), E = y.shift() || "", C = E.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
              E.match(/\(([^)]*)\)/) && (v = E.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
              var k = v === void 0 || v === "[arguments not available]" ? void 0 : v.split(",");
              return new l({ functionName: C, args: k, fileName: w[0], lineNumber: w[1], columnNumber: w[2], source: m });
            }, this);
          } };
        }) == "function" ? s.apply(p, i) : s) === void 0 || (o.exports = d);
      })();
    }, 124: function(o, p) {
      var f, s, i;
      (function(d, u) {
        s = [], (i = typeof (f = function() {
          function a(S) {
            return !isNaN(parseFloat(S)) && isFinite(S);
          }
          function l(S) {
            return S.charAt(0).toUpperCase() + S.substring(1);
          }
          function g(S) {
            return function() {
              return this[S];
            };
          }
          var c = ["isConstructor", "isEval", "isNative", "isToplevel"], h = ["columnNumber", "lineNumber"], b = ["fileName", "functionName", "source"], m = ["args"], v = ["evalOrigin"], y = c.concat(h, b, m, v);
          function w(S) {
            if (S) for (var O = 0; O < y.length; O++) S[y[O]] !== void 0 && this["set" + l(y[O])](S[y[O]]);
          }
          w.prototype = { getArgs: function() {
            return this.args;
          }, setArgs: function(S) {
            if (Object.prototype.toString.call(S) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = S;
          }, getEvalOrigin: function() {
            return this.evalOrigin;
          }, setEvalOrigin: function(S) {
            if (S instanceof w) this.evalOrigin = S;
            else {
              if (!(S instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
              this.evalOrigin = new w(S);
            }
          }, toString: function() {
            var S = this.getFileName() || "", O = this.getLineNumber() || "", T = this.getColumnNumber() || "", x = this.getFunctionName() || "";
            return this.getIsEval() ? S ? "[eval] (" + S + ":" + O + ":" + T + ")" : "[eval]:" + O + ":" + T : x ? x + " (" + S + ":" + O + ":" + T + ")" : S + ":" + O + ":" + T;
          } }, w.fromString = function(S) {
            var O = S.indexOf("("), T = S.lastIndexOf(")"), x = S.substring(0, O), I = S.substring(O + 1, T).split(","), R = S.substring(T + 1);
            if (R.indexOf("@") === 0) var N = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(R, ""), D = N[1], A = N[2], L = N[3];
            return new w({ functionName: x, args: I || void 0, fileName: D, lineNumber: A || void 0, columnNumber: L || void 0 });
          };
          for (var E = 0; E < c.length; E++) w.prototype["get" + l(c[E])] = g(c[E]), w.prototype["set" + l(c[E])] = /* @__PURE__ */ function(S) {
            return function(O) {
              this[S] = !!O;
            };
          }(c[E]);
          for (var C = 0; C < h.length; C++) w.prototype["get" + l(h[C])] = g(h[C]), w.prototype["set" + l(h[C])] = /* @__PURE__ */ function(S) {
            return function(O) {
              if (!a(O)) throw new TypeError(S + " must be a Number");
              this[S] = Number(O);
            };
          }(h[C]);
          for (var k = 0; k < b.length; k++) w.prototype["get" + l(b[k])] = g(b[k]), w.prototype["set" + l(b[k])] = /* @__PURE__ */ function(S) {
            return function(O) {
              this[S] = String(O);
            };
          }(b[k]);
          return w;
        }) == "function" ? f.apply(p, s) : f) === void 0 || (o.exports = i);
      })();
    }, 815: (o, p, f) => {
      var s = f(702), i = f(817), d = { hostname: "api.rollbar.com", path: "/api/1/item/", search: null, version: "1", protocol: "https:", port: 443 };
      function u(l, g, c, h, b) {
        this.options = l, this.transport = g, this.url = c, this.truncation = h, this.jsonBackup = b, this.accessToken = l.accessToken, this.transportOptions = a(l, c);
      }
      function a(l, g) {
        return i.getTransportFromOptions(l, d, g);
      }
      u.prototype.postItem = function(l, g) {
        var c = i.transportOptions(this.transportOptions, "POST"), h = i.buildPayload(this.accessToken, l, this.jsonBackup), b = this;
        setTimeout(function() {
          b.transport.post(b.accessToken, c, h, g);
        }, 0);
      }, u.prototype.buildJsonPayload = function(l, g) {
        var c, h = i.buildPayload(this.accessToken, l, this.jsonBackup);
        return (c = this.truncation ? this.truncation.truncate(h) : s.stringify(h)).error ? (g && g(c.error), null) : c.value;
      }, u.prototype.postJsonPayload = function(l, g) {
        var c = i.transportOptions(this.transportOptions, "POST");
        this.transport.postJsonPayload(this.accessToken, c, l, g);
      }, u.prototype.configure = function(l) {
        var g = this.oldOptions;
        return this.options = s.merge(g, l), this.transportOptions = a(this.options, this.url), this.options.accessToken !== void 0 && (this.accessToken = this.options.accessToken), this;
      }, o.exports = u;
    }, 817: (o, p, f) => {
      var s = f(702);
      o.exports = { buildPayload: function(i, d, u) {
        if (!s.isType(d.context, "string")) {
          var a = s.stringify(d.context, u);
          a.error ? d.context = "Error: could not serialize 'context'" : d.context = a.value || "", d.context.length > 255 && (d.context = d.context.substr(0, 255));
        }
        return { access_token: i, data: d };
      }, getTransportFromOptions: function(i, d, u) {
        var a = d.hostname, l = d.protocol, g = d.port, c = d.path, h = d.search, b = i.timeout, m = function(w) {
          var E = typeof window < "u" && window || typeof self < "u" && self, C = w.defaultTransport || "xhr";
          return E.fetch === void 0 && (C = "xhr"), E.XMLHttpRequest === void 0 && (C = "fetch"), C;
        }(i), v = i.proxy;
        if (i.endpoint) {
          var y = u.parse(i.endpoint);
          a = y.hostname, l = y.protocol, g = y.port, c = y.pathname, h = y.search;
        }
        return { timeout: b, hostname: a, protocol: l, port: g, path: c, search: h, proxy: v, transport: m };
      }, transportOptions: function(i, d) {
        var u = i.protocol || "https:", a = i.port || (u === "http:" ? 80 : u === "https:" ? 443 : void 0), l = i.hostname, g = i.path, c = i.timeout, h = i.transport;
        return i.search && (g += i.search), i.proxy && (g = u + "//" + l + g, l = i.proxy.host || i.proxy.hostname, a = i.proxy.port, u = i.proxy.protocol || u), { timeout: c, protocol: u, hostname: l, path: g, port: a, method: d, transport: h };
      }, appendPathToPath: function(i, d) {
        var u = /\/$/.test(i), a = /^\//.test(d);
        return u && a ? d = d.substring(1) : u || a || (d = "/" + d), i + d;
      } };
    }, 409: (o, p, f) => {
      var s = f(343), i = typeof window < "u" && window._rollbarConfig, d = i && i.globalAlias || "Rollbar", u = typeof window < "u" && window[d] && typeof window[d].shimId == "function" && window[d].shimId() !== void 0;
      if (typeof window > "u" || window._rollbarStartTime || (window._rollbarStartTime = (/* @__PURE__ */ new Date()).getTime()), !u && i) {
        var a = new s(i);
        window[d] = a;
      } else typeof window < "u" ? (window.rollbar = s, window._rollbarDidLoad = !0) : typeof self < "u" && (self.rollbar = s, self._rollbarDidLoad = !0);
      o.exports = s;
    }, 403: (o, p, f) => {
      var s = f(562), i = f(702), d = f(815), u = f(802), a = f(349), l = f(477), g = f(509), c = f(860), h = f(417), b = f(172), m = f(61), v = f(303);
      function y(x, I) {
        this.options = i.handleOptions(T, x, null, u), this.options._configuredOptions = x;
        var R = this.components.telemeter, N = this.components.instrumenter, D = this.components.polyfillJSON;
        this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
        var A = this.components.truncation, L = new l(A), q = new d(this.options, L, g, A);
        R && (this.telemeter = new R(this.options)), this.client = I || new s(this.options, q, u, this.telemeter, "browser");
        var te = k(), Ee = typeof document < "u" && document;
        this.isChrome = te.chrome && te.chrome.runtime, this.anonymousErrorsPending = 0, function(Pe, Ie, ce) {
          Pe.addTransform(c.handleDomException).addTransform(c.handleItemWithError).addTransform(c.ensureItemHasSomethingToSay).addTransform(c.addBaseInfo).addTransform(c.addRequestInfo(ce)).addTransform(c.addClientInfo(ce)).addTransform(c.addPluginInfo(ce)).addTransform(c.addBody).addTransform(h.addMessageWithError).addTransform(h.addTelemetryData).addTransform(h.addConfigToPayload).addTransform(c.addScrubber(Ie.scrub)).addTransform(h.addPayloadOptions).addTransform(h.userTransform(u)).addTransform(h.addConfiguredOptions).addTransform(h.addDiagnosticKeys).addTransform(h.itemToPayload);
        }(this.client.notifier, this, te), this.client.queue.addPredicate(m.checkLevel).addPredicate(b.checkIgnore).addPredicate(m.userCheckIgnore(u)).addPredicate(m.urlIsNotBlockListed(u)).addPredicate(m.urlIsSafeListed(u)).addPredicate(m.messageIsIgnored(u)), this.setupUnhandledCapture(), N && (this.instrumenter = new N(this.options, this.client.telemeter, this, te, Ee), this.instrumenter.instrument()), i.setupJSON(D), this.rollbar = this;
      }
      var w = null;
      function E(x) {
        var I = "Rollbar is not initialized";
        u.error(I), x && x(new Error(I));
      }
      function C(x) {
        for (var I = 0, R = x.length; I < R; ++I) if (i.isFunction(x[I])) return x[I];
      }
      function k() {
        return typeof window < "u" && window || typeof self < "u" && self;
      }
      y.init = function(x, I) {
        return w ? w.global(x).configure(x) : w = new y(x, I);
      }, y.prototype.components = {}, y.setComponents = function(x) {
        y.prototype.components = x;
      }, y.prototype.global = function(x) {
        return this.client.global(x), this;
      }, y.global = function(x) {
        if (w) return w.global(x);
        E();
      }, y.prototype.configure = function(x, I) {
        var R = this.options, N = {};
        return I && (N = { payload: I }), this.options = i.handleOptions(R, x, N, u), this.options._configuredOptions = i.handleOptions(R._configuredOptions, x, N), this.client.configure(this.options, I), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
      }, y.configure = function(x, I) {
        if (w) return w.configure(x, I);
        E();
      }, y.prototype.lastError = function() {
        return this.client.lastError;
      }, y.lastError = function() {
        if (w) return w.lastError();
        E();
      }, y.prototype.log = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.log(x), { uuid: I };
      }, y.log = function() {
        if (w) return w.log.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.debug = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.debug(x), { uuid: I };
      }, y.debug = function() {
        if (w) return w.debug.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.info = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.info(x), { uuid: I };
      }, y.info = function() {
        if (w) return w.info.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.warn = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.warn(x), { uuid: I };
      }, y.warn = function() {
        if (w) return w.warn.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.warning = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.warning(x), { uuid: I };
      }, y.warning = function() {
        if (w) return w.warning.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.error = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.error(x), { uuid: I };
      }, y.error = function() {
        if (w) return w.error.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.critical = function() {
        var x = this._createItem(arguments), I = x.uuid;
        return this.client.critical(x), { uuid: I };
      }, y.critical = function() {
        if (w) return w.critical.apply(w, arguments);
        E(C(arguments));
      }, y.prototype.buildJsonPayload = function(x) {
        return this.client.buildJsonPayload(x);
      }, y.buildJsonPayload = function() {
        if (w) return w.buildJsonPayload.apply(w, arguments);
        E();
      }, y.prototype.sendJsonPayload = function(x) {
        return this.client.sendJsonPayload(x);
      }, y.sendJsonPayload = function() {
        if (w) return w.sendJsonPayload.apply(w, arguments);
        E();
      }, y.prototype.setupUnhandledCapture = function() {
        var x = k();
        this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (a.captureUncaughtExceptions(x, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(x, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (a.captureUnhandledRejections(x, this), this.unhandledRejectionsInitialized = !0);
      }, y.prototype.handleUncaughtException = function(x, I, R, N, D, A) {
        if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
          if (this.options.inspectAnonymousErrors && this.isChrome && D === null && I === "") return "anonymous";
          var L, q = i.makeUnhandledStackInfo(x, I, R, N, D, "onerror", "uncaught exception", v);
          i.isError(D) ? (L = this._createItem([x, D, A]))._unhandledStackInfo = q : i.isError(I) ? (L = this._createItem([x, I, A]))._unhandledStackInfo = q : (L = this._createItem([x, A])).stackInfo = q, L.level = this.options.uncaughtErrorLevel, L._isUncaught = !0, this.client.log(L);
        }
      }, y.prototype.handleAnonymousErrors = function() {
        if (this.options.inspectAnonymousErrors && this.isChrome) {
          var x = this;
          try {
            Error.prepareStackTrace = function(I, R) {
              if (x.options.inspectAnonymousErrors && x.anonymousErrorsPending) {
                if (x.anonymousErrorsPending -= 1, !I) return;
                I._isAnonymous = !0, x.handleUncaughtException(I.message, null, null, null, I);
              }
              return I.stack;
            };
          } catch (I) {
            this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", I);
          }
        }
      }, y.prototype.handleUnhandledRejection = function(x, I) {
        if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
          var R = "unhandled rejection was null or undefined!";
          if (x) if (x.message) R = x.message;
          else {
            var N = i.stringify(x);
            N.value && (R = N.value);
          }
          var D, A = x && x._rollbarContext || I && I._rollbarContext;
          i.isError(x) ? D = this._createItem([R, x, A]) : (D = this._createItem([R, x, A])).stackInfo = i.makeUnhandledStackInfo(R, "", 0, 0, null, "unhandledrejection", "", v), D.level = this.options.uncaughtErrorLevel, D._isUncaught = !0, D._originalArgs = D._originalArgs || [], D._originalArgs.push(I), this.client.log(D);
        }
      }, y.prototype.wrap = function(x, I, R) {
        try {
          var N;
          if (N = i.isFunction(I) ? I : function() {
            return I || {};
          }, !i.isFunction(x) || x._isWrap) return x;
          if (!x._rollbar_wrapped && (x._rollbar_wrapped = function() {
            R && i.isFunction(R) && R.apply(this, arguments);
            try {
              return x.apply(this, arguments);
            } catch (L) {
              var A = L;
              throw A && window._rollbarWrappedError !== A && (i.isType(A, "string") && (A = new String(A)), A._rollbarContext = N() || {}, A._rollbarContext._wrappedSource = x.toString(), window._rollbarWrappedError = A), A;
            }
          }, x._rollbar_wrapped._isWrap = !0, x.hasOwnProperty)) for (var D in x) x.hasOwnProperty(D) && D !== "_rollbar_wrapped" && (x._rollbar_wrapped[D] = x[D]);
          return x._rollbar_wrapped;
        } catch {
          return x;
        }
      }, y.wrap = function(x, I) {
        if (w) return w.wrap(x, I);
        E();
      }, y.prototype.captureEvent = function() {
        var x = i.createTelemetryEvent(arguments);
        return this.client.captureEvent(x.type, x.metadata, x.level);
      }, y.captureEvent = function() {
        if (w) return w.captureEvent.apply(w, arguments);
        E();
      }, y.prototype.captureDomContentLoaded = function(x, I) {
        return I || (I = /* @__PURE__ */ new Date()), this.client.captureDomContentLoaded(I);
      }, y.prototype.captureLoad = function(x, I) {
        return I || (I = /* @__PURE__ */ new Date()), this.client.captureLoad(I);
      }, y.prototype.loadFull = function() {
        u.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
      }, y.prototype._createItem = function(x) {
        return i.createItem(x, u, this);
      };
      var S = f(948), O = f(677), T = { version: S.version, scrubFields: O.scrubFields, logLevel: S.logLevel, reportLevel: S.reportLevel, uncaughtErrorLevel: S.uncaughtErrorLevel, endpoint: S.endpoint, verbose: !1, enabled: !0, transmit: !0, sendConfig: !1, includeItemsInTelemetry: !0, captureIp: !0, inspectAnonymousErrors: !0, ignoreDuplicateErrors: !0, wrapGlobalEventHandlers: !1 };
      o.exports = y;
    }, 677: (o) => {
      o.exports = { scrubFields: ["pw", "pass", "passwd", "password", "secret", "confirm_password", "confirmPassword", "password_confirmation", "passwordConfirmation", "access_token", "accessToken", "X-Rollbar-Access-Token", "secret_key", "secretKey", "secretToken", "cc-number", "card number", "cardnumber", "cardnum", "ccnum", "ccnumber", "cc num", "creditcardnumber", "credit card number", "newcreditcardnumber", "new credit card", "creditcardno", "credit card no", "card#", "card #", "cc-csc", "cvc", "cvc2", "cvv2", "ccv2", "security code", "card verification", "name on credit card", "name on card", "nameoncard", "cardholder", "card holder", "name des karteninhabers", "ccname", "card type", "cardtype", "cc type", "cctype", "payment type", "expiration date", "expirationdate", "expdate", "cc-exp", "ccmonth", "ccyear"] };
    }, 616: (o) => {
      var p = { ieVersion: function() {
        var f;
        if (typeof document > "u") return f;
        for (var s = 3, i = document.createElement("div"), d = i.getElementsByTagName("i"); i.innerHTML = "<!--[if gt IE " + ++s + "]><i></i><![endif]-->", d[0]; ) ;
        return s > 4 ? s : f;
      } };
      o.exports = p;
    }, 300: (o) => {
      function p(i) {
        return (i.getAttribute("type") || "").toLowerCase();
      }
      function f(i) {
        if (!i || !i.tagName) return "";
        var d = [i.tagName];
        i.id && d.push("#" + i.id), i.classes && d.push("." + i.classes.join("."));
        for (var u = 0; u < i.attributes.length; u++) d.push("[" + i.attributes[u].key + '="' + i.attributes[u].value + '"]');
        return d.join("");
      }
      function s(i) {
        if (!i || !i.tagName) return null;
        var d, u, a, l, g = {};
        g.tagName = i.tagName.toLowerCase(), i.id && (g.id = i.id), (d = i.className) && typeof d == "string" && (g.classes = d.split(/\s+/));
        var c = ["type", "name", "title", "alt"];
        for (g.attributes = [], l = 0; l < c.length; l++) u = c[l], (a = i.getAttribute(u)) && g.attributes.push({ key: u, value: a });
        return g;
      }
      o.exports = { describeElement: s, descriptionToString: f, elementArrayToString: function(i) {
        for (var d, u, a = [], l = 0, g = i.length - 1; g >= 0; g--) {
          if (d = f(i[g]), u = l + 3 * a.length + d.length, g < i.length - 1 && u >= 83) {
            a.unshift("...");
            break;
          }
          a.unshift(d), l += d.length;
        }
        return a.join(" > ");
      }, treeToArray: function(i) {
        for (var d, u = [], a = 0; i && a < 5 && (d = s(i)).tagName !== "html"; a++) u.unshift(d), i = i.parentNode;
        return u;
      }, getElementFromEvent: function(i, d) {
        return i.target ? i.target : d && d.elementFromPoint ? d.elementFromPoint(i.clientX, i.clientY) : void 0;
      }, isDescribedElement: function(i, d, u) {
        if (i.tagName.toLowerCase() !== d.toLowerCase()) return !1;
        if (!u) return !0;
        i = p(i);
        for (var a = 0; a < u.length; a++) if (u[a] === i) return !0;
        return !1;
      }, getElementType: p };
    }, 349: (o) => {
      o.exports = { captureUncaughtExceptions: function(p, f, s) {
        if (p) {
          var i;
          if (typeof f._rollbarOldOnError == "function") i = f._rollbarOldOnError;
          else if (p.onerror) {
            for (i = p.onerror; i._rollbarOldOnError; ) i = i._rollbarOldOnError;
            f._rollbarOldOnError = i;
          }
          f.handleAnonymousErrors();
          var d = function() {
            var u = Array.prototype.slice.call(arguments, 0);
            (function(a, l, g, c) {
              a._rollbarWrappedError && (c[4] || (c[4] = a._rollbarWrappedError), c[5] || (c[5] = a._rollbarWrappedError._rollbarContext), a._rollbarWrappedError = null);
              var h = l.handleUncaughtException.apply(l, c);
              g && g.apply(a, c), h === "anonymous" && (l.anonymousErrorsPending += 1);
            })(p, f, i, u);
          };
          s && (d._rollbarOldOnError = i), p.onerror = d;
        }
      }, captureUnhandledRejections: function(p, f, s) {
        if (p) {
          typeof p._rollbarURH == "function" && p._rollbarURH.belongsToShim && p.removeEventListener("unhandledrejection", p._rollbarURH);
          var i = function(d) {
            var u, a, l;
            try {
              u = d.reason;
            } catch {
              u = void 0;
            }
            try {
              a = d.promise;
            } catch {
              a = "[unhandledrejection] error getting `promise` from event";
            }
            try {
              l = d.detail, !u && l && (u = l.reason, a = l.promise);
            } catch {
            }
            u || (u = "[unhandledrejection] error getting `reason` from event"), f && f.handleUnhandledRejection && f.handleUnhandledRejection(u, a);
          };
          i.belongsToShim = s, p._rollbarURH = i, p.addEventListener("unhandledrejection", i);
        }
      } };
    }, 802: (o, p, f) => {
      f(276);
      var s = f(616), i = f(702);
      o.exports = { error: function() {
        var d = Array.prototype.slice.call(arguments, 0);
        d.unshift("Rollbar:"), s.ieVersion() <= 8 ? console.error(i.formatArgsAsString(d)) : console.error.apply(console, d);
      }, info: function() {
        var d = Array.prototype.slice.call(arguments, 0);
        d.unshift("Rollbar:"), s.ieVersion() <= 8 ? console.info(i.formatArgsAsString(d)) : console.info.apply(console, d);
      }, log: function() {
        var d = Array.prototype.slice.call(arguments, 0);
        d.unshift("Rollbar:"), s.ieVersion() <= 8 ? console.log(i.formatArgsAsString(d)) : console.log.apply(console, d);
      } };
    }, 172: (o, p, f) => {
      var s = f(702);
      o.exports = { checkIgnore: function(i, d) {
        return !s.get(d, "plugins.jquery.ignoreAjaxErrors") || !s.get(i, "body.message.extra.isAjax");
      } };
    }, 343: (o, p, f) => {
      var s = f(403), i = f(773), d = f(568), u = f(876), a = f(965), l = f(369), g = f(473);
      s.setComponents({ telemeter: i, instrumenter: d, polyfillJSON: u, wrapGlobals: a, scrub: l, truncation: g }), o.exports = s;
    }, 568: (o, p, f) => {
      var s = f(702), i = f(650), d = f(297), u = f(369), a = f(509), l = f(300), g = { network: !0, networkResponseHeaders: !1, networkResponseBody: !1, networkRequestHeaders: !1, networkRequestBody: !1, networkErrorOnHttp5xx: !1, networkErrorOnHttp4xx: !1, networkErrorOnHttp0: !1, log: !0, dom: !0, navigation: !0, connectivity: !0, contentSecurityPolicy: !0, errorOnContentSecurityPolicy: !1 };
      function c(m, v) {
        for (var y; m[v].length; ) (y = m[v].shift())[0][y[1]] = y[2];
      }
      function h(m, v, y, w, E) {
        this.options = m;
        var C = m.autoInstrument;
        m.enabled === !1 || C === !1 ? this.autoInstrument = {} : (s.isType(C, "object") || (C = g), this.autoInstrument = s.merge(g, C)), this.scrubTelemetryInputs = !!m.scrubTelemetryInputs, this.telemetryScrubber = m.telemetryScrubber, this.defaultValueScrubber = function(k) {
          for (var S = [], O = 0; O < k.length; ++O) S.push(new RegExp(k[O], "i"));
          return function(T) {
            var x = function(R) {
              if (!R || !R.attributes) return null;
              for (var N = R.attributes, D = 0; D < N.length; ++D) if (N[D].key === "name") return N[D].value;
              return null;
            }(T);
            if (!x) return !1;
            for (var I = 0; I < S.length; ++I) if (S[I].test(x)) return !0;
            return !1;
          };
        }(m.scrubFields), this.telemeter = v, this.rollbar = y, this.diagnostic = y.client.notifier.diagnostic, this._window = w || {}, this._document = E || {}, this.replacements = { network: [], log: [], navigation: [], connectivity: [] }, this.eventRemovers = { dom: [], connectivity: [], contentsecuritypolicy: [] }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
      }
      function b(m) {
        return typeof URL < "u" && m instanceof URL;
      }
      h.prototype.configure = function(m) {
        this.options = s.merge(this.options, m);
        var v = m.autoInstrument, y = s.merge(this.autoInstrument);
        m.enabled === !1 || v === !1 ? this.autoInstrument = {} : (s.isType(v, "object") || (v = g), this.autoInstrument = s.merge(g, v)), this.instrument(y), m.scrubTelemetryInputs !== void 0 && (this.scrubTelemetryInputs = !!m.scrubTelemetryInputs), m.telemetryScrubber !== void 0 && (this.telemetryScrubber = m.telemetryScrubber);
      }, h.prototype.instrument = function(m) {
        !this.autoInstrument.network || m && m.network ? !this.autoInstrument.network && m && m.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || m && m.log ? !this.autoInstrument.log && m && m.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || m && m.dom ? !this.autoInstrument.dom && m && m.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || m && m.navigation ? !this.autoInstrument.navigation && m && m.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || m && m.connectivity ? !this.autoInstrument.connectivity && m && m.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || m && m.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && m && m.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
      }, h.prototype.deinstrumentNetwork = function() {
        c(this.replacements, "network");
      }, h.prototype.instrumentNetwork = function() {
        var m = this;
        function v(w, E) {
          w in E && s.isFunction(E[w]) && d(E, w, function(C) {
            return m.rollbar.wrap(C);
          });
        }
        if ("XMLHttpRequest" in this._window) {
          var y = this._window.XMLHttpRequest.prototype;
          d(y, "open", function(w) {
            return function(E, C) {
              var k = b(C);
              return (s.isType(C, "string") || k) && (C = k ? C.toString() : C, this.__rollbar_xhr ? (this.__rollbar_xhr.method = E, this.__rollbar_xhr.url = C, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = s.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = { method: E, url: C, status_code: null, start_time_ms: s.now(), end_time_ms: null }), w.apply(this, arguments);
            };
          }, this.replacements, "network"), d(y, "setRequestHeader", function(w) {
            return function(E, C) {
              return this.__rollbar_xhr || (this.__rollbar_xhr = {}), s.isType(E, "string") && s.isType(C, "string") && (m.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[E] = C), E.toLowerCase() === "content-type" && (this.__rollbar_xhr.request_content_type = C)), w.apply(this, arguments);
            };
          }, this.replacements, "network"), d(y, "send", function(w) {
            return function(E) {
              var C = this;
              function k() {
                if (C.__rollbar_xhr && (C.__rollbar_xhr.status_code === null && (C.__rollbar_xhr.status_code = 0, m.autoInstrument.networkRequestBody && (C.__rollbar_xhr.request = E), C.__rollbar_event = m.captureNetwork(C.__rollbar_xhr, "xhr", void 0)), C.readyState < 2 && (C.__rollbar_xhr.start_time_ms = s.now()), C.readyState > 3)) {
                  C.__rollbar_xhr.end_time_ms = s.now();
                  var S = null;
                  if (C.__rollbar_xhr.response_content_type = C.getResponseHeader("Content-Type"), m.autoInstrument.networkResponseHeaders) {
                    var O = m.autoInstrument.networkResponseHeaders;
                    S = {};
                    try {
                      var T, x;
                      if (O === !0) {
                        var I = C.getAllResponseHeaders();
                        if (I) {
                          var R, N, D = I.trim().split(/[\r\n]+/);
                          for (x = 0; x < D.length; x++) T = (R = D[x].split(": ")).shift(), N = R.join(": "), S[T] = N;
                        }
                      } else for (x = 0; x < O.length; x++) S[T = O[x]] = C.getResponseHeader(T);
                    } catch {
                    }
                  }
                  var A = null;
                  if (m.autoInstrument.networkResponseBody) try {
                    A = C.responseText;
                  } catch {
                  }
                  var L = null;
                  (A || S) && (L = {}, A && (m.isJsonContentType(C.__rollbar_xhr.response_content_type) ? L.body = m.scrubJson(A) : L.body = A), S && (L.headers = S)), L && (C.__rollbar_xhr.response = L);
                  try {
                    var q = C.status;
                    q = q === 1223 ? 204 : q, C.__rollbar_xhr.status_code = q, C.__rollbar_event.level = m.telemeter.levelFromStatus(q), m.errorOnHttpStatus(C.__rollbar_xhr);
                  } catch {
                  }
                }
              }
              return v("onload", C), v("onerror", C), v("onprogress", C), "onreadystatechange" in C && s.isFunction(C.onreadystatechange) ? d(C, "onreadystatechange", function(S) {
                return m.rollbar.wrap(S, void 0, k);
              }) : C.onreadystatechange = k, C.__rollbar_xhr && m.trackHttpErrors() && (C.__rollbar_xhr.stack = new Error().stack), w.apply(this, arguments);
            };
          }, this.replacements, "network");
        }
        "fetch" in this._window && d(this._window, "fetch", function(w) {
          return function(E, C) {
            for (var k = new Array(arguments.length), S = 0, O = k.length; S < O; S++) k[S] = arguments[S];
            var T, x = k[0], I = "GET", R = b(x);
            s.isType(x, "string") || R ? T = R ? x.toString() : x : x && (T = x.url, x.method && (I = x.method)), k[1] && k[1].method && (I = k[1].method);
            var N = { method: I, url: T, status_code: null, start_time_ms: s.now(), end_time_ms: null };
            if (k[1] && k[1].headers) {
              var D = i(k[1].headers);
              N.request_content_type = D.get("Content-Type"), m.autoInstrument.networkRequestHeaders && (N.request_headers = m.fetchHeaders(D, m.autoInstrument.networkRequestHeaders));
            }
            return m.autoInstrument.networkRequestBody && (k[1] && k[1].body ? N.request = k[1].body : k[0] && !s.isType(k[0], "string") && k[0].body && (N.request = k[0].body)), m.captureNetwork(N, "fetch", void 0), m.trackHttpErrors() && (N.stack = new Error().stack), w.apply(this, k).then(function(A) {
              N.end_time_ms = s.now(), N.status_code = A.status, N.response_content_type = A.headers.get("Content-Type");
              var L = null;
              m.autoInstrument.networkResponseHeaders && (L = m.fetchHeaders(A.headers, m.autoInstrument.networkResponseHeaders));
              var q = null;
              return m.autoInstrument.networkResponseBody && typeof A.text == "function" && (q = A.clone().text()), (L || q) && (N.response = {}, q && (typeof q.then == "function" ? q.then(function(te) {
                te && m.isJsonContentType(N.response_content_type) ? N.response.body = m.scrubJson(te) : N.response.body = te;
              }) : N.response.body = q), L && (N.response.headers = L)), m.errorOnHttpStatus(N), A;
            });
          };
        }, this.replacements, "network");
      }, h.prototype.captureNetwork = function(m, v, y) {
        return m.request && this.isJsonContentType(m.request_content_type) && (m.request = this.scrubJson(m.request)), this.telemeter.captureNetwork(m, v, y);
      }, h.prototype.isJsonContentType = function(m) {
        return !!(m && s.isType(m, "string") && m.toLowerCase().includes("json"));
      }, h.prototype.scrubJson = function(m) {
        return JSON.stringify(u(JSON.parse(m), this.options.scrubFields));
      }, h.prototype.fetchHeaders = function(m, v) {
        var y = {};
        try {
          var w;
          if (v === !0) {
            if (typeof m.entries == "function") for (var E = m.entries(), C = E.next(); !C.done; ) y[C.value[0]] = C.value[1], C = E.next();
          } else for (w = 0; w < v.length; w++) {
            var k = v[w];
            y[k] = m.get(k);
          }
        } catch {
        }
        return y;
      }, h.prototype.trackHttpErrors = function() {
        return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
      }, h.prototype.errorOnHttpStatus = function(m) {
        var v = m.status_code;
        if (v >= 500 && this.autoInstrument.networkErrorOnHttp5xx || v >= 400 && this.autoInstrument.networkErrorOnHttp4xx || v === 0 && this.autoInstrument.networkErrorOnHttp0) {
          var y = new Error("HTTP request failed with Status " + v);
          y.stack = m.stack, this.rollbar.error(y, { skipFrames: 1 });
        }
      }, h.prototype.deinstrumentConsole = function() {
        if ("console" in this._window && this._window.console.log) for (var m; this.replacements.log.length; ) m = this.replacements.log.shift(), this._window.console[m[0]] = m[1];
      }, h.prototype.instrumentConsole = function() {
        if ("console" in this._window && this._window.console.log) {
          var m = this, v = this._window.console, y = ["debug", "info", "warn", "error", "log"];
          try {
            for (var w = 0, E = y.length; w < E; w++) C(y[w]);
          } catch (k) {
            this.diagnostic.instrumentConsole = { error: k.message };
          }
        }
        function C(k) {
          var S = v[k], O = v, T = k === "warn" ? "warning" : k;
          v[k] = function() {
            var x = Array.prototype.slice.call(arguments), I = s.formatArgsAsString(x);
            m.telemeter.captureLog(I, T), S && Function.prototype.apply.call(S, O, x);
          }, m.replacements.log.push([k, S]);
        }
      }, h.prototype.deinstrumentDom = function() {
        ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
      }, h.prototype.instrumentDom = function() {
        if ("addEventListener" in this._window || "attachEvent" in this._window) {
          var m = this.handleClick.bind(this), v = this.handleBlur.bind(this);
          this.addListener("dom", this._window, "click", "onclick", m, !0), this.addListener("dom", this._window, "blur", "onfocusout", v, !0);
        }
      }, h.prototype.handleClick = function(m) {
        try {
          var v = l.getElementFromEvent(m, this._document), y = v && v.tagName, w = l.isDescribedElement(v, "a") || l.isDescribedElement(v, "button");
          y && (w || l.isDescribedElement(v, "input", ["button", "submit"])) ? this.captureDomEvent("click", v) : l.isDescribedElement(v, "input", ["checkbox", "radio"]) && this.captureDomEvent("input", v, v.value, v.checked);
        } catch {
        }
      }, h.prototype.handleBlur = function(m) {
        try {
          var v = l.getElementFromEvent(m, this._document);
          v && v.tagName && (l.isDescribedElement(v, "textarea") ? this.captureDomEvent("input", v, v.value) : l.isDescribedElement(v, "select") && v.options && v.options.length ? this.handleSelectInputChanged(v) : l.isDescribedElement(v, "input") && !l.isDescribedElement(v, "input", ["button", "submit", "hidden", "checkbox", "radio"]) && this.captureDomEvent("input", v, v.value));
        } catch {
        }
      }, h.prototype.handleSelectInputChanged = function(m) {
        if (m.multiple) for (var v = 0; v < m.options.length; v++) m.options[v].selected && this.captureDomEvent("input", m, m.options[v].value);
        else m.selectedIndex >= 0 && m.options[m.selectedIndex] && this.captureDomEvent("input", m, m.options[m.selectedIndex].value);
      }, h.prototype.captureDomEvent = function(m, v, y, w) {
        if (y !== void 0) if (this.scrubTelemetryInputs || l.getElementType(v) === "password") y = "[scrubbed]";
        else {
          var E = l.describeElement(v);
          this.telemetryScrubber ? this.telemetryScrubber(E) && (y = "[scrubbed]") : this.defaultValueScrubber(E) && (y = "[scrubbed]");
        }
        var C = l.elementArrayToString(l.treeToArray(v));
        this.telemeter.captureDom(m, C, y, w);
      }, h.prototype.deinstrumentNavigation = function() {
        var m = this._window.chrome;
        !(m && m.app && m.app.runtime) && this._window.history && this._window.history.pushState && c(this.replacements, "navigation");
      }, h.prototype.instrumentNavigation = function() {
        var m = this._window.chrome;
        if (!(m && m.app && m.app.runtime) && this._window.history && this._window.history.pushState) {
          var v = this;
          d(this._window, "onpopstate", function(y) {
            return function() {
              var w = v._location.href;
              v.handleUrlChange(v._lastHref, w), y && y.apply(this, arguments);
            };
          }, this.replacements, "navigation"), d(this._window.history, "pushState", function(y) {
            return function() {
              var w = arguments.length > 2 ? arguments[2] : void 0;
              return w && v.handleUrlChange(v._lastHref, w + ""), y.apply(this, arguments);
            };
          }, this.replacements, "navigation");
        }
      }, h.prototype.handleUrlChange = function(m, v) {
        var y = a.parse(this._location.href), w = a.parse(v), E = a.parse(m);
        this._lastHref = v, y.protocol === w.protocol && y.host === w.host && (v = w.path + (w.hash || "")), y.protocol === E.protocol && y.host === E.host && (m = E.path + (E.hash || "")), this.telemeter.captureNavigation(m, v);
      }, h.prototype.deinstrumentConnectivity = function() {
        ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : c(this.replacements, "connectivity"));
      }, h.prototype.instrumentConnectivity = function() {
        if ("addEventListener" in this._window || "body" in this._document) if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, function() {
          this.telemeter.captureConnectivityChange("online");
        }.bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, function() {
          this.telemeter.captureConnectivityChange("offline");
        }.bind(this), !0);
        else {
          var m = this;
          d(this._document.body, "ononline", function(v) {
            return function() {
              m.telemeter.captureConnectivityChange("online"), v && v.apply(this, arguments);
            };
          }, this.replacements, "connectivity"), d(this._document.body, "onoffline", function(v) {
            return function() {
              m.telemeter.captureConnectivityChange("offline"), v && v.apply(this, arguments);
            };
          }, this.replacements, "connectivity");
        }
      }, h.prototype.handleCspEvent = function(m) {
        var v = "Security Policy Violation: blockedURI: " + m.blockedURI + ", violatedDirective: " + m.violatedDirective + ", effectiveDirective: " + m.effectiveDirective + ", ";
        m.sourceFile && (v += "location: " + m.sourceFile + ", line: " + m.lineNumber + ", col: " + m.columnNumber + ", "), v += "originalPolicy: " + m.originalPolicy, this.telemeter.captureLog(v, "error"), this.handleCspError(v);
      }, h.prototype.handleCspError = function(m) {
        this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(m);
      }, h.prototype.deinstrumentContentSecurityPolicy = function() {
        "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
      }, h.prototype.instrumentContentSecurityPolicy = function() {
        if ("addEventListener" in this._document) {
          var m = this.handleCspEvent.bind(this);
          this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, m, !1);
        }
      }, h.prototype.addListener = function(m, v, y, w, E, C) {
        v.addEventListener ? (v.addEventListener(y, E, C), this.eventRemovers[m].push(function() {
          v.removeEventListener(y, E, C);
        })) : w && (v.attachEvent(w, E), this.eventRemovers[m].push(function() {
          v.detachEvent(w, E);
        }));
      }, h.prototype.removeListeners = function(m) {
        for (; this.eventRemovers[m].length; ) this.eventRemovers[m].shift()();
      }, o.exports = h;
    }, 860: (o, p, f) => {
      var s = f(702), i = f(303), d = f(802);
      function u(c, h, b) {
        var m = c.message, v = c.custom;
        m || (m = "Item sent with null or missing arguments.");
        var y = { body: m };
        v && (y.extra = s.merge(v)), s.set(c, "data.body", { message: y }), b(null, c);
      }
      function a(c) {
        var h = c.stackInfo.stack;
        return h && h.length === 0 && c._unhandledStackInfo && c._unhandledStackInfo.stack && (h = c._unhandledStackInfo.stack), h;
      }
      function l(c, h, b) {
        var m = c && c.data.description, v = c && c.custom, y = a(c), w = i.guessErrorClass(h.message), E = { exception: { class: g(h, w[0], b), message: w[1] } };
        if (m && (E.exception.description = m), y) {
          var C, k, S, O, T, x, I, R;
          for (y.length === 0 && (E.exception.stack = h.rawStack, E.exception.raw = String(h.rawException)), E.frames = [], I = 0; I < y.length; ++I) k = { filename: (C = y[I]).url ? s.sanitizeUrl(C.url) : "(unknown)", lineno: C.line || null, method: C.func && C.func !== "?" ? C.func : "[anonymous]", colno: C.column }, b.sendFrameUrl && (k.url = C.url), k.method && k.method.endsWith && k.method.endsWith("_rollbar_wrapped") || (S = O = T = null, (x = C.context ? C.context.length : 0) && (R = Math.floor(x / 2), O = C.context.slice(0, R), S = C.context[R], T = C.context.slice(R)), S && (k.code = S), (O || T) && (k.context = {}, O && O.length && (k.context.pre = O), T && T.length && (k.context.post = T)), C.args && (k.args = C.args), E.frames.push(k));
          E.frames.reverse(), v && (E.extra = s.merge(v));
        }
        return E;
      }
      function g(c, h, b) {
        return c.name ? c.name : b.guessErrorClass ? h : "(unknown)";
      }
      o.exports = { handleDomException: function(c, h, b) {
        if (c.err && i.Stack(c.err).name === "DOMException") {
          var m = new Error();
          m.name = c.err.name, m.message = c.err.message, m.stack = c.err.stack, m.nested = c.err, c.err = m;
        }
        b(null, c);
      }, handleItemWithError: function(c, h, b) {
        if (c.data = c.data || {}, c.err) try {
          c.stackInfo = c.err._savedStackTrace || i.parse(c.err, c.skipFrames), h.addErrorContext && function(m) {
            var v = [], y = m.err;
            for (v.push(y); y.nested || y.cause; ) y = y.nested || y.cause, v.push(y);
            s.addErrorContext(m, v);
          }(c);
        } catch (m) {
          d.error("Error while parsing the error object.", m);
          try {
            c.message = c.err.message || c.err.description || c.message || String(c.err);
          } catch (v) {
            c.message = String(c.err) || String(v);
          }
          delete c.err;
        }
        b(null, c);
      }, ensureItemHasSomethingToSay: function(c, h, b) {
        c.message || c.stackInfo || c.custom || b(new Error("No message, stack info, or custom data"), null), b(null, c);
      }, addBaseInfo: function(c, h, b) {
        var m = h.payload && h.payload.environment || h.environment;
        c.data = s.merge(c.data, { environment: m, level: c.level, endpoint: h.endpoint, platform: "browser", framework: "browser-js", language: "javascript", server: {}, uuid: c.uuid, notifier: { name: "rollbar-browser-js", version: h.version }, custom: c.custom }), b(null, c);
      }, addRequestInfo: function(c) {
        return function(h, b, m) {
          var v = {};
          c && c.location && (v.url = c.location.href, v.query_string = c.location.search);
          var y = "$remote_ip";
          b.captureIp ? b.captureIp !== !0 && (y += "_anonymize") : y = null, y && (v.user_ip = y), Object.keys(v).length > 0 && s.set(h, "data.request", v), m(null, h);
        };
      }, addClientInfo: function(c) {
        return function(h, b, m) {
          if (!c) return m(null, h);
          var v = c.navigator || {}, y = c.screen || {};
          s.set(h, "data.client", { runtime_ms: h.timestamp - c._rollbarStartTime, timestamp: Math.round(h.timestamp / 1e3), javascript: { browser: v.userAgent, language: v.language, cookie_enabled: v.cookieEnabled, screen: { width: y.width, height: y.height } } }), m(null, h);
        };
      }, addPluginInfo: function(c) {
        return function(h, b, m) {
          if (!c || !c.navigator) return m(null, h);
          for (var v, y = [], w = c.navigator.plugins || [], E = 0, C = w.length; E < C; ++E) v = w[E], y.push({ name: v.name, description: v.description });
          s.set(h, "data.client.javascript.plugins", y), m(null, h);
        };
      }, addBody: function(c, h, b) {
        c.stackInfo ? c.stackInfo.traceChain ? function(m, v, y) {
          for (var w = m.stackInfo.traceChain, E = [], C = w.length, k = 0; k < C; k++) {
            var S = l(m, w[k], v);
            E.push(S);
          }
          s.set(m, "data.body", { trace_chain: E }), y(null, m);
        }(c, h, b) : function(m, v, y) {
          var w = a(m);
          if (w) {
            var E = l(m, m.stackInfo, v);
            s.set(m, "data.body", { trace: E }), y(null, m);
          } else {
            var C = m.stackInfo, k = i.guessErrorClass(C.message), S = g(C, k[0], v), O = k[1];
            m.message = S + ": " + O, u(m, 0, y);
          }
        }(c, h, b) : u(c, 0, b);
      }, addScrubber: function(c) {
        return function(h, b, m) {
          if (c) {
            var v = b.scrubFields || [], y = b.scrubPaths || [];
            h.data = c(h.data, v, y);
          }
          m(null, h);
        };
      } };
    }, 477: (o, p, f) => {
      var s = f(702), i = f(656), d = f(86);
      function u(a) {
        this.truncation = a;
      }
      u.prototype.get = function(a, l, g, c, h) {
        c && s.isFunction(c) || (c = function() {
        }), s.addParamsAndAccessTokenToPath(a, l, g);
        var b = s.formatUrl(l);
        this._makeZoneRequest(a, b, "GET", null, c, h, l.timeout, l.transport);
      }, u.prototype.post = function(a, l, g, c, h) {
        if (c && s.isFunction(c) || (c = function() {
        }), !g) return c(new Error("Cannot send empty request"));
        var b;
        if ((b = this.truncation ? this.truncation.truncate(g) : s.stringify(g)).error) return c(b.error);
        var m = b.value, v = s.formatUrl(l);
        this._makeZoneRequest(a, v, "POST", m, c, h, l.timeout, l.transport);
      }, u.prototype.postJsonPayload = function(a, l, g, c, h) {
        c && s.isFunction(c) || (c = function() {
        });
        var b = s.formatUrl(l);
        this._makeZoneRequest(a, b, "POST", g, c, h, l.timeout, l.transport);
      }, u.prototype._makeZoneRequest = function() {
        var a = typeof window < "u" && window || h !== void 0 && h, l = a && a.Zone && a.Zone.current, g = Array.prototype.slice.call(arguments);
        if (l && l._name === "angular") {
          var c = l._parent, h = this;
          c.run(function() {
            h._makeRequest.apply(void 0, g);
          });
        } else this._makeRequest.apply(void 0, g);
      }, u.prototype._makeRequest = function(a, l, g, c, h, b, m, v) {
        if (typeof RollbarProxy < "u") return function(y, w) {
          new RollbarProxy().sendJsonPayload(y, function(E) {
          }, function(E) {
            w(new Error(E));
          });
        }(c, h);
        v === "fetch" ? i(a, l, g, c, h, m) : d(a, l, g, c, h, b, m);
      }, o.exports = u;
    }, 656: (o, p, f) => {
      var s = f(802), i = f(702);
      o.exports = function(d, u, a, l, g, c) {
        var h, b;
        i.isFiniteNumber(c) && (h = new AbortController(), b = setTimeout(function() {
          h.abort();
        }, c)), fetch(u, { method: a, headers: { "Content-Type": "application/json", "X-Rollbar-Access-Token": d, signal: h && h.signal }, body: l }).then(function(m) {
          return b && clearTimeout(b), m.json();
        }).then(function(m) {
          g(null, m);
        }).catch(function(m) {
          s.error(m.message), g(m);
        });
      };
    }, 86: (o, p, f) => {
      var s = f(702), i = f(802);
      function d(u, a) {
        var l = new Error(u);
        return l.code = a || "ENOTFOUND", l;
      }
      o.exports = function(u, a, l, g, c, h, b) {
        var m;
        if (!(m = h ? h() : function() {
          var w, E, C = [function() {
            return new XMLHttpRequest();
          }, function() {
            return new ActiveXObject("Msxml2.XMLHTTP");
          }, function() {
            return new ActiveXObject("Msxml3.XMLHTTP");
          }, function() {
            return new ActiveXObject("Microsoft.XMLHTTP");
          }], k = C.length;
          for (E = 0; E < k; E++) try {
            w = C[E]();
            break;
          } catch {
          }
          return w;
        }())) return c(new Error("No way to send a request"));
        try {
          try {
            var v = function() {
              try {
                if (v && m.readyState === 4) {
                  v = void 0;
                  var w = s.jsonParse(m.responseText);
                  if ((k = m) && k.status && k.status === 200) return void c(w.error, w.value);
                  if (function(S) {
                    return S && s.isType(S.status, "number") && S.status >= 400 && S.status < 600;
                  }(m)) {
                    if (m.status === 403) {
                      var E = w.value && w.value.message;
                      i.error(E);
                    }
                    c(new Error(String(m.status)));
                  } else c(d("XHR response had no status code (likely connection failure)"));
                }
              } catch (S) {
                var C;
                C = S && S.stack ? S : new Error(S), c(C);
              }
              var k;
            };
            m.open(l, a, !0), m.setRequestHeader && (m.setRequestHeader("Content-Type", "application/json"), m.setRequestHeader("X-Rollbar-Access-Token", u)), s.isFiniteNumber(b) && (m.timeout = b), m.onreadystatechange = v, m.send(g);
          } catch {
            if (typeof XDomainRequest < "u") {
              if (!window || !window.location) return c(new Error("No window available during request, unknown environment"));
              window.location.href.substring(0, 5) === "http:" && a.substring(0, 5) === "https" && (a = "http" + a.substring(5));
              var y = new XDomainRequest();
              y.onprogress = function() {
              }, y.ontimeout = function() {
                c(d("Request timed out", "ETIMEDOUT"));
              }, y.onerror = function() {
                c(new Error("Error during request"));
              }, y.onload = function() {
                var E = s.jsonParse(y.responseText);
                c(E.error, E.value);
              }, y.open(l, a, !0), y.send(g);
            } else c(new Error("Cannot find a method to transport a request"));
          }
        } catch (w) {
          c(w);
        }
      };
    }, 509: (o) => {
      o.exports = { parse: function(p) {
        var f, s, i = { protocol: null, auth: null, host: null, path: null, hash: null, href: p, hostname: null, port: null, pathname: null, search: null, query: null };
        if ((f = p.indexOf("//")) !== -1 ? (i.protocol = p.substring(0, f), s = f + 2) : s = 0, (f = p.indexOf("@", s)) !== -1 && (i.auth = p.substring(s, f), s = f + 1), (f = p.indexOf("/", s)) === -1) {
          if ((f = p.indexOf("?", s)) === -1) return (f = p.indexOf("#", s)) === -1 ? i.host = p.substring(s) : (i.host = p.substring(s, f), i.hash = p.substring(f)), i.hostname = i.host.split(":")[0], i.port = i.host.split(":")[1], i.port && (i.port = parseInt(i.port, 10)), i;
          i.host = p.substring(s, f), i.hostname = i.host.split(":")[0], i.port = i.host.split(":")[1], i.port && (i.port = parseInt(i.port, 10)), s = f;
        } else i.host = p.substring(s, f), i.hostname = i.host.split(":")[0], i.port = i.host.split(":")[1], i.port && (i.port = parseInt(i.port, 10)), s = f;
        if ((f = p.indexOf("#", s)) === -1 ? i.path = p.substring(s) : (i.path = p.substring(s, f), i.hash = p.substring(f)), i.path) {
          var d = i.path.split("?");
          i.pathname = d[0], i.query = d[1], i.search = i.query ? "?" + i.query : null;
        }
        return i;
      } };
    }, 965: (o) => {
      function p(f, s, i) {
        if (s.hasOwnProperty && s.hasOwnProperty("addEventListener")) {
          for (var d = s.addEventListener; d._rollbarOldAdd && d.belongsToShim; ) d = d._rollbarOldAdd;
          var u = function(g, c, h) {
            d.call(this, g, f.wrap(c), h);
          };
          u._rollbarOldAdd = d, u.belongsToShim = i, s.addEventListener = u;
          for (var a = s.removeEventListener; a._rollbarOldRemove && a.belongsToShim; ) a = a._rollbarOldRemove;
          var l = function(g, c, h) {
            a.call(this, g, c && c._rollbar_wrapped || c, h);
          };
          l._rollbarOldRemove = a, l.belongsToShim = i, s.removeEventListener = l;
        }
      }
      o.exports = function(f, s, i) {
        if (f) {
          var d, u, a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
          for (d = 0; d < a.length; ++d) f[u = a[d]] && f[u].prototype && p(s, f[u].prototype, i);
        }
      };
    }, 948: (o) => {
      o.exports = { version: "2.26.4", endpoint: "api.rollbar.com/api/1/item/", logLevel: "debug", reportLevel: "debug", uncaughtErrorLevel: "error", maxItems: 0, itemsPerMin: 60 };
    }, 303: (o, p, f) => {
      var s = f(180), i = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
      function d() {
        return null;
      }
      function u(l) {
        var g = {};
        return g._stackFrame = l, g.url = l.fileName, g.line = l.lineNumber, g.func = l.functionName, g.column = l.columnNumber, g.args = l.args, g.context = null, g;
      }
      function a(l, g) {
        return { stack: function() {
          var m = [];
          g = g || 0;
          try {
            m = s.parse(l);
          } catch {
            m = [];
          }
          for (var v = [], y = g; y < m.length; y++) v.push(new u(m[y]));
          return v;
        }(), message: l.message, name: (c = l, h = c.name && c.name.length && c.name, b = c.constructor.name && c.constructor.name.length && c.constructor.name, h && b ? h === "Error" ? b : h : h || b), rawStack: l.stack, rawException: l };
        var c, h, b;
      }
      o.exports = { guessFunctionName: function() {
        return "?";
      }, guessErrorClass: function(l) {
        if (!l || !l.match) return ["Unknown error. There was no error message to display.", ""];
        var g = l.match(i), c = "(unknown)";
        return g && (c = g[g.length - 1], l = (l = l.replace((g[g.length - 2] || "") + c + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [c, l];
      }, gatherContext: d, parse: function(l, g) {
        var c = l;
        if (c.nested || c.cause) {
          for (var h = []; c; ) h.push(new a(c, g)), c = c.nested || c.cause, g = 0;
          return h[0].traceChain = h, h[0];
        }
        return new a(c, g);
      }, Stack: a, Frame: u };
    }, 420: (o) => {
      var p = Object.prototype.hasOwnProperty, f = Object.prototype.toString, s = function(i) {
        if (!i || f.call(i) !== "[object Object]") return !1;
        var d, u = p.call(i, "constructor"), a = i.constructor && i.constructor.prototype && p.call(i.constructor.prototype, "isPrototypeOf");
        if (i.constructor && !u && !a) return !1;
        for (d in i) ;
        return d === void 0 || p.call(i, d);
      };
      o.exports = function i() {
        var d, u, a, l, g, c = {}, h = null, b = arguments.length;
        for (d = 0; d < b; d++) if ((h = arguments[d]) != null) for (g in h) u = c[g], c !== (a = h[g]) && (a && s(a) ? (l = u && s(u) ? u : {}, c[g] = i(l, a)) : a !== void 0 && (c[g] = a));
        return c;
      };
    }, 314: (o, p, f) => {
      var s = f(702);
      function i(d, u) {
        this.queue = d, this.options = u, this.transforms = [], this.diagnostic = {};
      }
      i.prototype.configure = function(d) {
        this.queue && this.queue.configure(d);
        var u = this.options;
        return this.options = s.merge(u, d), this;
      }, i.prototype.addTransform = function(d) {
        return s.isFunction(d) && this.transforms.push(d), this;
      }, i.prototype.log = function(d, u) {
        if (u && s.isFunction(u) || (u = function() {
        }), !this.options.enabled) return u(new Error("Rollbar is not enabled"));
        this.queue.addPendingItem(d);
        var a = d.err;
        this._applyTransforms(d, function(l, g) {
          if (l) return this.queue.removePendingItem(d), u(l, null);
          this.queue.addItem(g, u, a, d);
        }.bind(this));
      }, i.prototype._applyTransforms = function(d, u) {
        var a = -1, l = this.transforms.length, g = this.transforms, c = this.options, h = function(b, m) {
          b ? u(b, null) : ++a !== l ? g[a](m, c, h) : u(null, m);
        };
        h(null, d);
      }, o.exports = i;
    }, 61: (o, p, f) => {
      var s = f(702);
      function i(u, a, l) {
        if (!u) return !l;
        var g, c, h = u.frames;
        if (!h || h.length === 0) return !l;
        for (var b = a.length, m = h.length, v = 0; v < m; v++) {
          if (g = h[v].filename, !s.isType(g, "string")) return !l;
          for (var y = 0; y < b; y++) if (c = a[y], new RegExp(c).test(g)) return !0;
        }
        return !1;
      }
      function d(u, a, l, g) {
        var c, h, b = !1;
        l === "blocklist" && (b = !0);
        try {
          if (c = b ? a.hostBlockList : a.hostSafeList, h = s.get(u, "body.trace_chain") || [s.get(u, "body.trace")], !c || c.length === 0 || h.length === 0 || !h[0]) return !b;
          for (var m = h.length, v = 0; v < m; v++) if (i(h[v], c, b)) return !0;
        } catch (w) {
          b ? a.hostBlockList = null : a.hostSafeList = null;
          var y = b ? "hostBlockList" : "hostSafeList";
          return g.error("Error while reading your configuration's " + y + " option. Removing custom " + y + ".", w), !b;
        }
        return !1;
      }
      o.exports = { checkLevel: function(u, a) {
        var l = u.level, g = s.LEVELS[l] || 0, c = a.reportLevel;
        return !(g < (s.LEVELS[c] || 0));
      }, userCheckIgnore: function(u) {
        return function(a, l) {
          var g = !!a._isUncaught;
          delete a._isUncaught;
          var c = a._originalArgs;
          delete a._originalArgs;
          try {
            s.isFunction(l.onSendCallback) && l.onSendCallback(g, c, a);
          } catch (h) {
            l.onSendCallback = null, u.error("Error while calling onSendCallback, removing", h);
          }
          try {
            if (s.isFunction(l.checkIgnore) && l.checkIgnore(g, c, a)) return !1;
          } catch (h) {
            l.checkIgnore = null, u.error("Error while calling custom checkIgnore(), removing", h);
          }
          return !0;
        };
      }, urlIsNotBlockListed: function(u) {
        return function(a, l) {
          return !d(a, l, "blocklist", u);
        };
      }, urlIsSafeListed: function(u) {
        return function(a, l) {
          return d(a, l, "safelist", u);
        };
      }, messageIsIgnored: function(u) {
        return function(a, l) {
          var g, c, h, b, m, v;
          try {
            if (!(h = l.ignoredMessages) || h.length === 0 || (v = function(y) {
              var w = y.body, E = [];
              if (w.trace_chain) for (var C = w.trace_chain, k = 0; k < C.length; k++) {
                var S = C[k];
                E.push(s.get(S, "exception.message"));
              }
              return w.trace && E.push(s.get(w, "trace.exception.message")), w.message && E.push(s.get(w, "message.body")), E;
            }(a), v.length === 0)) return !0;
            for (b = h.length, g = 0; g < b; g++) for (m = new RegExp(h[g], "gi"), c = 0; c < v.length; c++) if (m.test(v[c])) return !1;
          } catch {
            l.ignoredMessages = null, u.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
          }
          return !0;
        };
      } };
    }, 358: (o, p, f) => {
      var s = f(702);
      function i(u, a, l, g) {
        this.rateLimiter = u, this.api = a, this.logger = l, this.options = g, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
      }
      i.prototype.configure = function(u) {
        this.api && this.api.configure(u);
        var a = this.options;
        return this.options = s.merge(a, u), this;
      }, i.prototype.addPredicate = function(u) {
        return s.isFunction(u) && this.predicates.push(u), this;
      }, i.prototype.addPendingItem = function(u) {
        this.pendingItems.push(u);
      }, i.prototype.removePendingItem = function(u) {
        var a = this.pendingItems.indexOf(u);
        a !== -1 && this.pendingItems.splice(a, 1);
      }, i.prototype.addItem = function(u, a, l, g) {
        a && s.isFunction(a) || (a = function() {
        });
        var c = this._applyPredicates(u);
        if (c.stop) return this.removePendingItem(g), void a(c.err);
        if (this._maybeLog(u, l), this.removePendingItem(g), this.options.transmit) {
          this.pendingRequests.push(u);
          try {
            this._makeApiRequest(u, function(h, b) {
              this._dequeuePendingRequest(u), a(h, b);
            }.bind(this));
          } catch (h) {
            this._dequeuePendingRequest(u), a(h);
          }
        } else a(new Error("Transmit disabled"));
      }, i.prototype.wait = function(u) {
        s.isFunction(u) && (this.waitCallback = u, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval(function() {
          this._maybeCallWait();
        }.bind(this), 500)));
      }, i.prototype._applyPredicates = function(u) {
        for (var a = null, l = 0, g = this.predicates.length; l < g; l++) if (!(a = this.predicates[l](u, this.options)) || a.err !== void 0) return { stop: !0, err: a.err };
        return { stop: !1, err: null };
      }, i.prototype._makeApiRequest = function(u, a) {
        var l = this.rateLimiter.shouldSend(u);
        l.shouldSend ? this.api.postItem(u, function(g, c) {
          g ? this._maybeRetry(g, u, a) : a(g, c);
        }.bind(this)) : l.error ? a(l.error) : this.api.postItem(l.payload, a);
      };
      var d = ["ECONNRESET", "ENOTFOUND", "ESOCKETTIMEDOUT", "ETIMEDOUT", "ECONNREFUSED", "EHOSTUNREACH", "EPIPE", "EAI_AGAIN"];
      i.prototype._maybeRetry = function(u, a, l) {
        var g = !1;
        if (this.options.retryInterval) {
          for (var c = 0, h = d.length; c < h; c++) if (u.code === d[c]) {
            g = !0;
            break;
          }
          g && s.isFiniteNumber(this.options.maxRetries) && (a.retries = a.retries ? a.retries + 1 : 1, a.retries > this.options.maxRetries && (g = !1));
        }
        g ? this._retryApiRequest(a, l) : l(u);
      }, i.prototype._retryApiRequest = function(u, a) {
        this.retryQueue.push({ item: u, callback: a }), this.retryHandle || (this.retryHandle = setInterval(function() {
          for (; this.retryQueue.length; ) {
            var l = this.retryQueue.shift();
            this._makeApiRequest(l.item, l.callback);
          }
        }.bind(this), this.options.retryInterval));
      }, i.prototype._dequeuePendingRequest = function(u) {
        var a = this.pendingRequests.indexOf(u);
        a !== -1 && (this.pendingRequests.splice(a, 1), this._maybeCallWait());
      }, i.prototype._maybeLog = function(u, a) {
        if (this.logger && this.options.verbose) {
          var l = a;
          if (l = (l = l || s.get(u, "body.trace.exception.message")) || s.get(u, "body.trace_chain.0.exception.message")) return void this.logger.error(l);
          (l = s.get(u, "body.message.body")) && this.logger.log(l);
        }
      }, i.prototype._maybeCallWait = function() {
        return !(!s.isFunction(this.waitCallback) || this.pendingItems.length !== 0 || this.pendingRequests.length !== 0 || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
      }, o.exports = i;
    }, 790: (o, p, f) => {
      var s = f(702);
      function i(a) {
        this.startTime = s.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(a);
      }
      function d(a, l, g) {
        return !a.ignoreRateLimit && l >= 1 && g > l;
      }
      function u(a, l, g, c, h, b, m) {
        var v = null;
        return g && (g = new Error(g)), g || c || (v = function(y, w, E, C, k) {
          var S = w.environment || w.payload && w.payload.environment, O = { body: { message: { body: k ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.", extra: { maxItems: E, itemsPerMinute: C } } }, language: "javascript", environment: S, notifier: { version: w.notifier && w.notifier.version || w.version } };
          return y === "browser" ? (O.platform = "browser", O.framework = "browser-js", O.notifier.name = "rollbar-browser-js") : y === "server" ? (O.framework = w.framework || "node-js", O.notifier.name = w.notifier.name) : y === "react-native" && (O.framework = w.framework || "react-native", O.notifier.name = w.notifier.name), O;
        }(a, l, h, b, m)), { error: g, shouldSend: c, payload: v };
      }
      i.globalSettings = { startTime: s.now(), maxItems: void 0, itemsPerMinute: void 0 }, i.prototype.configureGlobal = function(a) {
        a.startTime !== void 0 && (i.globalSettings.startTime = a.startTime), a.maxItems !== void 0 && (i.globalSettings.maxItems = a.maxItems), a.itemsPerMinute !== void 0 && (i.globalSettings.itemsPerMinute = a.itemsPerMinute);
      }, i.prototype.shouldSend = function(a, l) {
        var g = (l = l || s.now()) - this.startTime;
        (g < 0 || g >= 6e4) && (this.startTime = l, this.perMinCounter = 0);
        var c = i.globalSettings.maxItems, h = i.globalSettings.itemsPerMinute;
        if (d(a, c, this.counter)) return u(this.platform, this.platformOptions, c + " max items reached", !1);
        if (d(a, h, this.perMinCounter)) return u(this.platform, this.platformOptions, h + " items per minute reached", !1);
        this.counter++, this.perMinCounter++;
        var b = !d(a, c, this.counter), m = b;
        return b = b && !d(a, h, this.perMinCounter), u(this.platform, this.platformOptions, null, b, c, h, m);
      }, i.prototype.setPlatformOptions = function(a, l) {
        this.platform = a, this.platformOptions = l;
      }, o.exports = i;
    }, 562: (o, p, f) => {
      var s = f(790), i = f(358), d = f(314), u = f(702);
      function a(c, h, b, m, v) {
        this.options = u.merge(c), this.logger = b, a.rateLimiter.configureGlobal(this.options), a.rateLimiter.setPlatformOptions(v, this.options), this.api = h, this.queue = new i(a.rateLimiter, h, b, this.options);
        var y = this.options.tracer || null;
        g(y) ? (this.tracer = y, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new d(this.queue, this.options), this.telemeter = m, l(c), this.lastError = null, this.lastErrorHash = "none";
      }
      function l(c) {
        c.stackTraceLimit && (Error.stackTraceLimit = c.stackTraceLimit);
      }
      function g(c) {
        if (!c || !c.scope || typeof c.scope != "function") return !1;
        var h = c.scope();
        return !(!h || !h.active || typeof h.active != "function");
      }
      a.rateLimiter = new s({ maxItems: 0, itemsPerMinute: 60 }), a.prototype.global = function(c) {
        return a.rateLimiter.configureGlobal(c), this;
      }, a.prototype.configure = function(c, h) {
        var b = this.options, m = {};
        h && (m = { payload: h }), this.options = u.merge(b, c, m);
        var v = this.options.tracer || null;
        return g(v) ? (this.tracer = v, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), l(c), this.global(this.options), g(c.tracer) && (this.tracer = c.tracer), this;
      }, a.prototype.log = function(c) {
        var h = this._defaultLogLevel();
        return this._log(h, c);
      }, a.prototype.debug = function(c) {
        this._log("debug", c);
      }, a.prototype.info = function(c) {
        this._log("info", c);
      }, a.prototype.warn = function(c) {
        this._log("warning", c);
      }, a.prototype.warning = function(c) {
        this._log("warning", c);
      }, a.prototype.error = function(c) {
        this._log("error", c);
      }, a.prototype.critical = function(c) {
        this._log("critical", c);
      }, a.prototype.wait = function(c) {
        this.queue.wait(c);
      }, a.prototype.captureEvent = function(c, h, b) {
        return this.telemeter && this.telemeter.captureEvent(c, h, b);
      }, a.prototype.captureDomContentLoaded = function(c) {
        return this.telemeter && this.telemeter.captureDomContentLoaded(c);
      }, a.prototype.captureLoad = function(c) {
        return this.telemeter && this.telemeter.captureLoad(c);
      }, a.prototype.buildJsonPayload = function(c) {
        return this.api.buildJsonPayload(c);
      }, a.prototype.sendJsonPayload = function(c) {
        this.api.postJsonPayload(c);
      }, a.prototype._log = function(c, h) {
        var b;
        if (h.callback && (b = h.callback, delete h.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(h)) {
          if (b) {
            var m = new Error("ignored identical item");
            m.item = h, b(m);
          }
        } else try {
          this._addTracingInfo(h), h.level = h.level || c, this.telemeter && this.telemeter._captureRollbarItem(h), h.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(h, b);
        } catch (v) {
          b && b(v), this.logger.error(v);
        }
      }, a.prototype._defaultLogLevel = function() {
        return this.options.logLevel || "debug";
      }, a.prototype._sameAsLastError = function(c) {
        if (!c._isUncaught) return !1;
        var h = function(b) {
          var m = b.message || "", v = (b.err || {}).stack || String(b.err);
          return m + "::" + v;
        }(c);
        return this.lastErrorHash === h || (this.lastError = c.err, this.lastErrorHash = h, !1);
      }, a.prototype._addTracingInfo = function(c) {
        if (this.tracer) {
          var h = this.tracer.scope().active();
          if (function(v) {
            if (!v || !v.context || typeof v.context != "function") return !1;
            var y = v.context();
            return !!(y && y.toSpanId && y.toTraceId && typeof y.toSpanId == "function" && typeof y.toTraceId == "function");
          }(h)) {
            h.setTag("rollbar.error_uuid", c.uuid), h.setTag("rollbar.has_error", !0), h.setTag("error", !0), h.setTag("rollbar.item_url", `https://rollbar.com/item/uuid/?uuid=${c.uuid}`), h.setTag("rollbar.occurrence_url", `https://rollbar.com/occurrence/uuid/?uuid=${c.uuid}`);
            var b = h.context().toSpanId(), m = h.context().toTraceId();
            c.custom ? (c.custom.opentracing_span_id = b, c.custom.opentracing_trace_id = m) : c.custom = { opentracing_span_id: b, opentracing_trace_id: m };
          }
        }
      }, o.exports = a;
    }, 369: (o, p, f) => {
      var s = f(702), i = f(267);
      function d(u, a) {
        var l = a.split("."), g = l.length - 1;
        try {
          for (var c = 0; c <= g; ++c) c < g ? u = u[l[c]] : u[l[c]] = s.redact();
        } catch {
        }
      }
      o.exports = function(u, a, l) {
        if (a = a || [], l) for (var g = 0; g < l.length; ++g) d(u, l[g]);
        var c = function(m) {
          for (var v, y = [], w = 0; w < m.length; ++w) v = "^\\[?(%5[bB])?" + m[w] + "\\[?(%5[bB])?\\]?(%5[dD])?$", y.push(new RegExp(v, "i"));
          return y;
        }(a), h = function(m) {
          for (var v, y = [], w = 0; w < m.length; ++w) v = "\\[?(%5[bB])?" + m[w] + "\\[?(%5[bB])?\\]?(%5[dD])?", y.push(new RegExp("(" + v + "=)([^&\\n]+)", "igm"));
          return y;
        }(a);
        function b(m, v) {
          return v + s.redact();
        }
        return i(u, function m(v, y, w) {
          var E = function(C, k) {
            var S;
            for (S = 0; S < c.length; ++S) if (c[S].test(C)) {
              k = s.redact();
              break;
            }
            return k;
          }(v, y);
          return E === y ? s.isType(y, "object") || s.isType(y, "array") ? i(y, m, w) : function(C) {
            var k;
            if (s.isType(C, "string")) for (k = 0; k < h.length; ++k) C = C.replace(h[k], b);
            return C;
          }(E) : E;
        });
      };
    }, 773: (o, p, f) => {
      var s = f(702), i = 100;
      function d(a) {
        this.queue = [], this.options = s.merge(a);
        var l = this.options.maxTelemetryEvents || i;
        this.maxQueueSize = Math.max(0, Math.min(l, i));
      }
      function u(a, l) {
        return l || { error: "error", manual: "info" }[a] || "info";
      }
      d.prototype.configure = function(a) {
        var l = this.options;
        this.options = s.merge(l, a);
        var g = this.options.maxTelemetryEvents || i, c = Math.max(0, Math.min(g, i)), h = 0;
        this.queue.length > c && (h = this.queue.length - c), this.maxQueueSize = c, this.queue.splice(0, h);
      }, d.prototype.copyEvents = function() {
        var a = Array.prototype.slice.call(this.queue, 0);
        if (s.isFunction(this.options.filterTelemetry)) try {
          for (var l = a.length; l--; ) this.options.filterTelemetry(a[l]) && a.splice(l, 1);
        } catch {
          this.options.filterTelemetry = null;
        }
        return a;
      }, d.prototype.capture = function(a, l, g, c, h) {
        var b = { level: u(a, g), type: a, timestamp_ms: h || s.now(), body: l, source: "client" };
        c && (b.uuid = c);
        try {
          if (s.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(b)) return !1;
        } catch {
          this.options.filterTelemetry = null;
        }
        return this.push(b), b;
      }, d.prototype.captureEvent = function(a, l, g, c) {
        return this.capture(a, l, g, c);
      }, d.prototype.captureError = function(a, l, g, c) {
        var h = { message: a.message || String(a) };
        return a.stack && (h.stack = a.stack), this.capture("error", h, l, g, c);
      }, d.prototype.captureLog = function(a, l, g, c) {
        return this.capture("log", { message: a }, l, g, c);
      }, d.prototype.captureNetwork = function(a, l, g, c) {
        l = l || "xhr", a.subtype = a.subtype || l, c && (a.request = c);
        var h = this.levelFromStatus(a.status_code);
        return this.capture("network", a, h, g);
      }, d.prototype.levelFromStatus = function(a) {
        return a >= 200 && a < 400 ? "info" : a === 0 || a >= 400 ? "error" : "info";
      }, d.prototype.captureDom = function(a, l, g, c, h) {
        var b = { subtype: a, element: l };
        return g !== void 0 && (b.value = g), c !== void 0 && (b.checked = c), this.capture("dom", b, "info", h);
      }, d.prototype.captureNavigation = function(a, l, g) {
        return this.capture("navigation", { from: a, to: l }, "info", g);
      }, d.prototype.captureDomContentLoaded = function(a) {
        return this.capture("navigation", { subtype: "DOMContentLoaded" }, "info", void 0, a && a.getTime());
      }, d.prototype.captureLoad = function(a) {
        return this.capture("navigation", { subtype: "load" }, "info", void 0, a && a.getTime());
      }, d.prototype.captureConnectivityChange = function(a, l) {
        return this.captureNetwork({ change: a }, "connectivity", l);
      }, d.prototype._captureRollbarItem = function(a) {
        if (this.options.includeItemsInTelemetry) return a.err ? this.captureError(a.err, a.level, a.uuid, a.timestamp) : a.message ? this.captureLog(a.message, a.level, a.uuid, a.timestamp) : a.custom ? this.capture("log", a.custom, a.level, a.uuid, a.timestamp) : void 0;
      }, d.prototype.push = function(a) {
        this.queue.push(a), this.queue.length > this.maxQueueSize && this.queue.shift();
      }, o.exports = d;
    }, 417: (o, p, f) => {
      var s = f(702);
      function i(d, u) {
        s.isFunction(d[u]) && (d[u] = d[u].toString());
      }
      o.exports = { itemToPayload: function(d, u, a) {
        var l = d.data;
        d._isUncaught && (l._isUncaught = !0), d._originalArgs && (l._originalArgs = d._originalArgs), a(null, l);
      }, addPayloadOptions: function(d, u, a) {
        var l = u.payload || {};
        l.body && delete l.body, d.data = s.merge(d.data, l), a(null, d);
      }, addTelemetryData: function(d, u, a) {
        d.telemetryEvents && s.set(d, "data.body.telemetry", d.telemetryEvents), a(null, d);
      }, addMessageWithError: function(d, u, a) {
        if (d.message) {
          var l = "data.body.trace_chain.0", g = s.get(d, l);
          if (g || (l = "data.body.trace", g = s.get(d, l)), g) {
            if (!g.exception || !g.exception.description) return s.set(d, l + ".exception.description", d.message), void a(null, d);
            var c = s.get(d, l + ".extra") || {}, h = s.merge(c, { message: d.message });
            s.set(d, l + ".extra", h);
          }
          a(null, d);
        } else a(null, d);
      }, userTransform: function(d) {
        return function(u, a, l) {
          var g = s.merge(u), c = null;
          try {
            s.isFunction(a.transform) && (c = a.transform(g.data, u));
          } catch (h) {
            return a.transform = null, d.error("Error while calling custom transform() function. Removing custom transform().", h), void l(null, u);
          }
          s.isPromise(c) ? c.then(function(h) {
            h && (g.data = h), l(null, g);
          }, function(h) {
            l(h, u);
          }) : l(null, g);
        };
      }, addConfigToPayload: function(d, u, a) {
        if (!u.sendConfig) return a(null, d);
        var l = s.get(d, "data.custom") || {};
        l._rollbarConfig = u, d.data.custom = l, a(null, d);
      }, addConfiguredOptions: function(d, u, a) {
        var l = u._configuredOptions;
        i(l, "transform"), i(l, "checkIgnore"), i(l, "onSendCallback"), delete l.accessToken, d.data.notifier.configured_options = l, a(null, d);
      }, addDiagnosticKeys: function(d, u, a) {
        var l = s.merge(d.notifier.client.notifier.diagnostic, d.diagnostic);
        if (s.get(d, "err._isAnonymous") && (l.is_anonymous = !0), d._isUncaught && (l.is_uncaught = d._isUncaught), d.err) try {
          l.raw_error = { message: d.err.message, name: d.err.name, constructor_name: d.err.constructor && d.err.constructor.name, filename: d.err.fileName, line: d.err.lineNumber, column: d.err.columnNumber, stack: d.err.stack };
        } catch (g) {
          l.raw_error = { failed: String(g) };
        }
        d.data.notifier.diagnostic = s.merge(d.data.notifier.diagnostic, l), a(null, d);
      } };
    }, 473: (o, p, f) => {
      var s = f(702), i = f(267);
      function d(m, v) {
        return [m, s.stringify(m, v)];
      }
      function u(m, v) {
        var y = m.length;
        return y > 2 * v ? m.slice(0, v).concat(m.slice(y - v)) : m;
      }
      function a(m, v, y) {
        y = y === void 0 ? 30 : y;
        var w, E = m.data.body;
        if (E.trace_chain) for (var C = E.trace_chain, k = 0; k < C.length; k++) w = u(w = C[k].frames, y), C[k].frames = w;
        else E.trace && (w = u(w = E.trace.frames, y), E.trace.frames = w);
        return [m, s.stringify(m, v)];
      }
      function l(m, v) {
        return v && v.length > m ? v.slice(0, m - 3).concat("...") : v;
      }
      function g(m, v, y) {
        return v = i(v, function w(E, C, k) {
          switch (s.typeName(C)) {
            case "string":
              return l(m, C);
            case "object":
            case "array":
              return i(C, w, k);
            default:
              return C;
          }
        }), [v, s.stringify(v, y)];
      }
      function c(m) {
        return m.exception && (delete m.exception.description, m.exception.message = l(255, m.exception.message)), m.frames = u(m.frames, 1), m;
      }
      function h(m, v) {
        var y = m.data.body;
        if (y.trace_chain) for (var w = y.trace_chain, E = 0; E < w.length; E++) w[E] = c(w[E]);
        else y.trace && (y.trace = c(y.trace));
        return [m, s.stringify(m, v)];
      }
      function b(m, v) {
        return s.maxByteSize(m) > v;
      }
      o.exports = { truncate: function(m, v, y) {
        y = y === void 0 ? 524288 : y;
        for (var w, E, C, k = [d, a, g.bind(null, 1024), g.bind(null, 512), g.bind(null, 256), h]; w = k.shift(); ) if (m = (E = w(m, v))[0], (C = E[1]).error || !b(C.value, y)) return C;
        return C;
      }, raw: d, truncateFrames: a, truncateStrings: g, maybeTruncateValue: l };
    }, 702: (o, p, f) => {
      var s = f(420), i = {};
      function d(k, S) {
        return S === u(k);
      }
      function u(k) {
        var S = typeof k;
        return S !== "object" ? S : k ? k instanceof Error ? "error" : {}.toString.call(k).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
      }
      function a(k) {
        return d(k, "function");
      }
      function l(k) {
        var S = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), O = RegExp("^" + S + "$");
        return g(k) && O.test(k);
      }
      function g(k) {
        var S = typeof k;
        return k != null && (S == "object" || S == "function");
      }
      function c() {
        var k = C();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(S) {
          var O = (k + 16 * Math.random()) % 16 | 0;
          return k = Math.floor(k / 16), (S === "x" ? O : 7 & O | 8).toString(16);
        });
      }
      var h = { strictMode: !1, key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"], q: { name: "queryKey", parser: /(?:^|&)([^&=]*)=?([^&]*)/g }, parser: { strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/, loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ } };
      function b(k, S) {
        var O, T;
        try {
          O = i.stringify(k);
        } catch (x) {
          if (S && a(S)) try {
            O = S(k);
          } catch (I) {
            T = I;
          }
          else T = x;
        }
        return { error: T, value: O };
      }
      function m(k, S) {
        return function(O, T) {
          try {
            S(O, T);
          } catch (x) {
            k.error(x);
          }
        };
      }
      function v(k) {
        return function S(O, T) {
          var x, I, R, N = {};
          try {
            for (I in O) (x = O[I]) && (d(x, "object") || d(x, "array")) ? T.includes(x) ? N[I] = "Removed circular reference: " + u(x) : ((R = T.slice()).push(x), N[I] = S(x, R)) : N[I] = x;
          } catch (D) {
            N = "Failed cloning custom data: " + D.message;
          }
          return N;
        }(k, [k]);
      }
      var y = ["log", "network", "dom", "navigation", "error", "manual"], w = ["critical", "error", "warning", "info", "debug"];
      function E(k, S) {
        for (var O = 0; O < k.length; ++O) if (k[O] === S) return !0;
        return !1;
      }
      function C() {
        return Date.now ? +Date.now() : +/* @__PURE__ */ new Date();
      }
      o.exports = { addParamsAndAccessTokenToPath: function(k, S, O) {
        (O = O || {}).access_token = k;
        var T, x = [];
        for (T in O) Object.prototype.hasOwnProperty.call(O, T) && x.push([T, O[T]].join("="));
        var I = "?" + x.sort().join("&");
        (S = S || {}).path = S.path || "";
        var R, N = S.path.indexOf("?"), D = S.path.indexOf("#");
        N !== -1 && (D === -1 || D > N) ? (R = S.path, S.path = R.substring(0, N) + I + "&" + R.substring(N + 1)) : D !== -1 ? (R = S.path, S.path = R.substring(0, D) + I + R.substring(D)) : S.path = S.path + I;
      }, createItem: function(k, S, O, T, x) {
        for (var I, R, N, D, A, L, q = [], te = [], Ee = 0, Pe = k.length; Ee < Pe; ++Ee) {
          var Ie = u(L = k[Ee]);
          switch (te.push(Ie), Ie) {
            case "undefined":
              break;
            case "string":
              I ? q.push(L) : I = L;
              break;
            case "function":
              D = m(S, L);
              break;
            case "date":
              q.push(L);
              break;
            case "error":
            case "domexception":
            case "exception":
              R ? q.push(L) : R = L;
              break;
            case "object":
            case "array":
              if (L instanceof Error || typeof DOMException < "u" && L instanceof DOMException) {
                R ? q.push(L) : R = L;
                break;
              }
              if (T && Ie === "object" && !A) {
                for (var ce = 0, bt = T.length; ce < bt; ++ce) if (L[T[ce]] !== void 0) {
                  A = L;
                  break;
                }
                if (A) break;
              }
              N ? q.push(L) : N = L;
              break;
            default:
              if (L instanceof Error || typeof DOMException < "u" && L instanceof DOMException) {
                R ? q.push(L) : R = L;
                break;
              }
              q.push(L);
          }
        }
        N && (N = v(N)), q.length > 0 && (N || (N = v({})), N.extraArgs = v(q));
        var be = { message: I, err: R, custom: N, timestamp: C(), callback: D, notifier: O, diagnostic: {}, uuid: c() };
        return function(wt, re) {
          re && re.level !== void 0 && (wt.level = re.level, delete re.level), re && re.skipFrames !== void 0 && (wt.skipFrames = re.skipFrames, delete re.skipFrames);
        }(be, N), T && A && (be.request = A), x && (be.lambdaContext = x), be._originalArgs = k, be.diagnostic.original_arg_types = te, be;
      }, addErrorContext: function(k, S) {
        var O = k.data.custom || {}, T = !1;
        try {
          for (var x = 0; x < S.length; ++x) S[x].hasOwnProperty("rollbarContext") && (O = s(O, v(S[x].rollbarContext)), T = !0);
          T && (k.data.custom = O);
        } catch (I) {
          k.diagnostic.error_context = "Failed: " + I.message;
        }
      }, createTelemetryEvent: function(k) {
        for (var S, O, T, x, I = 0, R = k.length; I < R; ++I) switch (u(x = k[I])) {
          case "string":
            !S && E(y, x) ? S = x : !T && E(w, x) && (T = x);
            break;
          case "object":
            O = x;
        }
        return { type: S || "manual", metadata: O || {}, level: T };
      }, filterIp: function(k, S) {
        if (k && k.user_ip && S !== !0) {
          var O = k.user_ip;
          if (S) try {
            var T;
            if (O.indexOf(".") !== -1) (T = O.split(".")).pop(), T.push("0"), O = T.join(".");
            else if (O.indexOf(":") !== -1) {
              if ((T = O.split(":")).length > 2) {
                var x = T.slice(0, 3), I = x[2].indexOf("/");
                I !== -1 && (x[2] = x[2].substring(0, I)), O = x.concat("0000:0000:0000:0000:0000").join(":");
              }
            } else O = null;
          } catch {
            O = null;
          }
          else O = null;
          k.user_ip = O;
        }
      }, formatArgsAsString: function(k) {
        var S, O, T, x = [];
        for (S = 0, O = k.length; S < O; ++S) {
          switch (u(T = k[S])) {
            case "object":
              (T = (T = b(T)).error || T.value).length > 500 && (T = T.substr(0, 497) + "...");
              break;
            case "null":
              T = "null";
              break;
            case "undefined":
              T = "undefined";
              break;
            case "symbol":
              T = T.toString();
          }
          x.push(T);
        }
        return x.join(" ");
      }, formatUrl: function(k, S) {
        if (!(S = S || k.protocol) && k.port && (k.port === 80 ? S = "http:" : k.port === 443 && (S = "https:")), S = S || "https:", !k.hostname) return null;
        var O = S + "//" + k.hostname;
        return k.port && (O = O + ":" + k.port), k.path && (O += k.path), O;
      }, get: function(k, S) {
        if (k) {
          var O = S.split("."), T = k;
          try {
            for (var x = 0, I = O.length; x < I; ++x) T = T[O[x]];
          } catch {
            T = void 0;
          }
          return T;
        }
      }, handleOptions: function(k, S, O, T) {
        var x = s(k, S, O);
        return x = function(I, R) {
          return I.hostWhiteList && !I.hostSafeList && (I.hostSafeList = I.hostWhiteList, I.hostWhiteList = void 0, R && R.log("hostWhiteList is deprecated. Use hostSafeList.")), I.hostBlackList && !I.hostBlockList && (I.hostBlockList = I.hostBlackList, I.hostBlackList = void 0, R && R.log("hostBlackList is deprecated. Use hostBlockList.")), I;
        }(x, T), !S || S.overwriteScrubFields || S.scrubFields && (x.scrubFields = (k.scrubFields || []).concat(S.scrubFields)), x;
      }, isError: function(k) {
        return d(k, "error") || d(k, "exception");
      }, isFiniteNumber: function(k) {
        return Number.isFinite(k);
      }, isFunction: a, isIterable: function(k) {
        var S = u(k);
        return S === "object" || S === "array";
      }, isNativeFunction: l, isObject: g, isString: function(k) {
        return typeof k == "string" || k instanceof String;
      }, isType: d, isPromise: function(k) {
        return g(k) && d(k.then, "function");
      }, jsonParse: function(k) {
        var S, O;
        try {
          S = i.parse(k);
        } catch (T) {
          O = T;
        }
        return { error: O, value: S };
      }, LEVELS: { debug: 0, info: 1, warning: 2, error: 3, critical: 4 }, makeUnhandledStackInfo: function(k, S, O, T, x, I, R, N) {
        var D = { url: S || "", line: O, column: T };
        D.func = N.guessFunctionName(D.url, D.line), D.context = N.gatherContext(D.url, D.line);
        var A = typeof document < "u" && document && document.location && document.location.href, L = typeof window < "u" && window && window.navigator && window.navigator.userAgent;
        return { mode: I, message: x ? String(x) : k || R, url: A, stack: [D], useragent: L };
      }, merge: s, now: C, redact: function() {
        return "********";
      }, RollbarJSON: i, sanitizeUrl: function(k) {
        var S = function(O) {
          if (d(O, "string")) {
            for (var T = h, x = T.parser[T.strictMode ? "strict" : "loose"].exec(O), I = {}, R = 0, N = T.key.length; R < N; ++R) I[T.key[R]] = x[R] || "";
            return I[T.q.name] = {}, I[T.key[12]].replace(T.q.parser, function(D, A, L) {
              A && (I[T.q.name][A] = L);
            }), I;
          }
        }(k);
        return S ? (S.anchor === "" && (S.source = S.source.replace("#", "")), k = S.source.replace("?" + S.query, "")) : "(unknown)";
      }, set: function(k, S, O) {
        if (k) {
          var T = S.split("."), x = T.length;
          if (!(x < 1)) if (x !== 1) try {
            for (var I = k[T[0]] || {}, R = I, N = 1; N < x - 1; ++N) I[T[N]] = I[T[N]] || {}, I = I[T[N]];
            I[T[x - 1]] = O, k[T[0]] = R;
          } catch {
            return;
          }
          else k[T[0]] = O;
        }
      }, setupJSON: function(k) {
        a(i.stringify) && a(i.parse) || (d(JSON, "undefined") || (k ? (l(JSON.stringify) && (i.stringify = JSON.stringify), l(JSON.parse) && (i.parse = JSON.parse)) : (a(JSON.stringify) && (i.stringify = JSON.stringify), a(JSON.parse) && (i.parse = JSON.parse))), a(i.stringify) && a(i.parse) || k && k(i));
      }, stringify: b, maxByteSize: function(k) {
        for (var S = 0, O = k.length, T = 0; T < O; T++) {
          var x = k.charCodeAt(T);
          x < 128 ? S += 1 : x < 2048 ? S += 2 : x < 65536 && (S += 3);
        }
        return S;
      }, typeName: u, uuid4: c };
    }, 650: (o) => {
      function p(s) {
        return typeof s != "string" && (s = String(s)), s.toLowerCase();
      }
      function f(s) {
        this.map = {}, s instanceof f ? s.forEach(function(i, d) {
          this.append(d, i);
        }, this) : Array.isArray(s) ? s.forEach(function(i) {
          this.append(i[0], i[1]);
        }, this) : s && Object.getOwnPropertyNames(s).forEach(function(i) {
          this.append(i, s[i]);
        }, this);
      }
      f.prototype.append = function(s, i) {
        s = p(s), i = function(u) {
          return typeof u != "string" && (u = String(u)), u;
        }(i);
        var d = this.map[s];
        this.map[s] = d ? d + ", " + i : i;
      }, f.prototype.get = function(s) {
        return s = p(s), this.has(s) ? this.map[s] : null;
      }, f.prototype.has = function(s) {
        return this.map.hasOwnProperty(p(s));
      }, f.prototype.forEach = function(s, i) {
        for (var d in this.map) this.map.hasOwnProperty(d) && s.call(i, this.map[d], d, this);
      }, f.prototype.entries = function() {
        var s = [];
        return this.forEach(function(i, d) {
          s.push([d, i]);
        }), /* @__PURE__ */ function(i) {
          return { next: function() {
            var d = i.shift();
            return { done: d === void 0, value: d };
          } };
        }(s);
      }, o.exports = function(s) {
        return typeof Headers > "u" ? new f(s) : new Headers(s);
      };
    }, 876: (o, p, f) => {
      var s = f(708);
      o.exports = s;
    }, 297: (o) => {
      o.exports = function(p, f, s, i, d) {
        var u = p[f];
        p[f] = s(u), i && i[d].push([p, f, u]);
      };
    }, 267: (o, p, f) => {
      var s = f(702);
      o.exports = function(i, d, u) {
        var a, l, g, c, h = s.isType(i, "object"), b = s.isType(i, "array"), m = [];
        if (u = u || { obj: [], mapped: [] }, h) {
          if (c = u.obj.indexOf(i), h && c !== -1) return u.mapped[c] || u.obj[c];
          u.obj.push(i), c = u.obj.length - 1;
        }
        if (h) for (a in i) Object.prototype.hasOwnProperty.call(i, a) && m.push(a);
        else if (b) for (g = 0; g < i.length; ++g) m.push(g);
        var v = h ? {} : [], y = !0;
        for (g = 0; g < m.length; ++g) l = i[a = m[g]], v[a] = d(a, l, u), y = y && v[a] === i[a];
        return h && !y && (u.mapped[c] = v), y ? i : v;
      };
    }, 708: (o) => {
      o.exports = function(p) {
        var f, s, i, d, u, a, l, g, c, h, b, m, v, y = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        function w(S) {
          return S < 10 ? "0" + S : S;
        }
        function E() {
          return this.valueOf();
        }
        function C(S) {
          return y.lastIndex = 0, y.test(S) ? '"' + S.replace(y, function(O) {
            var T = i[O];
            return typeof T == "string" ? T : "\\u" + ("0000" + O.charCodeAt(0).toString(16)).slice(-4);
          }) + '"' : '"' + S + '"';
        }
        function k(S, O) {
          var T, x, I, R, N, D = f, A = O[S];
          switch (A && typeof A == "object" && typeof A.toJSON == "function" && (A = A.toJSON(S)), typeof d == "function" && (A = d.call(O, S, A)), typeof A) {
            case "string":
              return C(A);
            case "number":
              return isFinite(A) ? String(A) : "null";
            case "boolean":
            case "null":
              return String(A);
            case "object":
              if (!A) return "null";
              if (f += s, N = [], Object.prototype.toString.apply(A) === "[object Array]") {
                for (R = A.length, T = 0; T < R; T += 1) N[T] = k(T, A) || "null";
                return I = N.length === 0 ? "[]" : f ? `[
` + f + N.join(`,
` + f) + `
` + D + "]" : "[" + N.join(",") + "]", f = D, I;
              }
              if (d && typeof d == "object") for (R = d.length, T = 0; T < R; T += 1) typeof d[T] == "string" && (I = k(x = d[T], A)) && N.push(C(x) + (f ? ": " : ":") + I);
              else for (x in A) Object.prototype.hasOwnProperty.call(A, x) && (I = k(x, A)) && N.push(C(x) + (f ? ": " : ":") + I);
              return I = N.length === 0 ? "{}" : f ? `{
` + f + N.join(`,
` + f) + `
` + D + "}" : "{" + N.join(",") + "}", f = D, I;
          }
        }
        typeof Date.prototype.toJSON != "function" && (Date.prototype.toJSON = function() {
          return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + w(this.getUTCMonth() + 1) + "-" + w(this.getUTCDate()) + "T" + w(this.getUTCHours()) + ":" + w(this.getUTCMinutes()) + ":" + w(this.getUTCSeconds()) + "Z" : null;
        }, Boolean.prototype.toJSON = E, Number.prototype.toJSON = E, String.prototype.toJSON = E), typeof p.stringify != "function" && (i = { "\b": "\\b", "	": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" }, p.stringify = function(S, O, T) {
          var x;
          if (f = "", s = "", typeof T == "number") for (x = 0; x < T; x += 1) s += " ";
          else typeof T == "string" && (s = T);
          if (d = O, O && typeof O != "function" && (typeof O != "object" || typeof O.length != "number")) throw new Error("JSON.stringify");
          return k("", { "": S });
        }), typeof p.parse != "function" && (p.parse = (h = { "\\": "\\", '"': '"', "/": "/", t: "	", n: `
`, r: "\r", f: "\f", b: "\b" }, b = { go: function() {
          u = "ok";
        }, firstokey: function() {
          g = c, u = "colon";
        }, okey: function() {
          g = c, u = "colon";
        }, ovalue: function() {
          u = "ocomma";
        }, firstavalue: function() {
          u = "acomma";
        }, avalue: function() {
          u = "acomma";
        } }, m = { go: function() {
          u = "ok";
        }, ovalue: function() {
          u = "ocomma";
        }, firstavalue: function() {
          u = "acomma";
        }, avalue: function() {
          u = "acomma";
        } }, v = { "{": { go: function() {
          a.push({ state: "ok" }), l = {}, u = "firstokey";
        }, ovalue: function() {
          a.push({ container: l, state: "ocomma", key: g }), l = {}, u = "firstokey";
        }, firstavalue: function() {
          a.push({ container: l, state: "acomma" }), l = {}, u = "firstokey";
        }, avalue: function() {
          a.push({ container: l, state: "acomma" }), l = {}, u = "firstokey";
        } }, "}": { firstokey: function() {
          var S = a.pop();
          c = l, l = S.container, g = S.key, u = S.state;
        }, ocomma: function() {
          var S = a.pop();
          l[g] = c, c = l, l = S.container, g = S.key, u = S.state;
        } }, "[": { go: function() {
          a.push({ state: "ok" }), l = [], u = "firstavalue";
        }, ovalue: function() {
          a.push({ container: l, state: "ocomma", key: g }), l = [], u = "firstavalue";
        }, firstavalue: function() {
          a.push({ container: l, state: "acomma" }), l = [], u = "firstavalue";
        }, avalue: function() {
          a.push({ container: l, state: "acomma" }), l = [], u = "firstavalue";
        } }, "]": { firstavalue: function() {
          var S = a.pop();
          c = l, l = S.container, g = S.key, u = S.state;
        }, acomma: function() {
          var S = a.pop();
          l.push(c), c = l, l = S.container, g = S.key, u = S.state;
        } }, ":": { colon: function() {
          if (Object.hasOwnProperty.call(l, g)) throw new SyntaxError("Duplicate key '" + g + '"');
          u = "ovalue";
        } }, ",": { ocomma: function() {
          l[g] = c, u = "okey";
        }, acomma: function() {
          l.push(c), u = "avalue";
        } }, true: { go: function() {
          c = !0, u = "ok";
        }, ovalue: function() {
          c = !0, u = "ocomma";
        }, firstavalue: function() {
          c = !0, u = "acomma";
        }, avalue: function() {
          c = !0, u = "acomma";
        } }, false: { go: function() {
          c = !1, u = "ok";
        }, ovalue: function() {
          c = !1, u = "ocomma";
        }, firstavalue: function() {
          c = !1, u = "acomma";
        }, avalue: function() {
          c = !1, u = "acomma";
        } }, null: { go: function() {
          c = null, u = "ok";
        }, ovalue: function() {
          c = null, u = "ocomma";
        }, firstavalue: function() {
          c = null, u = "acomma";
        }, avalue: function() {
          c = null, u = "acomma";
        } } }, function(S, O) {
          var T, x, I = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
          u = "go", a = [];
          try {
            for (; T = I.exec(S); ) T[1] ? v[T[1]][u]() : T[2] ? (c = +T[2], m[u]()) : (x = T[3], c = x.replace(/\\(?:u(.{4})|([^u]))/g, function(R, N, D) {
              return N ? String.fromCharCode(parseInt(N, 16)) : h[D];
            }), b[u]()), S = S.slice(T[0].length);
          } catch (R) {
            u = R;
          }
          if (u !== "ok" || /[^\u0020\t\n\r]/.test(S)) throw u instanceof SyntaxError ? u : new SyntaxError("JSON");
          return typeof O == "function" ? function R(N, D) {
            var A, L, q = N[D];
            if (q && typeof q == "object") for (A in c) Object.prototype.hasOwnProperty.call(q, A) && ((L = R(q, A)) !== void 0 ? q[A] = L : delete q[A]);
            return O.call(N, D, q);
          }({ "": c }, "") : c;
        }));
      };
    } }, n = {}, function o(p) {
      var f = n[p];
      if (f !== void 0) return f.exports;
      var s = n[p] = { exports: {} };
      return r[p].call(s.exports, s, s.exports, o), s.exports;
    }(409);
    var r, n;
  });
})(Zn);
var _s = Zn.exports;
const ys = /* @__PURE__ */ gs(_s), vs = {
  email: "error.tracker@increase.app"
}, Ht = /* @__PURE__ */ He.createContext(null);
function ei({
  children: e,
  ...t
}) {
  const r = ze(), n = Re(), [o, p] = ke(null), [f, s] = ke(!1), i = t.enabled === !0 && process.env.NODE_ENV === "production";
  return Me(() => {
    !i || o !== null || p(new ys({
      accessToken: t.rollbarToken,
      environment: n.environment,
      captureUncaught: !0,
      captureUnhandledRejections: !0
    }));
  }, [t, o, i, n.environment]), Me(() => {
    function d() {
      return t.public ? vs : r.state === ue.Unauthenticated ? (s(!0), null) : r.state === ue.Unknown ? null : r.user;
    }
    if (o === null)
      return;
    const u = d();
    !u || !u.email || (o.configure({
      payload: {
        person: {
          id: u.email,
          username: u.email,
          email: u.email
        }
      }
    }), s(!0));
  }, [r, o, i, t.public]), i ? !t.public && r.state === ue.Unknown || o === null || !f ? null : /* @__PURE__ */ W(Ht.Provider, { value: o, children: e }) : /* @__PURE__ */ W(Ht.Provider, { value: null, children: e });
}
const bs = {
  setOnTopNotification: () => {
  }
}, ti = /* @__PURE__ */ He.createContext(bs);
function ws({
  children: e
}) {
  const [t, r] = ke(void 0), n = tn(() => ({
    onTopNotification: t,
    setOnTopNotification: r
  }), [t, r]);
  return /* @__PURE__ */ W(ti.Provider, { value: n, children: e });
}
function Cr() {
  const e = ze();
  return e.state !== ue.Authenticated ? null : e.user;
}
const ri = [], ni = /* @__PURE__ */ He.createContext(ri);
function Ss({
  children: e
}) {
  const [t, r] = ke(ri), n = Cr(), o = Re();
  return Me(() => {
    if (!n || !n.productAuthorizations) return;
    const p = n.productAuthorizations.find((f) => f.product === o.productName);
    if (!p) {
      console.warn(`Can't find authorizations for product ${o.productName}`);
      return;
    }
    r(p.authorizations);
  }, [o.productName, n]), /* @__PURE__ */ W(ni.Provider, { value: t, children: e });
}
function ks() {
  const e = Wt(), t = Re(), r = Cr(), [n, o] = ke(!r?.termsAndConditionsAcceptedAt);
  return /* @__PURE__ */ Qe(oi, { simple: !0, visible: n, onClose: () => {
  }, onCancel: () => {
    o(!1), window.location.href = `${t.authUrl}/logout`;
  }, onOk: () => {
    r && (e.updateUser(r.id, {
      first_name: r.firstName,
      last_name: r.lastName,
      phone_number: r.phone,
      terms_and_conditions_accepted_at: /* @__PURE__ */ new Date()
    }), o(!1));
  }, hideCloseButton: !0, headerText: "Actualizamos nuestros términos y condiciones.", okLabel: "Aceptar y continuar", cancelLabel: "Salir", children: [
    /* @__PURE__ */ Qe(Tr, { children: [
      "Es necesario que los aceptes para que puedas seguir utilizando los canales digitales. Te invitamos a conocerlos haciendo click",
      " ",
      /* @__PURE__ */ W(si, { href: "https://increase.app/terminos-y-condiciones", children: "acá" }),
      "."
    ] }),
    /* @__PURE__ */ W(Tr, { children: "Al salir se finalizará tu sesión." })
  ] });
}
function Xs({
  children: e,
  settings: t
}) {
  return /* @__PURE__ */ W(an, { environment: t.environment, productName: t.productName, children: /* @__PURE__ */ W(bi, { children: /* @__PURE__ */ W(Ss, { children: /* @__PURE__ */ W(ei, { ...t.errorTracking, children: /* @__PURE__ */ W(hs, { ...t.eventTracking, children: /* @__PURE__ */ W(wi, { children: /* @__PURE__ */ Qe(ws, { children: [
    e,
    /* @__PURE__ */ W(ks, {})
  ] }) }) }) }) }) }) });
}
function Ys({
  children: e,
  settings: t
}) {
  return /* @__PURE__ */ W(an, { environment: t.environment, productName: t.productName, children: /* @__PURE__ */ W(ei, { ...t.errorTracking, children: e }) });
}
function xs() {
  const e = We(ni);
  return {
    productAuthorizations: e,
    userHasAuthorization: (t) => e ? e.includes(t) : !1
  };
}
const Es = /* @__PURE__ */ W(ai, { children: "Ups! Parece que no tienes permiso para ver esta sección. Comúnicate con el administrador de tu cuenta." }), Ks = ({
  children: e,
  allowedAuthorizations: t,
  renderNoAccess: r
}) => {
  const {
    productAuthorizations: n
  } = xs();
  return n && n.length > 0 && t.some((p) => n.includes(p)) ? /* @__PURE__ */ W(en, { children: e }) : r || Es;
};
function Is() {
  return We(dn);
}
const Cs = () => {
  const e = Wt();
  return rn(async (r) => {
    const n = r;
    if (n.acquire_behaviour === "uri_acquire") {
      n.acquire_uri && (window.location.href = n.acquire_uri);
      return;
    }
    await e.createSubscription(n.name).then(() => {
      window.location.href = n.uri;
    });
  }, [e]);
};
function Os() {
  const e = Is();
  return e.state !== ln.Success ? null : e.products;
}
var Ts = process.env.NODE_ENV === "production";
function Ms(e, t) {
  if (!Ts) {
    if (e)
      return;
    var r = "Warning: " + t;
    typeof console < "u" && console.warn(r);
    try {
      throw Error(r);
    } catch {
    }
  }
}
const Ns = {
  sidebarLinks: {
    moreProducts: "Más productos",
    settings: "Ajustes",
    community: "Comunidad"
  },
  secondLevelLinks: {
    helpCenter: "Centro de ayuda",
    helpCenterDescription: "Autogestión de dudas"
  },
  profileLinks: {
    support: "Portal de Ayuda",
    community: "Comunidad",
    contact: "Contacto",
    whatsapp: "Contacto por WhatsApp"
  }
};
function Or(e) {
  return function(t) {
    const r = Ns[e][t];
    return Ms(!!r, `Translation missing for key ${e}:${t}.`), r || t;
  };
}
const Rs = (e, t = Or("profileLinks")) => [{
  label: t("support"),
  url: e.supportUrl,
  blank: !0
}, {
  label: t("contact"),
  url: e.contactUrl,
  blank: !0
}], As = (e, t = Or("secondLevelLinks")) => [{
  logo: /* @__PURE__ */ W(di, {}),
  name: t("helpCenter"),
  text: t("helpCenterDescription"),
  url: e.supportUrl
}], Ds = (e, t = Or("sidebarLinks")) => [];
function Xt() {
  const e = ze();
  return e.state !== ue.Authenticated ? null : e.user.defaultCountry || "argentina";
}
const Ls = /* @__PURE__ */ nn.div.withConfig({
  displayName: "ErrorScreen__Wrapper",
  componentId: "sc-1sxa6i3-0"
})(["min-height:calc(100vh - 112px);display:flex;flex-direction:column;align-items:center;text-align:center;.title{margin:40px auto;}.description{margin-bottom:40px;}svg{fill:var(--color-primaryAction-regular);}"]);
function Ps(e) {
  return `${e.charAt(0).toUpperCase()}${e.slice(1)}`;
}
function Us() {
  const e = Re(), t = Ps(e.productName);
  return /* @__PURE__ */ Qe(Ls, { children: [
    /* @__PURE__ */ W(fi, { height: "96", width: "96" }),
    /* @__PURE__ */ W(Mr, { className: "title", children: "¡Ups! No pudimos completar la acción solicitada" }),
    /* @__PURE__ */ Qe(Mr, { className: "description", weight: "normal", children: [
      "Vuelve a intentarlo en unos minutos.",
      /* @__PURE__ */ W("br", {}),
      "Si el error persiste, contáctanos."
    ] }),
    /* @__PURE__ */ Qe(ui, { as: "a", href: "/", children: [
      "Volver a ",
      t
    ] })
  ] });
}
class qs extends ii {
  static {
    this.contextType = Ht;
  }
  // eslint-disable-next-line react/sort-comp
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(t, r) {
    const n = this.context;
    n !== null && n.error(t, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ W(Us, {}) : this.props.children;
  }
}
function Fs() {
  return We(ti);
}
const js = /* @__PURE__ */ nn.div.withConfig({
  displayName: "Layout__SpinnerWrapper",
  componentId: "sc-647z22-0"
})(["height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;"]);
function Qs({
  children: e,
  ...t
}) {
  const r = ze({
    requireAuth: !0
  }), n = Re(), o = Os(), p = Xt(), f = Cs(), {
    onTopNotification: s,
    setOnTopNotification: i
  } = Fs();
  if (r.state !== ue.Authenticated || o === null)
    return /* @__PURE__ */ W(js, { children: /* @__PURE__ */ W(ci, { size: 64 }) });
  const d = r.user;
  return /* @__PURE__ */ W(li, { ...t, userName: d.name(), products: {
    all: o.filter(({
      acquire_behaviour: u
    }) => u !== "hidden"),
    current: n.productName,
    active: d.activeProducts()
  }, onProductAcquire: f, onTopNotification: s ? {
    ...s,
    onClose: () => i(void 0)
  } : void 0, country: p, urls: {
    auth: n.authUrl,
    platform: n.platformUrl,
    platformApi: `${n.gatewayUrl}/platform`,
    landing: n.landingUrl
  }, links: {
    profile: Rs(n),
    secondLevel: As(n),
    sidebar: Ds()
  }, children: /* @__PURE__ */ W(qs, { children: e }) });
}
function Bs() {
  const e = ze(), t = Xt();
  if (e.state !== ue.Authenticated) return null;
  switch (t) {
    case "argentina":
      return "ARS";
    case "chile":
      return "CLP";
    case "colombia":
      return "COP";
    case "dominicana":
      return "DOP";
    case "ecuador":
      return "USD";
    case "paraguay":
      return "PYG";
    case "uruguay":
      return "UYU";
    case "peru":
      return "PEN";
    case "costa_rica":
      return "CRC";
    case "panama":
      return "PAB";
    default:
      return null;
  }
}
function $s() {
  const e = ze(), t = Xt();
  if (e.state !== ue.Authenticated) return null;
  switch (t || "argentina") {
    case "argentina":
      return "es-AR";
    case "chile":
      return "es-CL";
    case "colombia":
      return "es-CO";
    case "dominicana":
      return "es-DO";
    case "ecuador":
      return "es-EC";
    case "paraguay":
      return "es-PY";
    case "uruguay":
      return "es-UY";
    case "peru":
      return "es-PE";
    case "costa_rica":
      return "es-CR";
    case "panama":
      return "es-PA";
    default:
      return "es-AR";
  }
}
function Zs({
  currency: e = void 0,
  value: t
}) {
  const r = Bs(), n = $s();
  return /* @__PURE__ */ W(pi, { currency: e || r, language: n || void 0, value: t });
}
const ea = ({
  children: e,
  hideFor: t,
  showIn: r
}) => {
  const n = Xt();
  return t && t.includes(n) || r && !r.includes(n) ? null : /* @__PURE__ */ W(en, { children: e });
};
function ta() {
  return We(Qn);
}
function ra() {
  return We(Ht);
}
const Ct = (e) => Math.round(new Date(e).getTime() / 1e3), Ot = (e) => e || null, Hs = (e, t) => {
  const r = e.subscriptions.find((o) => o.product.name === t);
  return {
    email: e.email,
    first_name: e.firstName,
    last_name: e.lastName,
    created_at: Ct(e.createdAt.toISOString()),
    country: e.defaultCountry,
    enterprise: e.account.enterprise,
    subscription_state: Ot(r?.state),
    partner_id: Ot(r?.partner),
    contact_center_id: Ot(r?.contact_center_id),
    product_id: t === "platform" ? "platform" : Ot(r?.product.id),
    subscription_created_at: r?.created_at ? Ct(r.created_at) : null,
    initial_billing: r?.initial_billing ? Ct(r.initial_billing) : null,
    employee_count: e.account.employee_count,
    last_entered: Ct((/* @__PURE__ */ new Date()).toISOString()),
    masquerading: e.isMasquerading,
    "Impersonator Email": e.isMasquerading ? e.realUserEmail : void 0
  };
};
function na(e, t, r) {
  const n = Cr(), [o, p] = ke(!1), f = window.Appcues, s = rn(() => {
    if (!f || !n)
      return;
    const d = {
      ...Hs(n, e),
      ...r
    };
    f.identify(n.id, d), p(!0);
  }, [f, n, e, r]);
  Me(() => {
    f && (o ? f.page() : s());
  }, [t, n, s, f]);
}
export {
  Ks as AccessControl,
  ue as AuthStates,
  Xs as BaseProvider,
  mi as COUNTRIES,
  ea as CountryFilter,
  Zs as Currency,
  qs as ErrorBoundary,
  Qs as Layout,
  ln as ProductsStateStates,
  Ys as PublicBaseProvider,
  _i as User,
  na as useAppcues,
  ze as useAuth,
  Re as useConfig,
  Xt as useCountry,
  Bs as useCurrency,
  ra as useErrorTracker,
  ta as useEventTracker,
  $s as useLocale,
  Cs as useOnAcquire,
  Fs as useOnTopNotification,
  Wt as usePlatformAPI,
  xs as useProductAuthorizations,
  Os as useProducts,
  Is as useProductsState,
  Cr as useUser,
  yi as userMapper
};
